import { V as VRow, a as VCol, n as normalizeComponent, b as VDivider, c as VBtn, d as VIcon, e as VMenu, f as VSlideXReverseTransition, g as VSheet, h as VCardText, i as VCard, j as VAlert, k as VCardActions, l as VCardTitle, m as VExpandTransition, o as VDialog, p as VHover, q as VStepper, r as VStepperHeader, s as VStepperStep, t as VContainer, u as VLabel, v as VTextField, w as VDataTable, x as VPagination, y as VFooter, z as VList, A as VListItem, B as VListItemContent, C as VListItemTitle, D as VSlideYTransition, E as VNavigationDrawer, F as VListItemIcon, G as VApp, H as VMain, I as VProgressCircular, J as VTextarea, K as VDatePicker, L as VCheckbox, M as VListItemAction, N as Vuetify, O as vuetifyOptions } from './phoenix.esm.vuetify.js';
import { defineComponent, getCurrentInstance, computed, reactive, ref, watch, watchEffect, onMounted, provide, inject, onUnmounted, onBeforeUnmount, toRefs, isRef } from '@vue/composition-api';
import { __awaiter } from 'tslib';
import Vue$1 from 'vue';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var vueSmoothScroll_min = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){return function(t){var e={};function o(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,o),r.l=!0,r.exports}return o.m=t,o.c=e,o.d=function(t,e,n){o.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n});},o.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},o.t=function(t,e){if(1&e&&(t=o(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)o.d(n,r,function(e){return t[e]}.bind(null,r));return n},o.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return o.d(e,"a",e),e},o.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},o.p="",o(o.s=0)}([function(t,e,o){function n(t){return (n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}var r;o.r(e);var i=function(t,e){return "HTML"===t.nodeName?-e:t.getBoundingClientRect().top+e};function u(){return {duration:500,offset:0,container:window,updateHistory:!0}}var c=Symbol("smoothScrollCtx");function f(t){var e=t.scrollTo,o=t.offset,n=t.duration,u=t.container,c=t.updateHistory,f=t.hash;r||(r=window.requestAnimationFrame||function(t){window.setTimeout(t,16);}),c&&window.history.pushState&&location.hash!==f&&window.history.pushState("","",f);var a=u.scrollTop||window.pageYOffset,l=i(e,a);l+=o;var d=Date.now();!function t(){var o,i=Date.now()-d,f=l;i<n?(f=a+(l-a)*((o=i/n)<.5?4*o*o*o:(o-1)*(2*o-2)*(2*o-2)+1),r(t)):c&&location.replace("#"+e.id),u===window?u.scrollTo(0,f):u.scrollTop=f;}();}var a={install:function(t,e){t.directive("smooth-scroll",{inserted:function(t,o,r){if("object"===("undefined"==typeof window?"undefined":n(window))&&void 0!==window.pageYOffset){var i=Object.assign({},u());e&&Object.assign(i,e);var a=o.value||{},l=a.duration,d=a.offset,s=a.container,p=a.updateHistory;l=l||i.duration,d=d||i.offset,s=s||i.container,p=void 0!==p?p:i.updateHistory,"string"==typeof s&&(s=document.querySelector(s));var y=function(t){t.preventDefault();var e=r.data.attrs.href,o=document.getElementById(e.substring(1));o&&f({scrollTo:o,offset:d,duration:l,container:s,updateHistory:p,hash:e});};t.addEventListener("click",y),t[c]={clickHandler:y};}},unbind:function(t){t.removeEventListener("click",t[c].clickHandler),t[c]=null;}}),t.prototype.$smoothScroll=function(t){return f(Object.assign({},u(),e,t))};}};e.default=a,"undefined"!=typeof window&&window.Vue&&window.Vue.use(a);}])}));
});

var vueSmoothScroll = /*@__PURE__*/getDefaultExportFromCjs(vueSmoothScroll_min);

//

var script$1i = defineComponent({
  name: 'FormRow',
  components: { VRow, VCol },
});

/* script */
const __vue_script__$1i = script$1i;
/* template */
var __vue_render__$1k = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"form-row"},[_c('v-col',[_vm._t("default")],2)],1)};
var __vue_staticRenderFns__$1k = [];

  /* style */
  const __vue_inject_styles__$1k = undefined;
  /* scoped */
  const __vue_scope_id__$1k = "data-v-3c08e6dd";
  /* module identifier */
  const __vue_module_identifier__$1k = undefined;
  /* functional template */
  const __vue_is_functional_template__$1k = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1k = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1k, staticRenderFns: __vue_staticRenderFns__$1k },
    __vue_inject_styles__$1k,
    __vue_script__$1i,
    __vue_scope_id__$1k,
    __vue_is_functional_template__$1k,
    __vue_module_identifier__$1k,
    false,
    undefined,
    undefined,
    undefined
  );

var useHasSlot = (slots) => {
    return (name = 'default') => {
        return !!slots[name];
    };
};

function useBreakpoints () {
    const vm = getCurrentInstance();
    const breakpoint = vm.$vuetify.breakpoint;
    const isDesktopView = computed(() => {
        return breakpoint.mdAndUp;
    });
    const isTabletView = computed(() => {
        return breakpoint.sm;
    });
    const isMobileView = computed(() => {
        return breakpoint.xs;
    });
    const isMobileOrTabletView = computed(() => {
        return breakpoint.smAndDown;
    });
    return {
        breakpoint: vm.$vuetify.breakpoint,
        isDesktopView,
        isTabletView,
        isMobileView,
        isMobileOrTabletView,
    };
}

var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
    LogLevel[LogLevel["Error"] = 4] = "Error";
    LogLevel[LogLevel["None"] = 5] = "None";
})(LogLevel || (LogLevel = {}));
let logLevel = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test' ? LogLevel.Warning : LogLevel.Trace;
function setLogLevel(level) {
    logLevel = level;
}
function extractErrorMessage(e) {
    if (e) {
        if (typeof e === 'string') {
            return e;
        }
        if (typeof e.message === 'string') {
            return e.message;
        }
    }
    return `Unknown error: ${e}`;
}
function logTrace(message, ...optionalParms) {
    if (logLevel <= LogLevel.Trace) {
        window.console.log(message, ...optionalParms);
    }
}
function logDebug(message, ...optionalParms) {
    if (logLevel <= LogLevel.Debug) {
        window.console.log(message, ...optionalParms);
    }
}
function logInfo(message, ...optionalParms) {
    if (logLevel <= LogLevel.Info) {
        window.console.info(message, ...optionalParms);
    }
}
function logWarning(message, ...optionalParms) {
    if (logLevel <= LogLevel.Warning) {
        window.console.warn(extractErrorMessage(message), ...optionalParms);
    }
}
function logError(message, ...optionalParms) {
    if (logLevel <= LogLevel.Error) {
        window.console.error(extractErrorMessage(message), ...optionalParms);
    }
}
function errorNotInProd(message) {
    if (process.env.NODE_ENV !== 'production') {
        throw Error(message);
    }
    logWarning(message);
}
function toStringSave(arg) {
    try {
        if (arg instanceof Date) {
            return isNaN(arg.valueOf()) ? 'Invalid Date' : arg.toISOString();
        }
        return JSON.stringify(arg);
    }
    catch (err) {
        try {
            return arg.toString();
        }
        catch (_) {
            return `unknown ${typeof arg}`;
        }
    }
}

function tryTranslateRecursive(vm, key, values) {
    if (!vm) {
        return undefined;
    }
    if (vm.$te && vm.$t && vm.$te(key)) {
        return vm.$t(key, values);
    }
    return tryTranslateRecursive(vm.$parent, key, values);
}
function translateRecursive(vm, key, values) {
    const result = tryTranslateRecursive(vm, key, values);
    if (result !== undefined) {
        return result;
    }
    logWarning(`No translation found for "${key}"`);
    return key;
}
function useI18n (vue) {
    const vm = vue || getCurrentInstance();
    return {
        t: vm.$t.bind(vm),
        d: vm.$d.bind(vm),
        n: vm.$n.bind(vm),
        te: vm.$te.bind(vm),
        tc: vm.$tc.bind(vm),
        tRecursiveTry(key, values) {
            return tryTranslateRecursive(vm, key, values);
        },
        tRecursive(key, values) {
            return translateRecursive(vm, key, values);
        },
    };
}

function useWindowPrint() {
    const sendToPrinter = () => {
        window.print();
        return false;
    };
    return {
        sendToPrinter,
    };
}

class StepRouter {
    constructor(steps, routeParam) {
        this.steps = steps;
        this.routeParam = routeParam;
        this.vm = getCurrentInstance();
        this.routes = {
            name: this.vm.$route.name || '',
            params: this.vm.$route.params,
            steps,
        };
        if (!this.routes.name) {
            throw Error('useStepRouter expects a route name.');
        }
        if (!routeParam) {
            throw Error('useStepRouter expects a route params key.');
        }
        this.hasRoutes = !!this.routes.steps && this.routes.steps.length > 0;
    }
    toComposable() {
        return reactive({
            stepNumber: computed(() => this.getRouteIndex(this.vm.$route.params[this.routeParam]) + 1),
            navigate: (toStepNumber) => this.navigate(toStepNumber),
        });
    }
    getRouteIndex(route) {
        if (!this.hasRoutes || !route) {
            return -1;
        }
        return this.routes.steps.findIndex((r) => r.toLowerCase() === route.toLowerCase());
    }
    getLocation(stepRoute, routeName, routeParam) {
        const params = Object.assign({}, this.vm.$route.params);
        const query = this.vm.$route.query;
        params[routeParam] = stepRoute;
        return { name: routeName, params, query };
    }
    navigate(toStepNumber) {
        const index = toStepNumber - 1;
        if (index < 0 || index >= this.routes.steps.length) {
            return false;
        }
        const location = this.getLocation(this.routes.steps[index], this.routes.name, this.routeParam);
        this.vm.$router.push(location);
        return true;
    }
}
function useStepRouter(steps, routeParam) {
    return new StepRouter(steps, routeParam).toComposable();
}

let _routeLinkResolver;
function setupRouteLinkResolver(routeResolver) {
    _routeLinkResolver = routeResolver;
}
function resolveRouteLink(link) {
    if (typeof link === 'string') {
        link = { name: link };
    }
    if (!_routeLinkResolver) {
        return {
            name: link.name,
            to: { name: link.name, params: link.params },
        };
    }
    else {
        return _routeLinkResolver(link);
    }
}
function useRouteResolver(props) {
    const linkTo = computed(() => computeLinkTo(props));
    const linkHref = computed(() => computeLinkHref(props));
    const allowed = computed(() => computeIsAllowed(props, linkTo, linkHref));
    return { allowed, linkTo, linkHref };
}
function useRouteResolverMulti(items) {
    return computed(() => items.map((item) => {
        const to = computeLinkTo(item);
        const href = computeLinkHref(item);
        return Object.assign(Object.assign({}, item), { to,
            href, isAllowed: !!(to || href) });
    }));
}
function computeLinkTo(props) {
    return props.to ? resolveRouteLink(props.to).to : undefined;
}
function computeLinkHref(props) {
    return props.to ? resolveRouteLink(props.to).href : props.href;
}
function computeIsAllowed(props, linkTo, linkHref) {
    return props.to ? !!(linkTo.value || linkHref.value) : true;
}

function makeIDGenerator(prefix) {
    let nextIndex = 0;
    return {
        next: () => {
            const result = `${prefix}-${nextIndex}`;
            nextIndex += 1;
            return result;
        },
    };
}
const generators = {};
function useIdGenerator (prefix) {
    if (!generators[prefix]) {
        generators[prefix] = makeIDGenerator(prefix);
    }
    return generators[prefix];
}

function useRouter () {
    const vm = getCurrentInstance();
    return {
        route: vm.$route,
        router: vm.$router,
    };
}

function useState(initialState) {
    const state = {};
    for (const key in initialState) {
        state[key] = ref(initialState[key]);
    }
    const setState = (newState) => {
        for (const k in newState) {
            state[k].value = newState[k];
        }
    };
    const setFromOldState = (callBack) => {
        const oldState = {};
        for (const key in state) {
            oldState[key] = state[key].value;
        }
        setState(callBack(oldState));
    };
    return { state, setState, setFromOldState };
}

var useCustomFocus = (focus, currentStyle = null) => {
    return computed(() => {
        return Array.isArray(focus)
            ? Object.assign(Object.assign({}, currentStyle), { '--p-focus-background-color': focus[0], '--p-focus-ring-color': focus[1] }) : currentStyle;
    });
};

var script$1h = defineComponent({
    name: 'PDivider',
    components: { VDivider },
});

/* script */
const __vue_script__$1h = script$1h;

/* template */
var __vue_render__$1j = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-divider',{attrs:{"role":"presentation"}})};
var __vue_staticRenderFns__$1j = [];

  /* style */
  const __vue_inject_styles__$1j = undefined;
  /* scoped */
  const __vue_scope_id__$1j = undefined;
  /* module identifier */
  const __vue_module_identifier__$1j = undefined;
  /* functional template */
  const __vue_is_functional_template__$1j = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1j = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1j, staticRenderFns: __vue_staticRenderFns__$1j },
    __vue_inject_styles__$1j,
    __vue_script__$1h,
    __vue_scope_id__$1j,
    __vue_is_functional_template__$1j,
    __vue_module_identifier__$1j,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1g = defineComponent({
    name: 'PHeading',
    props: {
        level: {
            type: [String, Number],
            required: true,
            validator: value => {
                const intLevel = parseInt(value, 10);
                return !isNaN(intLevel) && intLevel >= 1 && intLevel <= 6;
            },
        },
    },
    setup(props) {
        return {
            headingLevel: `h${props.level.toString()}`,
        };
    },
});

/* script */
const __vue_script__$1g = script$1g;

/* template */
var __vue_render__$1i = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.headingLevel,{tag:"component"},[_vm._t("default")],2)};
var __vue_staticRenderFns__$1i = [];

  /* style */
  const __vue_inject_styles__$1i = undefined;
  /* scoped */
  const __vue_scope_id__$1i = undefined;
  /* module identifier */
  const __vue_module_identifier__$1i = undefined;
  /* functional template */
  const __vue_is_functional_template__$1i = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1i = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1i, staticRenderFns: __vue_staticRenderFns__$1i },
    __vue_inject_styles__$1i,
    __vue_script__$1g,
    __vue_scope_id__$1i,
    __vue_is_functional_template__$1i,
    __vue_module_identifier__$1i,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1f = defineComponent({
    name: 'PageLayoutBase',
    components: { PDivider: __vue_component__$1j, PHeading: __vue_component__$1i },
    props: {
        a11yFocusableOptions: { type: Object, default: () => ({}) },
        pageTitle: { type: String, default: null },
        divider: { type: Boolean, default: true },
    },
    setup(props, { slots }) {
        const hasSlot = useHasSlot(slots);
        const { route } = useRouter();
        const title = computed(() => {
            if (props.pageTitle) {
                return props.pageTitle;
            }
            if (route && route.meta && route.meta.title) {
                return route.meta.title;
            }
            return '';
        });
        return {
            hasSlot,
            title,
        };
    },
});

/* script */
const __vue_script__$1f = script$1f;

/* template */
var __vue_render__$1h = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['d-flex justify-space-between', {'mb-4 mb-md-12': !_vm.divider}]},[(_vm.title || _vm.hasSlot('title'))?_c('p-heading',{directives:[{name:"a11y-focusable",rawName:"v-a11y-focusable",value:(_vm.a11yFocusableOptions),expression:"a11yFocusableOptions"}],attrs:{"level":"1"}},[(_vm.hasSlot('title'))?_vm._t("title"):[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]],2):_vm._e(),_vm._v(" "),_vm._t("headerInlineContent")],2),_vm._v(" "),(_vm.divider)?_c('p-divider',{staticClass:"mb-8 mb-xs-4 mb-md-14"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)};
var __vue_staticRenderFns__$1h = [];

  /* style */
  const __vue_inject_styles__$1h = undefined;
  /* scoped */
  const __vue_scope_id__$1h = undefined;
  /* module identifier */
  const __vue_module_identifier__$1h = undefined;
  /* functional template */
  const __vue_is_functional_template__$1h = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1h = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1h, staticRenderFns: __vue_staticRenderFns__$1h },
    __vue_inject_styles__$1h,
    __vue_script__$1f,
    __vue_scope_id__$1h,
    __vue_is_functional_template__$1h,
    __vue_module_identifier__$1h,
    false,
    undefined,
    undefined,
    undefined
  );

class UseHelpMenu {
    constructor(menuRef, withSetTimeout = null) {
        this.active = ref(false);
        this._linkRefs = [];
        this._focusOnLastItem = false;
        this._menuRef = menuRef;
        this._withSetTimeout = withSetTimeout;
        watch(this.active, () => this.active.value ? this._onOpen() : this._onClose());
    }
    menuKeyHandler(ev) {
        const actions = {
            ArrowUp: () => this._focusOnItem(this._getNextItemIndex('prev')),
            ArrowDown: () => this._focusOnItem(this._getNextItemIndex('next')),
            Home: () => this._focusOnItem(0),
            End: () => this._focusOnItem(this._linkRefs.length - 1),
        };
        actions[ev.code] && actions[ev.code]();
    }
    activatorKeyHandler(ev) {
        if (ev.type === 'keydown' && ev.code === 'ArrowUp') {
            this._focusOnLastItem = true;
        }
    }
    _onOpen() {
        if (!this._linkRefs.length) {
            const links = this._menuRef.value ? this._menuRef.value.querySelectorAll(':scope a') : [];
            this._linkRefs = [...links].map((link) => link);
        }
        const index = this._focusOnLastItem ? this._linkRefs.length - 1 : 0;
        if (this._withSetTimeout !== null) {
            setTimeout(() => this._focusOnItem(index), this._withSetTimeout);
        }
        else {
            this._focusOnItem(index);
        }
    }
    _onClose() {
        this._focusOnLastItem = false;
    }
    _focusOnItem(index) {
        if (this._linkRefs[index]) {
            this._linkRefs[index].focus();
        }
    }
    _focusedItemIndex() {
        let focusedElement = null;
        if (document.hasFocus() && document.activeElement !== document.body && document.activeElement !== document.documentElement) {
            focusedElement = document.activeElement;
        }
        else if (document.querySelector) {
            focusedElement = document.querySelector(':focus');
        }
        return this._linkRefs.findIndex((link) => link === focusedElement);
    }
    _getNextItemIndex(direction) {
        const focusedIndex = this._focusedItemIndex();
        const indices = {
            prev: (focusedIndex <= 0) ? this._linkRefs.length - 1 : focusedIndex - 1,
            next: (focusedIndex >= this._linkRefs.length - 1) ? 0 : focusedIndex + 1,
        };
        return indices[direction];
    }
}
function useHelpMenu(menuRef, withSetTimeout = null) {
    const helpMenu = new UseHelpMenu(menuRef, withSetTimeout);
    return {
        active: helpMenu.active,
        activatorKeyHandler: helpMenu.activatorKeyHandler.bind(helpMenu),
        menuKeyHandler: helpMenu.menuKeyHandler.bind(helpMenu),
    };
}

var i18n$a = {
    messages: {
        nl: {
            helpNeeded: 'Hulp nodig?',
            helpClose: 'Sluiten',
            helpdesk: 'Helpdesk',
        },
    },
};

var script$1e = defineComponent({
    name: 'PHelpPanel',
    components: { VBtn, VIcon, VMenu },
    i18n: i18n$a,
    props: {
        items: { type: Array, default: () => [] },
    },
    setup(props) {
        const hasItems = computed(() => !!props.items.length);
        const mainRef = ref(null);
        const menuRef = ref(null);
        const { active, activatorKeyHandler, menuKeyHandler } = useHelpMenu(menuRef, 100);
        return { hasItems, mainRef, menuRef, active, activatorKeyHandler, menuKeyHandler };
    },
});

/* script */
const __vue_script__$1e = script$1e;
/* template */
var __vue_render__$1g = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mainRef",staticClass:"p-help-panel"},[_c('v-menu',{attrs:{"attach":_vm.mainRef,"close-on-click":false,"close-on-content-click":false,"role":null,"rounded":"","bottom":"","left":"","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"p-help-panel__button white--text text-left justify-space-between px-4 py-3",attrs:{"color":"info","data-ui":"helpButtonDesktop","block":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.activatorKeyHandler.apply(null, arguments)}}},'v-btn',attrs,false),on),[_c('span',{staticClass:"flex-grow-1"},[_vm._v(_vm._s(_vm.$t('helpNeeded')))]),_vm._v(" "),_c('v-icon',{staticClass:"p_help-panel__icon ml-4",attrs:{"color":"white"}},[_vm._v("\n          $icon-chevron-beneden\n        ")])],1)]}}]),model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v;},expression:"active"}},[_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],ref:"menuRef",staticClass:"p-help-panel__menu ma-0 px-4 py-6",attrs:{"role":"menu"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])&&_vm._k($event.keyCode,"home",undefined,$event.key,undefined)&&_vm._k($event.keyCode,"end",undefined,$event.key,undefined)){ return null; }$event.preventDefault();return _vm.menuKeyHandler.apply(null, arguments)}}},_vm._l((_vm.items),function(item,index){return _c('li',{key:("pgb_help_panel_" + index),staticClass:"p-help-panel__link mb-4",attrs:{"role":"none"}},[_c('a',{staticClass:"d-flex align-start",attrs:{"href":item.url,"tabindex":"0","role":"menuitem"},on:{"click":function($event){item.anchorPoint ? _vm.$emit('scrollAnimate', $event) : null;}}},[_vm._v(_vm._s(item.label))])])}),0)])],1)};
var __vue_staticRenderFns__$1g = [];

  /* style */
  const __vue_inject_styles__$1g = undefined;
  /* scoped */
  const __vue_scope_id__$1g = "data-v-461f214f";
  /* module identifier */
  const __vue_module_identifier__$1g = undefined;
  /* functional template */
  const __vue_is_functional_template__$1g = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1g = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1g, staticRenderFns: __vue_staticRenderFns__$1g },
    __vue_inject_styles__$1g,
    __vue_script__$1e,
    __vue_scope_id__$1g,
    __vue_is_functional_template__$1g,
    __vue_module_identifier__$1g,
    false,
    undefined,
    undefined,
    undefined
  );

function btnOutlined() {
    return {
        color: 'primary',
        hoverClass: 'outline-hover',
        outlined: true,
    };
}
function btnFilled() {
    return {
        color: 'primary',
        hoverClass: 'filled-hover',
    };
}
function btnNext() {
    return Object.assign(Object.assign({}, btnFilled()), { inlineIcon: {
            position: 'right',
            icon: '$icon-chevron-rechts',
        } });
}
function btnPrevious() {
    return Object.assign(Object.assign({}, btnOutlined()), { inlineIcon: {
            icon: '$icon-chevron-links',
        } });
}
function btnUp() {
    return Object.assign(Object.assign({}, btnOutlined()), { inlineIcon: {
            position: 'right',
            icon: '$icon-chevron-boven',
        } });
}
function btnDown() {
    return Object.assign(Object.assign({}, btnOutlined()), { inlineIcon: {
            position: 'right',
            icon: '$icon-chevron-beneden',
        } });
}
function btnInfo() {
    return {
        color: 'info',
        hoverClass: 'info-hover',
    };
}
function btnText() {
    return {
        color: 'primary',
        text: true,
        hoverClass: 'text-hover',
    };
}
function btnHelpMobile(color) {
    return {
        style: { color },
        width: '100%',
    };
}
function btnPrint() {
    return Object.assign({}, btnOutlined());
}
function btnRestore() {
    return Object.assign(Object.assign({}, btnOutlined()), { inlineIcon: {
            icon: '$icon-ongedaan-maken',
        } });
}
function btnDelete() {
    return Object.assign(Object.assign({}, btnOutlined()), { inlineIcon: {
            icon: '$icon-verwijderen',
        } });
}
function removeNonInheritableOptions(data) {
    const options = {};
    for (const key in data) {
        if (key !== 'hoverClass') {
            options[key] = data[key];
        }
    }
    return options;
}
function getGetBtnPresets() {
    const vm = getCurrentInstance();
    const colorHexes = vm.$vuetify.theme.defaults.light;
    return () => {
        return {
            outlined: btnOutlined(),
            filled: btnFilled(),
            next: btnNext(),
            previous: btnPrevious(),
            up: btnUp(),
            down: btnDown(),
            info: btnInfo(),
            text: btnText(),
            helpMobile: btnHelpMobile(colorHexes.primary),
            print: btnPrint(),
            restore: btnRestore(),
            delete: btnDelete(),
        };
    };
}
function usePresets () {
    const getBtnPresets = getGetBtnPresets();
    return {
        getPreset: ({ name, small = false, hasContent = true, withIcon = true, extraSmall = false, }) => {
            const btnPresets = getBtnPresets();
            if (!btnPresets[name]) {
                name = 'outlined';
            }
            const preset = Object.assign({}, btnPresets[name]); // create new preset Object instance
            preset.large = !small && !extraSmall; // according to our own design rules, a normal sized buttons is the vuetify equavilant of a large button
            preset.small = extraSmall; // according to our own design rules, an extra-small sized buttons is the vuetify equavilant of a small button
            if (preset.inlineIcon && !preset.inlineIcon.position) {
                preset.inlineIcon.position = 'left';
            }
            if (!withIcon) {
                delete preset.inlineIcon;
            }
            if (!hasContent && preset.inlineIcon) {
                preset.inlineIcon.position = undefined;
            }
            return preset;
        },
        removeNonInheritableOptions,
    };
}

var script$1d = defineComponent({
    name: 'PButton',
    components: { VIcon, VBtn },
    props: {
        preset: { type: String, default: 'outlined' },
        focus: { type: [String, Array], default: 'dark' },
        small: { type: Boolean, default: false },
        extraSmall: { type: Boolean, default: false },
        to: { type: [String, Object], default: undefined },
        href: { type: String, default: undefined },
        disabled: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        exact: { type: Boolean, default: null },
    },
    setup(props, { slots }) {
        const { getPreset, removeNonInheritableOptions } = usePresets();
        const options = computed(() => {
            return getPreset({
                name: props.preset,
                small: props.small,
                withIcon: false,
                extraSmall: props.extraSmall,
            });
        });
        const customFocus = useCustomFocus(props.focus, options.value.style);
        const hasCustomFocus = computed(() => Array.isArray(props.focus));
        const hasSlot = useHasSlot(slots);
        const inlineIcon = computed(() => {
            const preset = getPreset({ name: props.preset, hasContent: hasSlot('default') });
            return preset.inlineIcon;
        });
        const { allowed, linkTo, linkHref } = useRouteResolver(props);
        return { hasSlot, options, inlineIcon, removeNonInheritableOptions, linkTo, linkHref, allowed, hasCustomFocus, customFocus };
    },
});

/* script */
const __vue_script__$1d = script$1d;
/* template */
var __vue_render__$1f = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allowed)?_c('v-btn',_vm._b({class:[
    'p-button',
    !_vm.hasSlot('default') ? 'p-button--no-text px-2' : 'px-4',
    _vm.options.hoverClass ? ("custom-hover " + (_vm.options.hoverClass)) : '',
    ("p-focus-" + (_vm.hasCustomFocus ? 'custom' : _vm.focus))
  ],style:(_vm.customFocus),attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"to":_vm.linkTo,"href":_vm.linkHref,"exact":_vm.exact},on:{"click":function($event){return _vm.$emit('click', $event)}}},'v-btn',Object.assign({}, _vm.removeNonInheritableOptions(_vm.options)),false),[(_vm.inlineIcon && _vm.inlineIcon.position === 'right')?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.inlineIcon)?_c('v-icon',_vm._b({class:[
      'p-button__icon',
      {'mr-4': _vm.inlineIcon.position === 'left'},
      {'ml-4': _vm.inlineIcon.position === 'right'}
    ]},'v-icon',Object.assign({}, {large: _vm.options.large},
      (_vm.inlineIcon.position ? ( _obj = {}, _obj[_vm.inlineIcon.position] = true, _obj ) : {})),false),[_vm._v("\n    "+_vm._s(_vm.inlineIcon.icon)+"\n  ")]):_vm._e(),_vm._v(" "),(!_vm.inlineIcon || _vm.inlineIcon.position === 'left')?_vm._t("default"):_vm._e()],2):_vm._e()};
var __vue_staticRenderFns__$1f = [];

  /* style */
  const __vue_inject_styles__$1f = undefined;
  /* scoped */
  const __vue_scope_id__$1f = "data-v-a9089af2";
  /* module identifier */
  const __vue_module_identifier__$1f = undefined;
  /* functional template */
  const __vue_is_functional_template__$1f = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1f, staticRenderFns: __vue_staticRenderFns__$1f },
    __vue_inject_styles__$1f,
    __vue_script__$1d,
    __vue_scope_id__$1f,
    __vue_is_functional_template__$1f,
    __vue_module_identifier__$1f,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1c = defineComponent({
    name: 'PHelpOverlay',
    components: {
        VSlideXReverseTransition,
        VSheet,
        VDivider,
        PButton: __vue_component__$1f,
        VCardText,
        VCard,
        VIcon,
        VBtn,
    },
    i18n: i18n$a,
    props: {
        value: { type: Boolean, default: false, required: true },
        items: { type: Array, default: () => [] },
    },
    setup(props, { emit }) {
        const expand = ref(false);
        const hasItems = computed(() => !!props.items.length);
        const toggleExpand = () => {
            expand.value = !expand.value;
            emit('input', expand.value);
        };
        watchEffect(() => {
            expand.value = props.value;
        });
        return { expand, toggleExpand, hasItems };
    },
});

/* script */
const __vue_script__$1c = script$1c;
/* template */
var __vue_render__$1e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-x-reverse-transition',{attrs:{"origin":"center right"}},[(_vm.value)?_c('v-sheet',{staticClass:"p-help-overlay",attrs:{"tile":"","height":"100%","width":"100%","color":"info"}},[_c('div',{staticClass:"p-help-overlay-container my-4"},[_c('div',{staticClass:"topbar mb-8"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.toggleExpand()}}},[_c('v-icon',{attrs:{"color":"white","large":""}},[_vm._v("\n            $icon-chevron-links\n          ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"content mx-4"},[_c('v-card',{attrs:{"elevation":"0","color":"info"}},[_c('v-card-text',{staticClass:"white--text px-0"},[_c('h2',[_vm._v(_vm._s(_vm.$t('helpNeeded')))]),_vm._v(" "),_c('v-divider',{staticClass:"mt-2 mb-6"}),_vm._v(" "),(_vm.hasItems)?_vm._l((_vm.items),function(item,index){return _c('div',{key:("p_help_panel_" + index),staticClass:"mb-4 d-flex align-start"},[_c('a',{staticClass:"white--text",attrs:{"href":item.url},on:{"click":function($event){item.anchorPoint && _vm.$emit('scrollAnimate', $event);}}},[_vm._v(_vm._s(item.label))])])}):_vm._e()],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"footer mb-8 mx-4"},[_c('p-button',{staticClass:"help-close-button",attrs:{"preset":"helpMobile","focus":['rgb(0, 93, 85)', 'var(--v-focus-light-lighten3)']},on:{"click":function($event){return _vm.toggleExpand()}}},[_vm._v("\n          "+_vm._s(_vm.$t('helpClose'))+"\n        ")])],1)])]):_vm._e()],1)};
var __vue_staticRenderFns__$1e = [];

  /* style */
  const __vue_inject_styles__$1e = undefined;
  /* scoped */
  const __vue_scope_id__$1e = "data-v-9c86ec0c";
  /* module identifier */
  const __vue_module_identifier__$1e = undefined;
  /* functional template */
  const __vue_is_functional_template__$1e = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1e, staticRenderFns: __vue_staticRenderFns__$1e },
    __vue_inject_styles__$1e,
    __vue_script__$1c,
    __vue_scope_id__$1e,
    __vue_is_functional_template__$1e,
    __vue_module_identifier__$1e,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1b = defineComponent({
    name: 'PHelp',
    i18n: i18n$a,
    components: {
        PHelpPanel: __vue_component__$1g,
        PHelpOverlay: __vue_component__$1e,
        PButton: __vue_component__$1f,
    },
    props: {
        portalName: { type: String, default: 'helpTrigger' },
        items: { type: Array, default: () => [] },
    },
    setup(_, { root }) {
        const expand = ref(false);
        const { isMobileOrTabletView } = useBreakpoints();
        const scrollToFooter = (e) => {
            if (!e.target) {
                return;
            }
            expand.value = false;
            // @ts-ignore
            root.$smoothScroll({
                scrollTo: document.querySelector(e.target.getAttribute('href')),
                offset: isMobileOrTabletView ? -100 : 0,
                updateHistory: false,
                hash: e.target.getAttribute('href'),
            });
        };
        return {
            expand,
            isMobileOrTabletView,
            scrollToFooter,
        };
    },
});

/* script */
const __vue_script__$1b = script$1b;

/* template */
var __vue_render__$1d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMobileOrTabletView)?_c('portal',{attrs:{"to":_vm.portalName}},[_c('div',{staticClass:"my-1"},[_c('p-button',{attrs:{"preset":"info","data-ui":"helpButtonMobile"},on:{"click":function($event){_vm.expand = true;}}},[_vm._v("\n        "+_vm._s(_vm.$t('helpNeeded'))+"\n      ")])],1)]):_vm._e(),_vm._v(" "),_c(_vm.isMobileOrTabletView ? 'p-help-overlay' : 'p-help-panel',{tag:"component",attrs:{"items":_vm.items},on:{"scrollAnimate":_vm.scrollToFooter},model:{value:(_vm.expand),callback:function ($$v) {_vm.expand=$$v;},expression:"expand"}})],1)};
var __vue_staticRenderFns__$1d = [];

  /* style */
  const __vue_inject_styles__$1d = undefined;
  /* scoped */
  const __vue_scope_id__$1d = undefined;
  /* module identifier */
  const __vue_module_identifier__$1d = undefined;
  /* functional template */
  const __vue_is_functional_template__$1d = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1d, staticRenderFns: __vue_staticRenderFns__$1d },
    __vue_inject_styles__$1d,
    __vue_script__$1b,
    __vue_scope_id__$1d,
    __vue_is_functional_template__$1d,
    __vue_module_identifier__$1d,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1a = defineComponent({
    name: 'PageLayoutStandard',
    components: { PageLayoutBase: __vue_component__$1h, PHelp: __vue_component__$1d, VCol, VRow },
    props: {
        helpPanelItems: { type: Array, default: null },
        a11yFocusableOptions: { type: Object, default: null },
        pageTitle: { type: String, default: null },
    },
    setup(_, { slots }) {
        return {
            hasSlot: useHasSlot(slots),
        };
    },
});

/* script */
const __vue_script__$1a = script$1a;

/* template */
var __vue_render__$1c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout-base',{attrs:{"a11y-focusable-options":_vm.a11yFocusableOptions,"divider":!_vm.hasSlot('headerInlineContent'),"page-title":_vm.pageTitle},scopedSlots:_vm._u([(_vm.hasSlot('title'))?{key:"title",fn:function(){return [_vm._t("title")]},proxy:true}:null,{key:"headerInlineContent",fn:function(){return [_vm._t("headerInlineContent")]},proxy:true}],null,true)},[_vm._v(" "),_vm._v(" "),_c('v-row',[_c('v-col',{staticClass:"mt-md-3",attrs:{"md":"9","cols":"12"}},[_vm._t("default")],2),_vm._v(" "),_c('v-col',{attrs:{"md":"3","cols":"12"}},[(_vm.helpPanelItems)?_c('p-help',{staticClass:"mb-5 ml-md-2",attrs:{"items":_vm.helpPanelItems}}):_vm._e(),_vm._v(" "),_vm._t("colRight")],2)],1)],1)};
var __vue_staticRenderFns__$1c = [];

  /* style */
  const __vue_inject_styles__$1c = undefined;
  /* scoped */
  const __vue_scope_id__$1c = undefined;
  /* module identifier */
  const __vue_module_identifier__$1c = undefined;
  /* functional template */
  const __vue_is_functional_template__$1c = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1c, staticRenderFns: __vue_staticRenderFns__$1c },
    __vue_inject_styles__$1c,
    __vue_script__$1a,
    __vue_scope_id__$1c,
    __vue_is_functional_template__$1c,
    __vue_module_identifier__$1c,
    false,
    undefined,
    undefined,
    undefined
  );

const alertDefaultLiveRegion = {
    success: 'polite',
    info: 'polite',
    warning: 'assertive',
    error: 'assertive',
};
function setWatcher(props, displayAlert, defaultDisplayAlertValue = true) {
    watch(() => props.showAlert, () => {
        if (props.showAlert === undefined) {
            if (props.ariaLive === 'off') {
                displayAlert.value = defaultDisplayAlertValue;
            }
            else {
                setTimeout(() => {
                    displayAlert.value = defaultDisplayAlertValue;
                }, 500);
            }
        }
        else {
            displayAlert.value = props.showAlert;
        }
    });
}
var script$19 = defineComponent({
    name: 'PAlert',
    components: { VAlert, PHeading: __vue_component__$1i },
    props: {
        type: { required: true, type: String },
        dismissible: { type: Boolean, default: false },
        dismissiblePersistentKey: { type: String, default: null },
        value: { type: Boolean, default: true },
        title: { type: String, default: null },
        headingLevel: { type: [String, Number], default: null },
        truncateTitle: { type: Boolean, default: false },
        ariaLive: { type: String, validator: v => ['off', 'polite', 'assertive'].includes(v), default: null },
        showAlert: { type: Boolean, default: undefined },
    },
    setup(props, ctx) {
        const displayAlert = ref(false);
        const getIcon = () => {
            const icons = {
                info: '$icon-info-i',
                success: '$icon-cirkel-ok',
                warning: '$icon-waarschuwing',
                error: '$icon-cirkel-fout',
            };
            return icons[props.type];
        };
        const handleInput = (inputEvent) => {
            if (props.dismissible && props.dismissiblePersistentKey && inputEvent === false) {
                // Message dismissed
                localStorage.setItem(props.dismissiblePersistentKey, 'true');
            }
            ctx.emit('input', inputEvent);
        };
        let alreadyDismissed = false;
        if (props.dismissible && props.dismissiblePersistentKey) {
            // Should check if the alert has been dismissed already
            alreadyDismissed = localStorage.getItem(props.dismissiblePersistentKey) !== null;
        }
        setWatcher(props, displayAlert, !alreadyDismissed);
        return {
            getIcon,
            handleInput,
            displayAlert,
            liveRegionLevel: computed(() => props.ariaLive || alertDefaultLiveRegion[props.type]),
            titleElement: computed(() => props.headingLevel ? __vue_component__$1i : 'span'),
        };
    },
});

/* script */
const __vue_script__$19 = script$19;
/* template */
var __vue_render__$1b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"aria-live":_vm.liveRegionLevel,"aria-atomic":"true"}},[(_vm.displayAlert)?_c('v-alert',_vm._b({staticClass:"p-alert",attrs:{"outlined":"","text":"","type":_vm.type,"dismissible":_vm.dismissible,"value":_vm.value,"icon":_vm.getIcon(),"role":null},on:{"input":function($event){return _vm.handleInput(arguments[0])}}},'v-alert',_vm.$attrs,false),[_c('div',{staticClass:"p-alert__content"},[(_vm.title)?_c(_vm.titleElement,{tag:"component",class:[{'text-truncate': _vm.truncateTitle},'p-alert__content__heading'],attrs:{"level":_vm.headingLevel}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)]):_vm._e()],1)};
var __vue_staticRenderFns__$1b = [];

  /* style */
  const __vue_inject_styles__$1b = undefined;
  /* scoped */
  const __vue_scope_id__$1b = "data-v-1dbb518e";
  /* module identifier */
  const __vue_module_identifier__$1b = undefined;
  /* functional template */
  const __vue_is_functional_template__$1b = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1b, staticRenderFns: __vue_staticRenderFns__$1b },
    __vue_inject_styles__$1b,
    __vue_script__$19,
    __vue_scope_id__$1b,
    __vue_is_functional_template__$1b,
    __vue_module_identifier__$1b,
    false,
    undefined,
    undefined,
    undefined
  );

var script$18 = defineComponent({
    name: 'PCard',
    components: { VCardText, VCardActions, VCardTitle, VCard, VExpandTransition, VIcon, PHeading: __vue_component__$1i },
    props: {
        title: { type: String, required: true },
        headingLevel: { type: [String, Number], required: true },
        isNamedSection: { type: Boolean, default: false },
        dark: { type: Boolean, default: false },
        expandable: { type: Boolean, default: false },
        expanded: { type: Boolean, default: false },
    },
    setup(props, { slots }) {
        const cardId = useIdGenerator('p-card').next();
        const headingId = useIdGenerator('p-card-heading').next();
        const show = ref(props.expanded);
        function expandToggle() {
            show.value = !show.value;
        }
        return {
            hasSlot: useHasSlot(slots),
            show,
            cardId,
            headingId,
            expandToggle,
            titleWrapperElement: computed(() => props.expandable ? __vue_component__$1i : 'div'),
            titleElement: computed(() => props.expandable ? 'span' : __vue_component__$1i),
        };
    },
});

/* script */
const __vue_script__$18 = script$18;
/* template */
var __vue_render__$1a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:['p-card', { 'p-card--dark': _vm.dark }],attrs:{"outlined":""}},[_c('section',{attrs:{"aria-labelledby":_vm.isNamedSection ? _vm.headingId : null}},[(_vm.title || _vm.hasSlot('info'))?_c(_vm.titleWrapperElement,{tag:"component",staticClass:"p-card__heading",attrs:{"level":_vm.expandable ? _vm.headingLevel : null,"id":_vm.expandable && _vm.isNamedSection ? _vm.headingId : null}},[_c('v-card-title',{class:[
          'p-card__heading-bar',
          {'p-card__heading-bar--expandable': _vm.expandable}
        ],attrs:{"tabindex":_vm.expandable ? 0 : null,"aria-expanded":_vm.expandable ? _vm.show.toString() : null,"aria-controls":_vm.expandable ? _vm.cardId : null,"role":_vm.expandable ? 'button': null},on:{"click":_vm.expandToggle,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.expandToggle.apply(null, arguments)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.expandToggle.apply(null, arguments)}}},[_c(_vm.titleElement,{tag:"component",staticClass:"p-card__heading-bar-title flex-grow-1",attrs:{"level":_vm.expandable ? null : _vm.headingLevel,"id":_vm.expandable || !_vm.isNamedSection ? null : _vm.headingId}},[(_vm.title)?_c('span',{staticClass:"p-card__heading-bar-title-text"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._v(" "),(!_vm.expandable)?_vm._t("info"):_vm._e()],2),_vm._v(" "),(_vm.expandable)?_c('v-icon',{staticClass:"p-card__heading-bar-icon"},[_vm._v("\n          "+_vm._s(_vm.show ? '$icon-chevron-boven' : '$icon-chevron-beneden')+"\n        ")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-expand-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show || !_vm.expandable),expression:"show || !expandable"}],attrs:{"id":_vm.cardId}},[_c('v-card-text',[_vm._t("default")],2),_vm._v(" "),(_vm.hasSlot('actions'))?_c('v-card-actions',[_vm._t("actions")],2):_vm._e()],1)])],1)])};
var __vue_staticRenderFns__$1a = [];

  /* style */
  const __vue_inject_styles__$1a = undefined;
  /* scoped */
  const __vue_scope_id__$1a = "data-v-06cc629a";
  /* module identifier */
  const __vue_module_identifier__$1a = undefined;
  /* functional template */
  const __vue_is_functional_template__$1a = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1a = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1a, staticRenderFns: __vue_staticRenderFns__$1a },
    __vue_inject_styles__$1a,
    __vue_script__$18,
    __vue_scope_id__$1a,
    __vue_is_functional_template__$1a,
    __vue_module_identifier__$1a,
    false,
    undefined,
    undefined,
    undefined
  );

var script$17 = defineComponent({
    name: 'PHelpMobileTrigger',
    props: {
        triggerName: { type: String, default: 'helpTrigger' },
    },
});

/* script */
const __vue_script__$17 = script$17;

/* template */
var __vue_render__$19 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal-target',{attrs:{"name":_vm.triggerName}})};
var __vue_staticRenderFns__$19 = [];

  /* style */
  const __vue_inject_styles__$19 = undefined;
  /* scoped */
  const __vue_scope_id__$19 = undefined;
  /* module identifier */
  const __vue_module_identifier__$19 = undefined;
  /* functional template */
  const __vue_is_functional_template__$19 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$19 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$19, staticRenderFns: __vue_staticRenderFns__$19 },
    __vue_inject_styles__$19,
    __vue_script__$17,
    __vue_scope_id__$19,
    __vue_is_functional_template__$19,
    __vue_module_identifier__$19,
    false,
    undefined,
    undefined,
    undefined
  );

var script$16 = defineComponent({
    name: 'PValueGrid',
    setup(props, { slots }) {
        const hideSlot = ref(false);
        const checkForIllegalElements = () => {
            const valueRows = slots.default ? slots.default() : [];
            if (valueRows.length) {
                valueRows.forEach(el => {
                    const componentTag = el.componentOptions && el.componentOptions.tag;
                    if ((el.tag && !el.componentOptions) || (el.componentOptions && componentTag !== 'p-value-row')) {
                        // eslint-disable-next-line
                        console.warn(`PValueGrid: Component/element "${el.tag || componentTag}" is not a valid component, please provide the PValueRow component`);
                        hideSlot.value = true;
                    }
                });
                return;
            }
            // eslint-disable-next-line
            console.warn(`PValueGrid: PValueRow component has not been provided in the slot`);
        };
        onMounted(checkForIllegalElements);
        return { checkForIllegalElements, hideSlot };
    },
});

/* script */
const __vue_script__$16 = script$16;
/* template */
var __vue_render__$18 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{ref:"gridContainer",staticClass:"p-value-grid d-flex flex-column"},[(!_vm.hideSlot)?_vm._t("default"):_vm._e()],2)};
var __vue_staticRenderFns__$18 = [];

  /* style */
  const __vue_inject_styles__$18 = undefined;
  /* scoped */
  const __vue_scope_id__$18 = "data-v-3f684a9e";
  /* module identifier */
  const __vue_module_identifier__$18 = undefined;
  /* functional template */
  const __vue_is_functional_template__$18 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$18 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$18, staticRenderFns: __vue_staticRenderFns__$18 },
    __vue_inject_styles__$18,
    __vue_script__$16,
    __vue_scope_id__$18,
    __vue_is_functional_template__$18,
    __vue_module_identifier__$18,
    false,
    undefined,
    undefined,
    undefined
  );

var i18n$9 = {
    messages: {
        nl: {
            close: 'Sluiten',
            ariaLabel: 'Extra informatie weergeven',
            ariaLabelWithLinkedLabelText: 'Extra informatie weergeven voor {label}',
        },
    },
};

var script$15 = defineComponent({
    name: 'PDialog',
    components: {
        VDialog,
        VCard,
        VCardActions,
        VCardText,
        VCardTitle,
        VDivider,
        PButton: __vue_component__$1f,
    },
    props: {
        value: { type: Boolean, default: undefined },
        title: { type: String, default: '' },
        dataUi: { type: String, default: null },
        wide: { type: Boolean, default: false },
        small: { type: Boolean, default: false },
        persistent: { type: Boolean, default: true },
    },
    setup(props, { emit, slots }) {
        const visibleModel = ref(!!props.value);
        watch(() => props.value, (v) => {
            visibleModel.value = v;
        });
        const hasSlot = useHasSlot(slots);
        watch(() => visibleModel.value, (v) => {
            if (typeof v !== 'undefined') {
                emit('input', v);
            }
        });
        return {
            visibleModel,
            hasSlot,
            modalWidth: getModalWidth(props),
        };
    },
});
function getModalWidth(props) {
    const sizes = { small: 390, default: 500, wide: 748 };
    return computed(() => {
        if (props.small) {
            return sizes.small;
        }
        if (props.wide) {
            return sizes.wide;
        }
        return sizes.default;
    });
}

/* script */
const __vue_script__$15 = script$15;
/* template */
var __vue_render__$17 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":_vm.modalWidth,"persistent":_vm.persistent,"scrollable":""},scopedSlots:_vm._u([(_vm.hasSlot('activator'))?{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("activator",null,{"on":on,"attrs":attrs})]}}:null],null,true),model:{value:(_vm.visibleModel),callback:function ($$v) {_vm.visibleModel=$$v;},expression:"visibleModel"}},[_vm._v(" "),_c('v-card',{attrs:{"data-ui":_vm.dataUi}},[(_vm.title)?_c('v-card-title',{staticClass:"p-dialog__title"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"p-dialog__text"},[_vm._t("default")],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',{staticClass:"p-dialog__actions"},[(_vm.hasSlot('actions'))?[_vm._t("actions")]:_c('p-button',{staticClass:"p-dialog__close-button ml-auto",attrs:{"data-ui":"modal-close","preset":"filled"},on:{"click":function($event){_vm.visibleModel = !_vm.visibleModel;}}},[_vm._v("\n        "+_vm._s(_vm.$t('close'))+"\n      ")])],2)],1)],1)};
var __vue_staticRenderFns__$17 = [];

  /* style */
  const __vue_inject_styles__$17 = undefined;
  /* scoped */
  const __vue_scope_id__$17 = "data-v-36d77b2a";
  /* module identifier */
  const __vue_module_identifier__$17 = undefined;
  /* functional template */
  const __vue_is_functional_template__$17 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$17 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$17, staticRenderFns: __vue_staticRenderFns__$17 },
    __vue_inject_styles__$17,
    __vue_script__$15,
    __vue_scope_id__$17,
    __vue_is_functional_template__$17,
    __vue_module_identifier__$17,
    false,
    undefined,
    undefined,
    undefined
  );

var script$14 = defineComponent({
    name: 'PInfo',
    components: {
        PDialog: __vue_component__$17,
        VIcon,
        VHover,
    },
    i18n: i18n$9,
    props: {
        title: { type: String, default: '' },
        message: { type: String, default: '' },
        wide: { type: Boolean, default: false },
        linkedLabelText: { type: String, default: '' },
        focus: { type: [String, Array], default: 'dark' },
        invert: { type: Boolean, default: false },
    },
    setup(props, { slots }) {
        const hasSlot = useHasSlot(slots);
        const customFocus = useCustomFocus(props.focus);
        const internalId = useIdGenerator('p-info').next();
        return {
            hasSlot,
            customFocus,
            internalId,
        };
    },
});

/* script */
const __vue_script__$14 = script$14;
/* template */
var __vue_render__$16 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'p-info',
    ("p-focus-" + (_vm.customFocus ? 'custom' : _vm.focus))
  ],style:(_vm.customFocus)},[_c('p-dialog',{staticClass:"p-info__dialog",attrs:{"data-ui":"info-modal","title":_vm.title,"persistent":false,"wide":_vm.wide,"small":!_vm.wide},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
  var on = ref.on;
  var attrs = ref.attrs;
return [_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var hover = ref.hover;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"p-info__icon",attrs:{"color":_vm.invert ? 'white' : 'info',"dark":"","aria-labelledby":(_vm.internalId + "-label")}},'v-icon',attrs,false),on),[_vm._v("\n          "+_vm._s(hover ? '$icon-info-i' : '$icon-info-i-dun')+"\n        ")])]}}],null,true)})]}}])},[_vm._v(" "),(_vm.hasSlot())?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.message))])],2),_vm._v(" "),_c('div',{staticClass:"d-none",attrs:{"id":(_vm.internalId + "-label"),"aria-hidden":"true"}},[_vm._v("\n    "+_vm._s(_vm.linkedLabelText ? _vm.$t('ariaLabelWithLinkedLabelText', {label: _vm.linkedLabelText}) : _vm.$t('ariaLabel'))+"\n  ")])],1)};
var __vue_staticRenderFns__$16 = [];

  /* style */
  const __vue_inject_styles__$16 = undefined;
  /* scoped */
  const __vue_scope_id__$16 = "data-v-06e62e8e";
  /* module identifier */
  const __vue_module_identifier__$16 = undefined;
  /* functional template */
  const __vue_is_functional_template__$16 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$16 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$16, staticRenderFns: __vue_staticRenderFns__$16 },
    __vue_inject_styles__$16,
    __vue_script__$14,
    __vue_scope_id__$16,
    __vue_is_functional_template__$16,
    __vue_module_identifier__$16,
    false,
    undefined,
    undefined,
    undefined
  );

var script$13 = defineComponent({
    name: 'PValueRow',
    components: { PInfo: __vue_component__$16, VIcon },
    props: {
        label: { type: String, required: true },
        value: { type: [String, Number, Boolean], default: '' },
        info: { type: String, default: '' },
        id: { type: String, default: null },
        percentage: { type: Boolean, default: false },
        days: { type: Boolean, default: false },
        warning: { type: Boolean, default: false },
        yesNoBoolean: { type: Boolean, default: false },
        yesUnknownBoolean: { type: Boolean, default: false },
        yesNoUnknownBoolean: { type: Boolean, default: null },
        ellipsis: { type: Boolean, default: false },
        right: { type: Boolean, default: false },
        bold: { type: Boolean, default: false },
        dataUi: { type: String, default: null },
        dashOnFalsy: { type: Boolean, default: false },
        currency: { type: Boolean, default: false },
    },
    setup(props) {
        const { isMobileView } = useBreakpoints();
        const { tc, t, n } = useI18n();
        const renderChoices = [
            { propKey: 'days', value: () => props.value ? tc('days', Number(props.value)) : '-' },
            { propKey: 'percentage', value: () => String(props.value) + ' %' },
            { propKey: 'yesNoBoolean', value: () => props.value ? t('yes') : t('no') },
            { propKey: 'yesUnknownBoolean', value: () => props.value ? t('yes') : t('unknown') },
            { propKey: 'yesNoUnknownBoolean', value: () => props.value === null ? t('unknown') : (props.value ? t('yes') : t('no')) },
            { propKey: 'dashOnFalsy', value: () => props.dashOnFalsy && !props.value ? '-' : props.value },
            { propKey: 'currency', value: () => n(props.value, 'currency') },
        ];
        const rowValue = computed(() => {
            for (const item of renderChoices) {
                if (item.propKey && props[item.propKey]) {
                    return item.value();
                }
            }
            return props.value;
        });
        return { isMobileView, rowValue };
    },
});

/* script */
const __vue_script__$13 = script$13;
/* template */
var __vue_render__$15 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['p-value-row', {'p-value-row--mobile': _vm.isMobileView}]},[_c('dt',{staticClass:"p-value-row__cell-label pr-5 pb-1 pb-sm-4"},[_c('div',{staticClass:"p-value-row__cell-label-text"},[_vm._v("\n                        "+_vm._s(_vm.label)+"\n                        "),(_vm.info)?_c('p-info',{attrs:{"linked-label-text":_vm.label,"data-ui":_vm.dataUi ? _vm.dataUi + '-info': null,"message":_vm.info}}):_vm._e(),_vm._v(" "),_vm._t("label-info")],2)]),_vm._v(" "),_c('dd',{class:[
      'p-value-row__cell-value',
      'pb-1',
      'pb-sm-4',
      {
        'text-right': _vm.right,
        'font-weight-bold': _vm.bold,
        'overflow-hidden': _vm.ellipsis,
        'text-no-wrap': _vm.ellipsis,
      }
    ]},[(_vm.rowValue)?_c('div',{staticClass:"d-flex align-start"},[(_vm.warning)?_c('v-icon',{class:['pr-1', _vm.right? 'flex-grow-1 justify-end': null],attrs:{"color":"warning"}},[_vm._v("\n        $icon-waarschuwing\n      ")]):_vm._e(),_vm._v(" "),_c('span',{class:[{'flex-grow-1': !_vm.warning}, _vm.ellipsis ? 'text-truncate': 'break-all'],attrs:{"data-ui":_vm.dataUi}},[_vm._v("\n        "+_vm._s(_vm.rowValue)+"\n      ")])],1):_c('div',{attrs:{"data-ui":_vm.dataUi}},[_vm._t("default")],2)])])};
var __vue_staticRenderFns__$15 = [];

  /* style */
  const __vue_inject_styles__$15 = undefined;
  /* scoped */
  const __vue_scope_id__$15 = "data-v-766e0784";
  /* module identifier */
  const __vue_module_identifier__$15 = undefined;
  /* functional template */
  const __vue_is_functional_template__$15 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$15 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$15, staticRenderFns: __vue_staticRenderFns__$15 },
    __vue_inject_styles__$15,
    __vue_script__$13,
    __vue_scope_id__$15,
    __vue_is_functional_template__$15,
    __vue_module_identifier__$15,
    false,
    undefined,
    undefined,
    undefined
  );

const RegisterPStepKey = Symbol('registerPStep');
function provideRegisterPStep(register) {
    provide(RegisterPStepKey, register);
}
function injectRegisterPStep() {
    return inject(RegisterPStepKey);
}
function registerPStep(step) {
    const register = injectRegisterPStep();
    if (register && step) {
        register(step);
    }
}

const registerStepComponentKey = 'registerStepComponentKey';
function provideRegisterStepComponent(register) {
    provide(registerStepComponentKey, register);
}
function injectRegisterStepComponent() {
    return inject(registerStepComponentKey, null);
}
function registerStepComponent(stepComponent) {
    const register = injectRegisterStepComponent();
    if (register) {
        onMounted(() => {
            register(stepComponent);
        });
        onUnmounted(() => {
            register(stepComponent, true);
        });
    }
}

var script$12 = defineComponent({
    name: 'PStep',
    inheritAttrs: false,
    props: {
        save: { type: Boolean, default: false },
        previous: { type: Boolean, default: true },
        next: { type: Boolean, default: true },
        submit: { type: Boolean, default: false },
        complete: { type: Boolean, default: false },
        saveOnNext: { type: Boolean, default: false },
    },
    setup(props) {
        const active = ref(false);
        const stepComponents = ref([]);
        provideRegisterStepComponent((stepComponent, remove) => {
            if (remove) {
                const index = stepComponents.value.indexOf(stepComponent);
                if (index >= 0) {
                    stepComponents.value.splice(index, 1);
                }
            }
            else {
                stepComponents.value.push(stepComponent);
            }
        });
        registerPStep({
            show: () => {
                active.value = true;
            },
            hide: () => {
                active.value = false;
            },
            canGoNext: () => canGoNextFn(stepComponents),
            getHasValidation: () => getHasValidationFn(stepComponents),
            save: () => saveFn(stepComponents),
            props,
        });
        return {
            active,
        };
    },
});
function canGoNextFn(stepComponents) {
    return Promise
        .all(stepComponents.value.map(v => !v.readyToProceed || v.readyToProceed()))
        .then((values) => values.reduce((prev, current) => prev && current, true));
}
function saveFn(stepComponents) {
    return Promise
        .all(stepComponents.value.map(v => !v.save || v.save()))
        .then((values) => values.reduce((prev, current) => prev && current, true));
}
function getHasValidationFn(stepComponents) {
    return stepComponents.value.some((stepComponent) => !!stepComponent.readyToProceed);
}

/* script */
const __vue_script__$12 = script$12;
/* template */
var __vue_render__$14 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-step",class:{ hidden: !_vm.active }},[_c('keep-alive',[(_vm.active)?_vm._t("default"):_vm._e()],2)],1)};
var __vue_staticRenderFns__$14 = [];

  /* style */
  const __vue_inject_styles__$14 = undefined;
  /* scoped */
  const __vue_scope_id__$14 = "data-v-31ce26de";
  /* module identifier */
  const __vue_module_identifier__$14 = undefined;
  /* functional template */
  const __vue_is_functional_template__$14 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$14 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$14, staticRenderFns: __vue_staticRenderFns__$14 },
    __vue_inject_styles__$14,
    __vue_script__$12,
    __vue_scope_id__$14,
    __vue_is_functional_template__$14,
    __vue_module_identifier__$14,
    false,
    undefined,
    undefined,
    undefined
  );

var i18n$8 = {
    messages: {
        nl: {
            stap: 'Stap {stepNumber}',
            stapVoltooid: 'Stap {stepName} afgerond',
        },
    },
};

class StepNavigator {
    constructor(dc, context, updateState) {
        this.dc = dc;
        this.context = context;
        this.updateState = updateState;
    }
    buildMethods() {
        return {
            start: this.start.bind(this),
            toNextStep: this.toNextStep.bind(this),
            toPreviousStep: this.toPreviousStep.bind(this),
            toNavigateStep: this.toNavigateStep.bind(this),
            saveStep: this.saveStep.bind(this),
        };
    }
    start() {
        if (this.dc.routed.value) {
            this.dc.state.started = this.toNavigateStep();
        }
        else {
            this.dc.state.started = this.toValidatedNextStep(true);
        }
        this.dc.state.failed = !this.dc.state.started;
        this.updateState();
    }
    updateStep(newStep) {
        if (newStep >= 1 && newStep <= this.dc.state.steps.length) {
            this.dc.activeStep.value.hide();
            this.dc.state.stepNumber = newStep;
            this.dc.activeStep.value.show();
            this.updateState();
            return true;
        }
        return false;
    }
    getValidRouteIndex(index) {
        if (this.dc.finished.value) {
            return this.dc.finishedStep - 1;
        }
        let maxValidStep = this.dc.state.stepNumber;
        if (this.dc.currentStepValidated || !this.dc.activeStep.value.getHasValidation()) {
            maxValidStep = maxValidStep + 1;
        }
        if (index >= maxValidStep) {
            return maxValidStep - 1;
        }
        else {
            return index;
        }
    }
    navigate(stepNumber) {
        this.context.emit('navigate', stepNumber);
    }
    toNavigateStep() {
        const index = this.dc.navigateStep.value - 1;
        if (index < 0) {
            return false;
        }
        const validRouteIndex = this.getValidRouteIndex(index);
        if (validRouteIndex !== index) {
            this.navigate(validRouteIndex + 1);
            return true;
        }
        const direction = index + 1 - this.dc.state.stepNumber;
        const newStep = this.dc.state.stepNumber + direction;
        return direction !== 0 && this.updateStep(newStep);
    }
    toNextStep() {
        this.dc.state.processingNext = true;
        this.dc.activeStep.value.canGoNext()
            .then((value) => {
            const props = this.dc.activeStep.value.props;
            if (value && props.save && props.saveOnNext) {
                this.dc.activeStep.value.save();
            }
            this.toValidatedNextStep(value);
        })
            .finally(() => { this.dc.state.processingNext = false; });
    }
    toValidatedNextStep(valid) {
        if (!valid) {
            return false;
        }
        this.dc.currentStepValidated = true;
        const nextStep = this.dc.state.stepNumber + 1;
        if (this.dc.routed.value) {
            this.navigate(nextStep);
            return true;
        }
        else {
            return this.updateStep(nextStep);
        }
    }
    toPreviousStep() {
        const previousStep = this.dc.state.stepNumber - 1;
        if (this.dc.routed.value) {
            this.navigate(previousStep);
        }
        else {
            this.updateStep(previousStep);
        }
    }
    saveStep() {
        this.dc.state.processingSave = true;
        this.dc.activeStep.value.save()
            .then((saved) => this.context.emit('saved', saved))
            .finally(() => { this.dc.state.processingSave = false; });
    }
}

function updateState(dc) {
    dc.state.completed = dc.state.started && dc.activeStep.value.props.complete;
    dc.currentStepValidated = false;
    if (dc.finished.value) {
        dc.finishedStep = dc.state.stepNumber;
    }
}
function useButtons(dc) {
    function canShowNext() {
        return dc.state.stepNumber < dc.state.steps.length &&
            dc.activeStep.value.props.next &&
            !dc.finished.value;
    }
    return reactive({
        hasNextButton: computed(() => canShowNext() && !dc.activeStep.value.props.submit),
        hasPreviousButton: computed(() => dc.state.stepNumber > 1 && dc.activeStep.value.props.next && !dc.finished.value),
        hasSubmitButton: computed(() => canShowNext() && dc.activeStep.value.props.submit),
        hasSaveButton: computed(() => dc.activeStep.value.props.save),
    });
}
function getDefaultStep() {
    return {
        show: () => undefined,
        hide: () => undefined,
        canGoNext: () => __awaiter(this, void 0, void 0, function* () { return true; }),
        save: () => __awaiter(this, void 0, void 0, function* () { return true; }),
        getHasValidation: () => false,
        props: { save: false, previous: false, next: false, submit: false, complete: false, saveOnNext: false },
    };
}
function useDataContext(props) {
    const state = reactive({
        steps: [],
        stepNumber: 0,
        started: false,
        completed: false,
        failed: false,
        processingSave: false,
        processingNext: false,
        stepHeaders: computed(() => props.headers || []),
    });
    return {
        state,
        activeStep: computed(() => state.stepNumber > 0 ? state.steps[state.stepNumber - 1] : getDefaultStep()),
        finished: computed(() => state.completed || state.failed),
        routed: computed(() => props.navigateStep !== null),
        navigateStep: computed(() => props.navigateStep !== null ? props.navigateStep : 0),
        processing: computed(() => state.processingSave || state.processingNext),
        currentStepValidated: false,
        finishedStep: 0,
    };
}
function registerWatchers(dc, context, navigator) {
    let lastStepNumberEmitted = 0;
    watch(() => dc.state.stepNumber, (stepNumber) => {
        if (stepNumber > 0 && stepNumber !== lastStepNumberEmitted) {
            lastStepNumberEmitted = stepNumber;
            context.emit('stepped', stepNumber);
        }
    });
    watch(() => dc.state.completed, (completed) => {
        if (completed) {
            context.emit('completed');
        }
    });
    watch(() => dc.state.failed, (failed) => {
        if (failed) {
            context.emit('failed');
        }
    });
    // Track navigation
    watch(dc.navigateStep, () => {
        if (dc.state.started && dc.routed.value) {
            navigator.toNavigateStep();
        }
    });
    watch(() => ({ complete: dc.activeStep.value.props.complete }), () => updateState(dc));
}
function usePStepper (props, context) {
    const dc = useDataContext(props);
    const navigator = new StepNavigator(dc, context, () => updateState(dc)).buildMethods();
    registerWatchers(dc, context, navigator);
    return {
        dc,
        navigator,
        buttons: useButtons(dc),
    };
}

var script$11 = defineComponent({
    name: 'PStepper',
    components: {
        PButton: __vue_component__$1f,
        VRow,
        VCol,
        VStepper,
        VStepperHeader,
        VStepperStep,
        VDivider,
    },
    inheritAttrs: false,
    props: {
        headers: { type: [Number, Array], default: null },
        submitLabel: { type: String, default: '' },
        saveLabel: { type: String, default: '' },
        navigateStep: { type: Number, default: null },
    },
    i18n: i18n$8,
    setup(props, context) {
        const { dc, navigator, buttons } = usePStepper(props, context);
        provideRegisterPStep((step) => {
            dc.state.steps.push(step);
        });
        onMounted(() => {
            navigator.start();
        });
        return {
            state: dc.state,
            navigator,
            buttons,
            finished: dc.finished,
            processing: dc.processing,
        };
    },
});

/* script */
const __vue_script__$11 = script$11;
/* template */
var __vue_render__$13 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-stepper"},[(!_vm.state.failed)?_c('v-row',{key:"pStepperRowStateNotFailed"},[_c('v-col',{staticClass:"pt-0 pb-2 pb-md-11"},[_c('v-stepper',{staticClass:"p-stepper",attrs:{"value":_vm.state.stepNumber}},[_c('v-stepper-header',[_vm._l((_vm.state.stepHeaders),function(header,index){return [(index > 0)?_c('v-divider',{key:'h'+index,staticClass:"alt-labels"}):_vm._e(),_vm._v(" "),_c('v-stepper-step',{key:'s'+index,staticClass:"alt-labels",attrs:{"color":"grey-darker","complete":_vm.state.stepNumber > index + 1 || _vm.state.completed,"alt":_vm.state.stepNumber > index + 1 || _vm.state.completed ? _vm.$t('stapVoltooid', { stepName: header }) : _vm.$t('stap', { stepNumber: index + 1 }),"step":index + 1,"aria-current":_vm.state.stepNumber == index + 1}},[(header)?_c('span',[_vm._v(_vm._s(header))]):_vm._e()])]})],2)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-row',[_c('v-col',[_vm._t("default",null,{"state":{ stepNumber: _vm.state.stepNumber, completed: _vm.state.completed, failed: _vm.state.failed }})],2)],1),_vm._v(" "),(!_vm.finished)?_c('v-row',{key:"pStepperRowIsNotDone"},[_c('v-col',{staticClass:"d-flex justify-start"},[(_vm.buttons.hasPreviousButton)?_c('p-button',{attrs:{"id":"wizard-button-prev","preset":"previous","disabled":_vm.processing},on:{"click":function($event){return _vm.navigator.toPreviousStep()}}},[_vm._v("\n        "+_vm._s(_vm.$t('previousStep'))+"\n      ")]):_vm._e()],1),_vm._v(" "),(_vm.buttons.hasSaveButton)?_c('v-col',{key:"pStepperRowIsNotDoneColHasSaveButton",staticClass:"d-flex justify-start justify-sm-center"},[_c('p-button',{attrs:{"disabled":_vm.processing,"loading":_vm.state.processingSave,"id":"wizard-button-save"},on:{"click":function($event){return _vm.navigator.saveStep()}}},[_vm._v("\n        "+_vm._s(_vm.saveLabel || _vm.$t('save'))+"\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.buttons.hasNextButton || _vm.buttons.hasSubmitButton)?_c('v-col',{key:"pStepperRowIsNotDoneColHasSubmitButton",staticClass:"d-flex justify-start justify-end"},[_c('p-button',{attrs:{"id":"wizard-button-next","preset":"next","disabled":_vm.processing,"loading":_vm.state.processingNext},on:{"click":function($event){return _vm.navigator.toNextStep()}}},[_vm._v("\n        "+_vm._s(_vm.buttons.hasSubmitButton ? _vm.submitLabel || _vm.$t('submit') : _vm.$t('nextStep'))+"\n      ")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.finished)?_c('v-row',{key:"pStepperRowIsDone"},[_c('v-col',[_vm._t("done",null,{"state":{ stepNumber: _vm.state.stepNumber, completed: _vm.state.completed, failed: _vm.state.failed }})],2)],1):_vm._e()],1)};
var __vue_staticRenderFns__$13 = [];

  /* style */
  const __vue_inject_styles__$13 = undefined;
  /* scoped */
  const __vue_scope_id__$13 = "data-v-92e8fbb6";
  /* module identifier */
  const __vue_module_identifier__$13 = undefined;
  /* functional template */
  const __vue_is_functional_template__$13 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$13 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$13, staticRenderFns: __vue_staticRenderFns__$13 },
    __vue_inject_styles__$13,
    __vue_script__$11,
    __vue_scope_id__$13,
    __vue_is_functional_template__$13,
    __vue_module_identifier__$13,
    false,
    undefined,
    undefined,
    undefined
  );

/* script */
/* template */
var __vue_render__$12 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-button-container d-flex flex-row"},[_vm._t("default")],2)};
var __vue_staticRenderFns__$12 = [];

  /* style */
  const __vue_inject_styles__$12 = undefined;
  /* scoped */
  const __vue_scope_id__$12 = undefined;
  /* module identifier */
  const __vue_module_identifier__$12 = undefined;
  /* functional template */
  const __vue_is_functional_template__$12 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$12 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$12, staticRenderFns: __vue_staticRenderFns__$12 },
    __vue_inject_styles__$12,
    {},
    __vue_scope_id__$12,
    __vue_is_functional_template__$12,
    __vue_module_identifier__$12,
    false,
    undefined,
    undefined,
    undefined
  );

const maxColumnsOneline = 2;
const maxColumnsInlineLabels = 3;
const maxColumnsDefault = 4;

var script$10 = defineComponent({
    name: 'PContainer',
    components: { VContainer },
    props: {
        fluid: { type: Boolean, default: undefined },
    },
});

/* script */
const __vue_script__$10 = script$10;

/* template */
var __vue_render__$11 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":_vm.fluid}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$11 = [];

  /* style */
  const __vue_inject_styles__$11 = undefined;
  /* scoped */
  const __vue_scope_id__$11 = undefined;
  /* module identifier */
  const __vue_module_identifier__$11 = undefined;
  /* functional template */
  const __vue_is_functional_template__$11 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$11 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$11, staticRenderFns: __vue_staticRenderFns__$11 },
    __vue_inject_styles__$11,
    __vue_script__$10,
    __vue_scope_id__$11,
    __vue_is_functional_template__$11,
    __vue_module_identifier__$11,
    false,
    undefined,
    undefined,
    undefined
  );

const registerFormInputValidatorKey = 'registerInputValidatorKey';
function provideRegisterFormInputValidator(register) {
    provide(registerFormInputValidatorKey, register);
}
function injectRegisterFormInputValidator() {
    return inject(registerFormInputValidatorKey, null);
}
function registerFormInputValidator(formInputValidator) {
    const register = injectRegisterFormInputValidator();
    if (register) {
        onMounted(() => {
            register(formInputValidator);
        });
        onUnmounted(() => {
            register(formInputValidator, true);
        });
    }
}

class UseValidation {
    constructor(props, i18n, validate, shouldValidate) {
        this.props = props;
        this.i18n = i18n;
        this.validate = validate;
        this.shouldValidate = shouldValidate;
        this.isInError = ref(false);
        this.isRequired = ref(false);
        this.isFormValidating = ref(false);
        this.holdValidation = false;
        this.validation = props.validation;
        if (this.validation) {
            this.registerFormInputValidator();
            this.init();
        }
    }
    hasValidationError() {
        return !!this.validation.firstErrorMessage && !this.holdValidation;
    }
    getValidationMessage() {
        return this.translate(this.validation.firstErrorMessage || '') || '';
    }
    revalidate() {
        if (this.shouldValidate && this.shouldValidate() && this.validate) {
            this.validate(true);
        }
    }
    init() {
        this.addWatchers();
    }
    addWatchers() {
        watch(() => this.validation.firstErrorMessage, () => this.revalidate());
        watch(() => this.validation.required, () => {
            this.isRequired.value = !!this.validation.required;
        });
        if (this.props.holdValidation !== undefined) {
            watch([() => this.props.holdValidation, () => this.isFormValidating.value], () => {
                this.holdValidation = !!this.props.holdValidation && !this.isFormValidating.value;
                this.revalidate();
            });
        }
    }
    translate(message) {
        if (!message.startsWith('t:')) {
            if (message.startsWith('t.')) {
                logWarning(`Incorrect translation key format: ${message}. Instead, use notation: t:${message.substring(2)}`);
            }
            return message;
        }
        message = message.substr(2);
        if (this.validation.fieldName && message.startsWith('errorMessages.')) {
            const withFieldName = `${message.substr(0, 14)}${this.validation.fieldName}.${message.substr(14)}`;
            const result = this.i18n.tRecursiveTry(withFieldName, this.validation);
            if (result) {
                return result;
            }
        }
        return this.i18n.tRecursive(message, this.validation);
    }
    registerFormInputValidator() {
        registerFormInputValidator({
            start: () => {
                this.isFormValidating.value = true;
            },
            end: () => {
                this.isFormValidating.value = false;
            },
            validate: () => {
                return !this.validate || this.validate(true);
            },
        });
    }
}

const groupValidationProviderName = 'groupValidationProvider';

const formsStateManagerKey = 'formsStateManagerKey';

const formIdProvider = 'formIdProvider';

const useParentFormId = () => inject(formIdProvider, null);

const useFormsStateManager = (elementId) => {
    const formsStateManager = inject(formsStateManagerKey, null);
    const parentFormId = useParentFormId();
    const register = (persist = false) => {
        onMounted(() => {
            if (!formsStateManager || !parentFormId) {
                return;
            }
            const { registerElement } = formsStateManager;
            registerElement(parentFormId, elementId, { isDirty: false });
        });
        onBeforeUnmount(() => {
            if (!formsStateManager || !parentFormId || persist) {
                return;
            }
            const { deregisterElement } = formsStateManager;
            deregisterElement(parentFormId, elementId);
        });
    };
    const manualDeregister = () => {
        onBeforeUnmount(() => {
            if (!formsStateManager || !parentFormId) {
                return;
            }
            const { deregisterElement } = formsStateManager;
            deregisterElement(parentFormId, elementId);
        });
    };
    const setDirty = () => {
        if (!formsStateManager || !parentFormId) {
            return;
        }
        const { formsState, updateElement } = formsStateManager;
        if (formsState.value && !formsState.value[parentFormId][elementId].isDirty) {
            updateElement(parentFormId, elementId, { isDirty: true });
        }
    };
    return {
        register,
        manualDeregister,
        setDirty,
    };
};

class UseInput {
    constructor(props, listeners) {
        this.props = props;
        this.listeners = listeners;
        this.errorMessage = ref('');
        this.errorId = ref('');
        this.shouldValidate = ref(false);
        this.isTouched = ref(false);
        this.hasBlurredAtLeastOnce = ref(false);
        this.currentInstance = getCurrentInstance();
        this.hasFocus = ref(false);
        this.groupValidation = reactive({
            hasGroupValidation: false,
            isInError: false,
            hideChildValidationOnError: false,
        });
        this.i18n = useI18n();
        this.internalId = useIdGenerator('p-input').next();
        this.formsStateManagerId = props.formsStateManagerId || this.internalId;
        this.validation = new UseValidation({ validation: props.validation, holdValidation: props.holdValidation }, this.i18n, this.validate.bind(this), () => this.shouldValidate.value);
        this.registerGroupValidator();
        const { register, setDirty } = useFormsStateManager(this.formsStateManagerId);
        this.setDirtyFn = setDirty;
        register(this.props.persistInFormsState);
    }
    setDirty() {
        this.setDirtyFn();
    }
    registerGroupValidator() {
        this.groupValidation = inject(groupValidationProviderName, { hasGroupValidation: false, isInError: false, hideChildValidationOnError: false });
        if (this.groupValidation.setGroupField) {
            this.groupValidation.setGroupField(this.internalId, this.validation.isInError.value);
        }
        watch(() => this.groupValidation.hasGroupValidation ? this.groupValidation.isInError : false, isInError => {
            if (!this.errorMessage.value) {
                this.forceErrorState(isInError);
            }
        });
        onBeforeUnmount(() => {
            if (this.groupValidation.deleteGroupField) {
                this.groupValidation.deleteGroupField(this.internalId);
            }
        });
    }
    validate(force) {
        if (force) {
            this.shouldValidate.value = true;
        }
        this.errorMessage.value = this.shouldValidate.value ? this.validation.getValidationMessage() : '';
        if (!this.groupValidation.hasGroupValidation || !this.groupValidation.isInError) {
            this.forceErrorState(!!this.errorMessage.value);
        }
        if (this.groupValidation.setGroupField && this.groupValidation.validate) {
            this.groupValidation.setGroupField(this.internalId, !!this.errorMessage.value);
            this.groupValidation.validate(force);
        }
        this.currentInstance.$emit('validate');
        return !this.validation.isInError.value;
    }
    forceErrorState(state) {
        this.validation.isInError.value = state;
    }
    onBlur() {
        this.hasFocus.value = false;
        if (this.isTouched.value) {
            Vue$1.nextTick(() => {
                if (this.props.validation.forceValidate) {
                    this.props.validation.forceValidate();
                }
                this.hasBlurredAtLeastOnce.value = true;
                this.validate(true);
            });
        }
    }
    onChange() {
        this.setDirty();
        this.isTouched.value = true;
        this.validate(true);
    }
    onInput() {
        this.setDirty();
        this.isTouched.value = true;
        if (this.groupValidation.validate && this.hasBlurredAtLeastOnce.value) {
            this.groupValidation.validate();
        }
    }
    onFocus() {
        this.hasFocus.value = true;
    }
    getEvents() {
        return {
            input: this.onInput.bind(this),
            blur: this.onBlur.bind(this),
            change: this.onChange.bind(this),
            focus: this.onFocus.bind(this),
        };
    }
    getSlotListeners() {
        // lookup both listeners and new validationEvents and combine them as a single set of listeners
        const validationEvents = this.getEvents();
        const lookupEventsAndTrigger = (eventName, args) => {
            const validationEvent = validationEvents[eventName];
            const listenerEvents = this.listeners[eventName];
            if (listenerEvents) {
                listenerEvents(...args);
            }
            if (validationEvent) {
                validationEvent(...args);
            }
        };
        return Object.assign(Object.assign({}, this.listeners), { change(...args) {
                lookupEventsAndTrigger('change', args);
            },
            input(...args) {
                lookupEventsAndTrigger('input', args);
            },
            focus(...args) {
                lookupEventsAndTrigger('focus', args);
            },
            blur(...args) {
                lookupEventsAndTrigger('blur', args);
            } });
    }
    calculateAriaDescribedBy(errorId) {
        let errorString = null;
        if (this.errorMessage.value) {
            errorString = errorId;
        }
        if (this.groupValidation.hasGroupValidation && this.groupValidation.isInError && this.groupValidation.setAriaDescribedby) {
            errorString = this.groupValidation.errorId || null;
        }
        return errorString;
    }
    getSlotAttrs() {
        const id = this.props.id || this.internalId;
        this.errorId.value = `${id}_error`;
        const slotAttrs = reactive({
            id,
            'data-ui': this.props.dataUi,
            disabled: computed(() => this.props.disabled),
            'aria-disabled': computed(() => this.props.disabled),
            readonly: computed(() => this.props.readonly),
            'aria-readonly': computed(() => this.props.readonly),
            autofocus: this.props.autofocus,
            error: this.validation.isInError,
            'hide-details': true,
            'aria-required': this.validation.isRequired,
            'aria-invalid': computed(() => this.validation.isInError.value),
            'aria-describedby': computed(() => this.calculateAriaDescribedBy(this.errorId.value)),
        });
        watch(() => this.validation.isRequired.value, () => {
            slotAttrs['aria-required'] = this.validation.isRequired.value;
        });
        return slotAttrs;
    }
    getExtractedValidation() {
        if (this.props.extractedValidation) {
            return this.props.extractedValidation;
        }
        return {
            shouldValidate: this.shouldValidate,
            errorMessage: this.errorMessage,
            isRequired: this.validation.isRequired,
            isInError: this.validation.isInError,
            isTouched: this.isTouched,
            validate: this.validate.bind(this),
            hideValidation: computed(() => !!(this.groupValidation.hideChildValidationOnError && this.groupValidation.isInError)),
        };
    }
    extractComposable() {
        return {
            extractedValidation: this.getExtractedValidation(),
            slotAttrs: this.getSlotAttrs(),
            slotListeners: this.getSlotListeners(),
            hasFocus: this.hasFocus,
            errorId: this.errorId,
        };
    }
}

//

var script$$ = {
  name: 'PInputLabel',
  components: { PInfo: __vue_component__$16 },
  props: {
    isRequired: { type: Boolean, default: false },
    label: { type: String, default: null },
    hint: { type: String, default: null },
    info: { type: String, default: null },
  },
};

/* script */
const __vue_script__$$ = script$$;
/* template */
var __vue_render__$10 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-input-label pb-2"},[_c('div',{staticClass:"p-input-label__text-container d-flex"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"ml-1"},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("*")]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("("+_vm._s(_vm.$t('requiredField'))+")")])]):_vm._e(),_vm._v(" "),(_vm.info)?_c('p-info',{attrs:{"linked-label-text":_vm.label,"message":_vm.info}}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v("\n     \n  ")],2),_vm._v(" "),(_vm.hint)?_c('div',{staticClass:"p-input-label__hint font-italic font-weight-regular",domProps:{"textContent":_vm._s(_vm.hint)}}):_vm._e()])};
var __vue_staticRenderFns__$10 = [];

  /* style */
  const __vue_inject_styles__$10 = undefined;
  /* scoped */
  const __vue_scope_id__$10 = undefined;
  /* module identifier */
  const __vue_module_identifier__$10 = undefined;
  /* functional template */
  const __vue_is_functional_template__$10 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$10 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$10, staticRenderFns: __vue_staticRenderFns__$10 },
    __vue_inject_styles__$10,
    __vue_script__$$,
    __vue_scope_id__$10,
    __vue_is_functional_template__$10,
    __vue_module_identifier__$10,
    false,
    undefined,
    undefined,
    undefined
  );

const fieldsetProviderName = 'fieldsetProvider';

var script$_ = defineComponent({
    name: 'PInput',
    components: { VLabel, PInputLabel: __vue_component__$10 },
    props: {
        id: { type: String, default: null },
        formsStateManagerId: { type: String, default: null },
        persistInFormsState: { type: Boolean },
        dataUi: { type: String, default: null },
        label: { type: String, default: null },
        info: { type: String, default: null },
        disabled: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        autofocus: { type: Boolean, default: false },
        hint: { type: String, default: null },
        persistentHint: { type: Boolean, default: false },
        validation: { type: Object, default: () => ({ firstErrorMessage: null }) },
        holdValidation: { type: Boolean, default: false },
        hideDetails: { type: Boolean, default: false },
        inlineLabel: { type: Boolean, default: false },
        suppressChildInputState: { type: Boolean },
        // extractedValidation is a validation object that has already been extracted beforehand,
        extractedValidation: { type: Object, default: undefined },
    },
    setup(props, { slots, listeners }) {
        const hasSlot = useHasSlot(slots);
        const { extractedValidation, slotAttrs, slotListeners, errorId, } = new UseInput(props, listeners).extractComposable();
        const fieldSetConfig = inject(fieldsetProviderName, { visuallyHideLabels: false });
        return Object.assign(Object.assign({}, extractedValidation), { fieldSetConfig,
            hasSlot,
            slotAttrs,
            slotListeners,
            errorId });
    },
});

/* script */
const __vue_script__$_ = script$_;
/* template */
var __vue_render__$$ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['p-input',
           {
             'p-input--error': _vm.isInError,
             'p-input__label--visually-hidden': _vm.fieldSetConfig.visuallyHideLabels,
             'p-input__label--inline': _vm.inlineLabel,
             'p-input__label--hide-details': _vm.hideDetails
           }]},[((_vm.label || _vm.info))?_c('v-label',{attrs:{"focused":_vm.isInError,"color":_vm.isInError ? 'error' : undefined,"disabled":_vm.disabled,"for":_vm.slotAttrs.id,"absolute":_vm.fieldSetConfig.visuallyHideLabels}},[_c('p-input-label',{attrs:{"label":_vm.label,"info":_vm.info,"hint":_vm.hint,"is-required":_vm.isRequired}},[_vm._t("post-label-input")],2)],1):_vm._e(),_vm._v(" "),_vm._t("default",null,{"on":_vm.slotListeners,"attrs":_vm.slotAttrs,"min":_vm.validation.minValue,"max":_vm.validation.maxValue,"maxlength":_vm.validation.maxLength,"required":_vm.validation.required,"isInError":_vm.isInError,"errorMessage":_vm.errorMessage}),_vm._v(" "),(!_vm.hideDetails)?_c('div',{class:['p-input__error-container', !_vm.hideValidation || _vm.hasSlot('error-message') ? 'mb-4 mt-2': ''],attrs:{"aria-live":"assertive","aria-atomic":"true"}},[(!_vm.hideValidation || _vm.hasSlot('error-message'))?_c('div',{staticClass:"v-messages theme--light"},[_vm._t("error-message",function(){return [(_vm.errorMessage)?_c('div',{staticClass:"p-input__error v-messages__message error--text",attrs:{"id":_vm.errorId}},[_vm._v("\n          "+_vm._s(_vm.errorMessage)+"\n        ")]):_vm._e()]})],2):_vm._e()]):_vm._e()],2)};
var __vue_staticRenderFns__$$ = [];

  /* style */
  const __vue_inject_styles__$$ = undefined;
  /* scoped */
  const __vue_scope_id__$$ = "data-v-883798e6";
  /* module identifier */
  const __vue_module_identifier__$$ = undefined;
  /* functional template */
  const __vue_is_functional_template__$$ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$$ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$$, staticRenderFns: __vue_staticRenderFns__$$ },
    __vue_inject_styles__$$,
    __vue_script__$_,
    __vue_scope_id__$$,
    __vue_is_functional_template__$$,
    __vue_module_identifier__$$,
    false,
    undefined,
    undefined,
    undefined
  );

const isElementInView = (element) => {
    const bounding = element.getBoundingClientRect();
    return (bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <=
            (window.innerWidth || document.documentElement.clientWidth));
};
const isScrollable = (element) => element && element.clientHeight < element.scrollHeight;
const maintainScrollVisibility = (activeElement, scrollParent) => {
    const { offsetHeight, offsetTop } = activeElement;
    const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent;
    const isAbove = offsetTop < scrollTop;
    const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
    if (isAbove) {
        scrollParent.scrollTo(0, offsetTop);
    }
    else if (isBelow) {
        scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
    }
};

const usePSelectOpenState = (comboboxElement, setSelectState, defaultOpen = false) => {
    const isOpen = ref(defaultOpen);
    const setOpenState = (open, callFocus = true) => {
        if (isOpen.value === open) {
            return;
        }
        isOpen.value = open;
        if (comboboxElement.value) {
            if (!open && !isElementInView(comboboxElement.value)) {
                comboboxElement.value.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
            callFocus && comboboxElement.value.focus();
        }
    };
    return {
        isOpen, setOpenState,
    };
};

const pageSize = 10;
const SelectActions = {
    Close: 0,
    CloseSelect: 1,
    First: 2,
    Last: 3,
    Next: 4,
    Open: 5,
    PageDown: 6,
    PageUp: 7,
    Previous: 8,
    Select: 9,
    Type: 10,
};

const filterOptions = (filter, options = [], exclude = []) => options.filter((option) => {
    const matches = option.text.toLowerCase().indexOf(filter.toLowerCase()) === 0;
    return matches && exclude.indexOf(option) < 0;
});
const checkOpenKeys = (event) => {
    const { key } = event;
    const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' '];
    if (openKeys.includes(key)) {
        return SelectActions.Open;
    }
    return null;
};
const checkHomeEndKeys = (event) => {
    const { key } = event;
    if (key === 'Home') {
        return SelectActions.First;
    }
    if (key === 'End') {
        return SelectActions.Last;
    }
    return null;
};
const checkIfTyping = (event) => {
    const { key, altKey, ctrlKey, metaKey } = event;
    if (key === 'Backspace' ||
        key === 'Clear' ||
        (key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey)) {
        return SelectActions.Type;
    }
    return null;
};
const checkArrowKeys = (event) => {
    const { key, altKey } = event;
    if (key === 'ArrowDown') {
        return SelectActions.Next;
    }
    else if (key === 'ArrowUp' && !altKey) {
        return SelectActions.Previous;
    }
    return null;
};
const checkPageUpPageDown = (event) => {
    const { key } = event;
    if (key === 'PageUp') {
        return SelectActions.PageUp;
    }
    else if (key === 'PageDown') {
        return SelectActions.PageDown;
    }
    return null;
};
const checkCloseKeys = (event) => {
    const { key, altKey } = event;
    if (key === 'ArrowUp' && altKey) {
        return SelectActions.CloseSelect;
    }
    else if (key === 'Escape') {
        return SelectActions.Close;
    }
    else if (key === 'Enter' || key === ' ') {
        return SelectActions.CloseSelect;
    }
    return null;
};
const getActionFromKey = (event, menuOpen) => {
    let action = null;
    if (!menuOpen) {
        action = checkOpenKeys(event);
    }
    action = action || checkHomeEndKeys(event) || checkIfTyping(event);
    if (menuOpen) {
        action = action || checkArrowKeys(event);
        action = action || checkPageUpPageDown(event);
        action = action || checkCloseKeys(event);
    }
    return action;
};
const getIndexByLetter = (options, filter, startIndex = 0) => {
    const orderedOptions = [
        ...options.slice(startIndex),
        ...options.slice(0, startIndex),
    ];
    const firstMatch = filterOptions(filter, orderedOptions)[0];
    const allSameLetter = (array) => array.every((letter) => letter === array[0]);
    if (firstMatch) {
        return options.indexOf(firstMatch);
    }
    else if (allSameLetter(filter.split(''))) {
        const matches = filterOptions(filter[0], orderedOptions);
        return options.indexOf(matches[0]);
    }
    else {
        return -1;
    }
};
const getUpdatedIndex = (currentIndex, maxIndex, action) => {
    switch (action) {
        case SelectActions.First:
            return 0;
        case SelectActions.Last:
            return maxIndex;
        case SelectActions.Previous:
            return Math.max(0, currentIndex - 1);
        case SelectActions.Next:
            return Math.min(maxIndex, currentIndex + 1);
        case SelectActions.PageUp:
            return Math.max(0, currentIndex - pageSize);
        case SelectActions.PageDown:
            return Math.min(maxIndex, currentIndex + pageSize);
        default:
            return currentIndex;
    }
};

const usePSelectHandlers = (selectOptions, isOpen, activeIndex, collectedStateSetters) => {
    const searchTimeout = ref(undefined);
    const searchString = ref('');
    const ignoreBlur = ref(false);
    const { setOpenState, selectOption, changeOption } = collectedStateSetters;
    const getSearchString = (char) => {
        // reset typing timeout and start new timeout
        // this allows us to make multiple-letter matches, like a native select
        window.clearTimeout(searchTimeout.value);
        searchTimeout.value = window.setTimeout(() => {
            searchString.value = '';
        }, 500);
        // add most recent letter to saved search string
        searchString.value += char;
        return searchString.value;
    };
    const onComboType = (letter) => {
        setOpenState(true);
        const search = getSearchString(letter);
        const searchIndex = getIndexByLetter(selectOptions.value, search, activeIndex.value + 1);
        if (searchIndex >= 0) {
            changeOption(searchIndex);
        }
        else {
            clearTimeout(searchTimeout.value);
            searchString.value = '';
        }
    };
    const preventAndChangeOption = (event, index, max, action) => {
        event.preventDefault();
        changeOption(getUpdatedIndex(index, max, action));
    };
    const preventAndUpdateMenu = (event, openMenu) => {
        event.preventDefault();
        setOpenState(openMenu);
    };
    const onComboKeyDownHandler = (event) => {
        const { key } = event;
        const max = selectOptions.value.length - 1;
        const action = getActionFromKey(event, isOpen.value);
        if (action == null) {
            return;
        }
        const actionMapper = {
            [SelectActions.Last]: () => {
                setOpenState(true);
                preventAndChangeOption(event, activeIndex.value, max, action);
            },
            [SelectActions.First]: () => {
                setOpenState(true);
                preventAndChangeOption(event, activeIndex.value, max, action);
            },
            [SelectActions.Next]: () => preventAndChangeOption(event, activeIndex.value, max, action),
            [SelectActions.Previous]: () => preventAndChangeOption(event, activeIndex.value, max, action),
            [SelectActions.PageUp]: () => preventAndChangeOption(event, activeIndex.value, max, action),
            [SelectActions.PageDown]: () => preventAndChangeOption(event, activeIndex.value, max, action),
            [SelectActions.CloseSelect]: () => {
                preventAndUpdateMenu(event, false);
                selectOption(activeIndex.value);
            },
            [SelectActions.Close]: () => preventAndUpdateMenu(event, false),
            [SelectActions.Type]: () => onComboType(key),
            [SelectActions.Open]: () => preventAndUpdateMenu(event, true),
        };
        actionMapper[action]();
    };
    const onOptionClickHandler = (index) => {
        changeOption(index);
        selectOption(index);
        setOpenState(false);
    };
    const onComboClickHandler = () => {
        setOpenState(!isOpen.value, false);
    };
    const onComboBlurHandler = () => {
        if (ignoreBlur.value) {
            ignoreBlur.value = false;
            return;
        }
        if (isOpen.value) {
            selectOption(activeIndex.value);
            setOpenState(false, false);
        }
    };
    const onOptionMouseDownHandler = () => {
        // Clicking an option will cause a blur event,
        // but we don't want to perform the default keyboard blur action
        ignoreBlur.value = true;
    };
    return {
        onComboKeyDownHandler,
        onOptionClickHandler,
        onComboClickHandler,
        onComboBlurHandler,
        onOptionMouseDownHandler,
    };
};

const usePSelectOptions = (options, defaultOption) => computed(() => (defaultOption.value
    ? [{ text: defaultOption.value, isDefaultOption: true }, ...options.value]
    : options.value).map((item) => {
    if (typeof item === 'string') {
        return {
            text: item,
            value: item,
        };
    }
    else {
        return Object.assign(Object.assign({}, item), { value: (item.value || item.value === 0) ? item.value : item.text });
    }
}));

const handleItemScroll = (listboxElement, index) => {
    const optionElements = listboxElement.querySelectorAll('[role=option]');
    if (isScrollable(listboxElement)) {
        maintainScrollVisibility(optionElements[index], listboxElement);
    }
    if (!isElementInView(optionElements[index])) {
        optionElements[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
};
const usePSelectOptionSetters = (options, setSelectState, listboxElement, emitFn) => {
    const selectOption = (index) => {
        if (!options.value[index]) {
            return;
        }
        setSelectState({
            activeIndex: index,
            selectedIndex: index,
            selectedText: options.value[index].text,
        });
        emitFn('input', options.value[index].isDefaultOption ? null : options.value[index].value);
    };
    const changeOption = (index) => {
        setSelectState({
            activeIndex: index,
        });
        Vue$1.nextTick(() => {
            if (listboxElement.value) {
                handleItemScroll(listboxElement.value, index);
            }
        });
    };
    return {
        selectOption,
        changeOption,
    };
};

var script$Z = defineComponent({
    name: 'PSelectCore',
    inheritAttrs: false,
    props: {
        value: { type: [String, Number], default: null },
        options: { type: Array, required: true },
        defaultOption: { type: String, default: '' },
        id: { type: String, default: '' },
        ariaRequired: { type: Boolean },
        ariaInvalid: { type: Boolean },
        ariaDescribedby: { type: String, default: null },
        ariaLabelledby: { type: String, default: null },
        dataUi: { type: String, default: null },
    },
    setup(props, { emit }) {
        const baseId = props.id || useIdGenerator('p-select').next();
        const listboxId = useIdGenerator('p-select-listbox').next();
        const comboboxElement = ref(null);
        const listboxElement = ref(null);
        const { options, value: valueProp, defaultOption } = toRefs(props);
        const selectOptions = usePSelectOptions(options, defaultOption);
        const { state, setState } = useState({
            activeIndex: 0,
            selectedIndex: 0,
            selectedText: selectOptions.value[0].text,
        });
        const { isOpen, setOpenState } = usePSelectOpenState(comboboxElement);
        const { selectOption, changeOption } = usePSelectOptionSetters(selectOptions, setState, listboxElement, emit);
        const collectedStateSetters = { setOpenState, setState, selectOption, changeOption };
        watch(() => valueProp.value, (val) => {
            const index = selectOptions.value.findIndex((option) => {
                return option.value === val;
            });
            const newIndex = Math.max(0, index);
            if (newIndex === state.selectedIndex.value &&
                state.selectedText.value === selectOptions.value[newIndex].text) {
                return;
            }
            setState({
                activeIndex: newIndex,
                selectedIndex: newIndex,
                selectedText: selectOptions.value[newIndex].text,
            });
        });
        onMounted(() => {
            if (!valueProp.value && !defaultOption.value) {
                emit('input-default', selectOptions.value[0].value);
            }
        });
        return Object.assign(Object.assign(Object.assign({ comboboxElement,
            listboxElement,
            listboxId,
            isOpen }, state), { baseId,
            selectOptions }), usePSelectHandlers(selectOptions, isOpen, state.activeIndex, collectedStateSetters));
    },
});

/* script */
const __vue_script__$Z = script$Z;
/* template */
var __vue_render__$_ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['p-select', {'p-select--open': _vm.isOpen}]},[_c('div',_vm._g(_vm._b({ref:"comboboxElement",staticClass:"p-select__input",attrs:{"id":_vm.baseId,"data-ui":_vm.dataUi,"role":"combobox","tabindex":"0","aria-controls":_vm.listboxId,"aria-expanded":_vm.isOpen.toString(),"aria-haspopup":"listbox","aria-required":_vm.ariaRequired,"aria-invalid":_vm.ariaInvalid,"aria-describedby":_vm.ariaDescribedby,"aria-labelledby":_vm.ariaLabelledby,"aria-activedescendant":_vm.isOpen ? (_vm.baseId + "-option-" + _vm.activeIndex) : ''},on:{"click":_vm.onComboClickHandler,"keydown":_vm.onComboKeyDownHandler,"blur":_vm.onComboBlurHandler}},'div',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n    "+_vm._s(_vm.selectedText)+"\n  ")]),_vm._v(" "),_c('div',{ref:"listboxElement",staticClass:"p-select__menu",attrs:{"role":"listbox","id":_vm.listboxId,"aria-labelledby":_vm.ariaLabelledby,"tabindex":"-1"}},_vm._l((_vm.selectOptions),function(option,index){return _c('div',{key:option.text,class:['p-select__option',{'p-select_option--current': _vm.activeIndex === index, 'p-select_option--default':option.isDefaultOption}],attrs:{"data-ui":_vm.dataUi ? (_vm.dataUi + "-" + (option.isDefaultOption ? 'default-option' : option.value || option.text)) : undefined,"id":(_vm.baseId + "-option-" + index),"role":"option","aria-selected":(_vm.selectedIndex === index).toString()},on:{"click":function($event){$event.preventDefault();return _vm.onOptionClickHandler(index)},"mousedown":_vm.onOptionMouseDownHandler}},[_c('span',{attrs:{"data-ui":"p-select-option-title"}},[_vm._v("\n        "+_vm._s(option.text)+"\n      ")]),_vm._v(" "),(option.subtitle)?_c('span',{staticClass:"p-select__option__subtitle",attrs:{"data-ui":"p-select-option-subtitle"}},[_vm._v(_vm._s(option.subtitle))]):_vm._e()])}),0)])};
var __vue_staticRenderFns__$_ = [];

  /* style */
  const __vue_inject_styles__$_ = undefined;
  /* scoped */
  const __vue_scope_id__$_ = "data-v-4ae0cea8";
  /* module identifier */
  const __vue_module_identifier__$_ = undefined;
  /* functional template */
  const __vue_is_functional_template__$_ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$_ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$_, staticRenderFns: __vue_staticRenderFns__$_ },
    __vue_inject_styles__$_,
    __vue_script__$Z,
    __vue_scope_id__$_,
    __vue_is_functional_template__$_,
    __vue_module_identifier__$_,
    false,
    undefined,
    undefined,
    undefined
  );

var script$Y = defineComponent({
    name: 'PSelect',
    components: { PInput: __vue_component__$$, PSelectCore: __vue_component__$_ },
    props: {
        value: { type: [String, Number], default: null },
        label: { type: String, default: null },
        options: { type: Array, required: true },
        defaultOption: { type: String, default: '' },
        id: { type: String, default: '' },
        dataUi: { type: String, default: null },
        info: { type: String, default: null },
        hint: { type: String, default: null },
        hideDetails: { type: Boolean, default: false },
        inlineLabel: { type: Boolean, default: false },
        validation: { type: Object, default: () => ({ firstErrorMessage: null }) },
        ariaLabelledby: { type: String, default: '' },
        focus: { type: [String, Array], default: 'dark' },
    },
    setup(props, { emit }) {
        const internalId = useIdGenerator('p-select').next();
        const ariaSelect = ref(null);
        const labelId = ref('');
        const customFocus = useCustomFocus(props.focus);
        const onDefaultValueSelectedHandler = (value) => {
            emit('input', value);
        };
        onMounted(() => {
            if (props.label && props.ariaLabelledby) {
                logError('P-Select with both label and aria-labelledby props detected. Select the correct label for the element and remove the other prop.');
                return;
            }
            if (!props.label && !props.ariaLabelledby) {
                logError('P-Select without valid label detected. Please label the component with either the label or aria-labelledby props');
                return;
            }
            // This is required as, without a reimplementation, the label inside PInput cannot
            // accept an id prop value. This is a Vuetify limitation and therefore this code should
            // be removed if v-label is ever removed from PInput.
            if (ariaSelect.value && ariaSelect.value.$el) {
                let labelElement;
                if (props.ariaLabelledby) {
                    labelElement = document.querySelector(`#${props.ariaLabelledby}`);
                }
                else {
                    labelElement = ariaSelect.value.$el.querySelector('label');
                    if (labelElement) {
                        labelId.value = `${labelElement.getAttribute('for')}-label`;
                        labelElement.setAttribute('id', labelId.value);
                        labelElement.removeAttribute('for');
                    }
                }
                if (!labelElement) {
                    return;
                }
                labelElement.addEventListener('click', (e) => {
                    // Focus combobox on label click. This is standard functionality when using
                    // for-id to link a label. Which cannot be done here.
                    e.preventDefault();
                    ariaSelect.value.$el.querySelector('[role="combobox"]').focus();
                });
            }
        });
        return {
            ariaSelect,
            labelId,
            customFocus,
            onDefaultValueSelectedHandler,
            internalId,
        };
    },
});

/* script */
const __vue_script__$Y = script$Y;

/* template */
var __vue_render__$Z = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-input',_vm._g({ref:"ariaSelect",staticClass:"p-select__container",style:(_vm.customFocus),attrs:{"id":_vm.id,"data-ui":_vm.dataUi,"label":_vm.label,"info":_vm.info,"validation":_vm.validation,"hide-details":_vm.hideDetails,"hint":_vm.hint,"inline-label":_vm.inlineLabel,"forms-state-manager-id":_vm.internalId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs; if ( attrs === void 0 ) attrs = {};
return [_c('p-select-core',_vm._g({class:[
        'input-control',
        ("p-focus-" + (_vm.customFocus ? 'custom' : _vm.focus))
      ],attrs:{"id":attrs.id,"aria-required":attrs['aria-required'],"aria-invalid":attrs['aria-invalid'],"aria-describedby":attrs['aria-describedby'],"aria-labelledby":_vm.ariaLabelledby || _vm.labelId,"options":_vm.options,"default-option":_vm.defaultOption,"value":_vm.value,"data-ui":attrs['data-ui']},on:{"input-default":_vm.onDefaultValueSelectedHandler}},on))]}},{key:"post-label-input",fn:function(){return [_vm._t("label-info")]},proxy:true}],null,true)},_vm.$listeners))};
var __vue_staticRenderFns__$Z = [];

  /* style */
  const __vue_inject_styles__$Z = undefined;
  /* scoped */
  const __vue_scope_id__$Z = undefined;
  /* module identifier */
  const __vue_module_identifier__$Z = undefined;
  /* functional template */
  const __vue_is_functional_template__$Z = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Z = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$Z, staticRenderFns: __vue_staticRenderFns__$Z },
    __vue_inject_styles__$Z,
    __vue_script__$Y,
    __vue_scope_id__$Z,
    __vue_is_functional_template__$Z,
    __vue_module_identifier__$Z,
    false,
    undefined,
    undefined,
    undefined
  );

var i18n$7 = {
    messages: {
        nl: {
            placeholder: 'Zoeken',
        },
    },
};

var script$X = defineComponent({
    name: 'PSearch',
    components: { VTextField, PInput: __vue_component__$$ },
    i18n: i18n$7,
    props: {
        id: { type: String, default: undefined },
        value: { type: [String, Number, Boolean], default: undefined },
        autofocus: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        dataUi: { type: String, default: null },
        clearable: { type: Boolean, default: false },
        placeholder: { type: String, default: '' },
        debounceTimeout: { type: Number, default: 200 },
        focus: { type: [String, Array], default: 'dark' },
    },
    setup(props, { emit }) {
        const internalId = useIdGenerator('p-search').next();
        const searchValue = ref(props.value);
        const customFocus = useCustomFocus(props.focus);
        let debounce = null;
        const handleInput = (payload) => {
            clearTimeout(debounce);
            debounce = setTimeout(() => {
                emit('input-debounced', payload);
            }, props.debounceTimeout);
        };
        const { t } = useI18n();
        const inputPlaceholder = props.placeholder || t('placeholder');
        return {
            searchValue,
            handleInput,
            inputPlaceholder,
            customFocus,
            internalId,
        };
    },
});

/* script */
const __vue_script__$X = script$X;
/* template */
var __vue_render__$Y = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-input',_vm._g({class:[
    'p-search',
    ("p-focus-" + (_vm.customFocus ? 'custom' : _vm.focus))
  ],style:(_vm.customFocus),attrs:{"id":_vm.id,"data-ui":_vm.dataUi,"disabled":_vm.disabled,"readonly":_vm.readonly,"autofocus":_vm.autofocus,"hide-details":"","forms-state-manager-id":_vm.internalId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var on = ref.on;
  var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"outlined":"","single-line":"","append-icon":"$icon-zoeken","type":"text","placeholder":_vm.inputPlaceholder,"clearable":_vm.clearable,"aria-label":"Zoeken"},on:{"input":_vm.handleInput},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v;},expression:"searchValue"}},'v-text-field',attrs,false),on))]}}])},_vm.$listeners))};
var __vue_staticRenderFns__$Y = [];

  /* style */
  const __vue_inject_styles__$Y = undefined;
  /* scoped */
  const __vue_scope_id__$Y = "data-v-6fee77c6";
  /* module identifier */
  const __vue_module_identifier__$Y = undefined;
  /* functional template */
  const __vue_is_functional_template__$Y = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Y = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$Y, staticRenderFns: __vue_staticRenderFns__$Y },
    __vue_inject_styles__$Y,
    __vue_script__$X,
    __vue_scope_id__$Y,
    __vue_is_functional_template__$Y,
    __vue_module_identifier__$Y,
    false,
    undefined,
    undefined,
    undefined
  );

var i18n$6 = {
    messages: {
        nl: {
            openFilterOptions: 'Open filteropties',
            closeFilterOptions: 'Sluit filteropties',
            descriptionFilters: 'Als u een filter kiest worden de zoekresultaten direct bijgewerkt.',
            descriptionSearch: 'Zoek bijvoorbeeld op een maand of bedrag.',
        },
    },
};

var script$W = defineComponent({
    name: 'PFilters',
    components: { PContainer: __vue_component__$11, PSelect: __vue_component__$Z, PButton: __vue_component__$1f, PSearch: __vue_component__$Y },
    i18n: i18n$6,
    props: {
        id: { type: String, default: '' },
        filters: { type: Array, default: () => [] },
        search: { type: String, default: null },
        searchEnabled: { type: Boolean, default: false },
        oneLine: { type: Boolean, default: false },
        inlineLabels: { type: Boolean, default: false },
        maxColumns: { type: Number, default: maxColumnsDefault },
        descriptions: { type: Object, default: undefined },
        showToggler: { type: Boolean, default: true },
        dataUi: { type: String, default: null },
    },
    setup(props, { slots, emit }) {
        const hasSlot = useHasSlot(slots);
        const filtersId = props.id || useIdGenerator('p-filters').next();
        const { filters: filterSelects, search: searchValue } = toRefs(props);
        const { isMobileOrTabletView } = useBreakpoints();
        const { state, setState } = useState({
            filters: [],
            search: null,
            open: false,
        });
        const showFiltersList = computed(() => {
            return (state.open.value || !isMobileOrTabletView.value || props.oneLine || !props.showToggler || props.filters.length === 1);
        });
        const showDescriptions = computed(() => {
            return {
                filters: filterSelects.value.length && descriptionFilters !== '' && (state.open.value || !isMobileOrTabletView.value || props.oneLine),
                search: props.searchEnabled && descriptionSearch !== '',
            };
        });
        const computedMaxColumns = computed(() => {
            const maxColumnsMultiLine = props.inlineLabels && props.maxColumns > maxColumnsInlineLabels ? maxColumnsInlineLabels : props.maxColumns;
            return props.oneLine ? maxColumnsOneline : maxColumnsMultiLine;
        });
        const { t } = useI18n();
        let descriptionFilters = t('descriptionFilters');
        let descriptionSearch = t('descriptionSearch');
        if (props.descriptions) {
            descriptionFilters = props.descriptions.filters !== undefined ? props.descriptions.filters : descriptionFilters;
            descriptionSearch = props.descriptions.search !== undefined ? props.descriptions.search : descriptionSearch;
        }
        if (props.oneLine && !props.searchEnabled) {
            logWarning('OneLine prop is set, but search is not enabled. This layout is optimized to show the search field on the right.');
        }
        const onInputHandler = (val, index) => {
            setState({
                filters: state.filters.value.map((filter, i) => {
                    if (i !== index) {
                        return filter;
                    }
                    return Object.assign(Object.assign({}, filter), { selected: val });
                }),
            });
            emit('input', {
                filters: state.filters.value,
                search: state.search.value,
            });
        };
        const onSearchHandler = (val) => {
            setState({ search: val });
            emit('input', {
                filters: state.filters.value,
                search: state.search.value,
            });
        };
        const onToggleHandler = () => {
            setState({ open: !state.open.value });
        };
        watch(() => searchValue.value, (newSearch) => {
            setState({ search: newSearch });
        });
        watch(() => filterSelects.value, (newFilters) => {
            setState({ filters: newFilters ? newFilters.map(({ id, label, selected }) => ({ id, label, selected })) : [] });
        });
        return {
            filtersId,
            filterSelects,
            descriptionFilters,
            descriptionSearch,
            showFiltersList,
            showDescriptions,
            computedMaxColumns,
            isMobileOrTabletView,
            filtersState: state.filters,
            searchState: state.search,
            openState: state.open,
            hasSlot,
            onInputHandler,
            onSearchHandler,
            onToggleHandler,
        };
    },
});

/* script */
const __vue_script__$W = script$W;
/* template */
var __vue_render__$X = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filterSelects.length > 0 || _vm.searchEnabled)?_c('div',{class:['p-filters', {'p-filters--one-line': _vm.oneLine}],attrs:{"data-ui":_vm.dataUi || _vm.filtersId}},[(_vm.showToggler && !_vm.oneLine && _vm.isMobileOrTabletView && _vm.filters.length > 1)?_c('p-container',{staticClass:"px-0 p-filters__toggler",attrs:{"fluid":""}},[_c('p-button',{attrs:{"small":"","preset":_vm.openState ? 'up' : 'down',"aria-controls":(_vm.filtersId + "-list"),"aria-expanded":_vm.openState,"data-ui":((_vm.dataUi || _vm.filtersId) + "-toggler")},on:{"click":function($event){return _vm.onToggleHandler()}}},[_vm._v("\n      "+_vm._s(_vm.$t(_vm.openState ? 'closeFilterOptions' : 'openFilterOptions'))+"\n    ")])],1):_vm._e(),_vm._v(" "),_c('p-container',{staticClass:"px-0 p-filters__grid",attrs:{"fluid":""}},[_c('div',{class:['p-filters__list', ("p-filters__list--max-col-" + _vm.computedMaxColumns)],attrs:{"id":(_vm.filtersId + "-list"),"data-ui":((_vm.dataUi || _vm.filtersId) + "-filters"),"role":"group","aria-labelledby":(_vm.filtersId + "-list-desc")}},[(_vm.showFiltersList)?[_vm._t("filters-list",function(){return _vm._l((_vm.filterSelects),function(filter,index){return _c('p-select',{key:filter.id || index,attrs:{"id":filter.id,"label":filter.label,"value":_vm.filtersState[index].selected || filter.selected,"inline-label":_vm.oneLine || _vm.inlineLabels || filter.inlineLabel,"info":filter.info,"options":filter.options,"default-option":filter.defaultOption,"hide-details":""},on:{"input":function($event){return _vm.onInputHandler($event, index)}},scopedSlots:_vm._u([(_vm.hasSlot(("filter-info-" + (filter.id))))?{key:"label-info",fn:function(){return [_vm._t(("filter-info-" + (filter.id)))]},proxy:true}:null],null,true)})})})]:_vm._e()],2),_vm._v(" "),(_vm.showDescriptions.filters)?_c('div',{staticClass:"pb-4 p-filters__description p-filters__description--filters",attrs:{"id":(_vm.filtersId + "-list-desc")}},[_c('span',{staticClass:"sr-only"},[_vm._v("Overzicht filters: ")]),_vm._v("\n      "+_vm._s(_vm.descriptionFilters)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('div',{staticClass:"p-filters__search",attrs:{"role":"group","aria-labelledby":(_vm.filtersId + "-search-desc")}},[_vm._t("filters-search",function(){return [_c('p-search',{attrs:{"value":_vm.searchState,"clearable":"","data-ui":((_vm.dataUi || _vm.filtersId) + "-search")},on:{"input-debounced":_vm.onSearchHandler}})]})],2):_vm._e(),_vm._v(" "),(_vm.showDescriptions.search)?_c('div',{staticClass:"p-filters__description p-filters__description--search",attrs:{"id":(_vm.filtersId + "-search-desc")}},[_c('span',{staticClass:"sr-only"},[_vm._v("Zoekfilter: ")]),_vm._v("\n      "+_vm._s(_vm.descriptionSearch)+"\n    ")]):_vm._e()])],1):_vm._e()};
var __vue_staticRenderFns__$X = [];

  /* style */
  const __vue_inject_styles__$X = undefined;
  /* scoped */
  const __vue_scope_id__$X = "data-v-62253fbd";
  /* module identifier */
  const __vue_module_identifier__$X = undefined;
  /* functional template */
  const __vue_is_functional_template__$X = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$X = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$X, staticRenderFns: __vue_staticRenderFns__$X },
    __vue_inject_styles__$X,
    __vue_script__$W,
    __vue_scope_id__$X,
    __vue_is_functional_template__$X,
    __vue_module_identifier__$X,
    false,
    undefined,
    undefined,
    undefined
  );

var i18n$5 = {
    messages: {
        nl: {
            amountRows: 'Aantal rijen',
            shownResults: 'Resultaten {shownEntries} van de {total}',
            unfilteredResults: 'Er zijn geen {itemTypes} gevonden | Er is {filteredLength} {itemTypes} gevonden. | Er zijn {filteredLength} {itemTypes} gevonden.',
            filteredResults: 'Er zijn geen {itemTypes} die voldoen aan uw filters. | Er is {filteredLength} {itemTypes} die voldoet aan uw filters. | Er zijn {filteredLength} ' +
                '{itemTypes} die voldoen aan uw filters.',
            aria: {
                selectAsc: '{field}: activeer om oplopend te sorteren',
                selectDesc: '{field}: activeer om aflopend te sorteren',
            },
            noData: 'Geen gegevens beschikbaar',
            noFilterData: 'Geen resultaten gevonden',
            sort: 'Sorteren op',
            sortDirection: {
                label: 'Sorteervolgorde',
                ascending: 'Oplopend',
                descending: 'Aflopend',
            },
        },
    },
};

const sortingDirection = {
    ascending: 'asc',
    descending: 'desc',
};
const itemsPerPageChoices = [20, 50, 100];
const itemsPerPage = 20;
const showAll = -1;

class UseDataTable {
    constructor(props) {
        this.props = props;
        this.customSorter = ref(null);
        this.sortOptions = ref({});
        if (props.defaultSort) {
            this.sortOptions.value = { value: props.defaultSort, order: false };
        }
        this.itemLength = computed(() => isRef(props.data.items) ? props.data.items.value.length : props.data.items.length);
        this.filteredLength = ref(this.itemLength);
        this.pageOptions = reactive({
            page: 1,
            pageCount: 0,
            itemsPerPage: props.itemsPerPage,
            itemsPerPageChoices: computed(() => {
                return [...props.itemsPerPageChoices.filter((_v, key, arr) => (arr[key - 1] || 0) <= this.itemLength.value), showAll].map((c) => ({
                    text: c >= 0 ? c.toString() : 'Alles',
                    value: c,
                }));
            }),
        });
        this.shownEntries = computed(() => {
            const first = (this.pageOptions.itemsPerPage * this.pageOptions.page) - (this.pageOptions.itemsPerPage - 1);
            const last = this.pageOptions.itemsPerPage * this.pageOptions.page;
            return `${first} - ${last > this.itemLength.value || last < 0 ? this.itemLength.value : last}`;
        });
        this.toggleSort = this.toggleSort.bind(this);
    }
    toggleSort(propName, forceOrder) {
        const selectedHeader = this.props.data.headers.find(h => h.value === propName);
        if (selectedHeader && selectedHeader.sortCustom) {
            this.customSorter.value = selectedHeader.sortCustom;
        }
        else {
            this.customSorter.value = null;
        }
        const setSortingOrder = () => {
            if (typeof forceOrder === 'boolean') {
                return forceOrder;
            }
            return isOtherColumn ? false : !this.sortOptions.value.order;
        };
        const isOtherColumn = typeof this.sortOptions.value.order === 'undefined' || propName !== this.sortOptions.value.value;
        this.sortOptions.value = { value: propName || '', order: setSortingOrder() };
    }
    extractComposable() {
        return {
            customSorter: this.customSorter,
            sortOptions: this.sortOptions,
            pageOptions: this.pageOptions,
            itemLength: this.itemLength,
            filteredLength: this.filteredLength,
            shownEntries: this.shownEntries,
            toggleSort: this.toggleSort,
        };
    }
    static createMutatableTableOptions(props) {
        const sortOptionsRef = ref(props.sortOptions || {});
        const pageOptionsRef = ref(props.pageOptions || {});
        watch(() => props.sortOptions, (v) => {
            sortOptionsRef.value = v || {};
        });
        watch(() => props.pageOptions, (v) => {
            pageOptionsRef.value = v || {};
        });
        return { sortOptionsRef, pageOptionsRef };
    }
}
function useDataTable(props) {
    return new UseDataTable(props).extractComposable();
}

var script$V = defineComponent({
    name: 'PDataTableDesktop',
    i18n: i18n$5,
    components: { VDataTable, VIcon },
    props: {
        customSorter: { type: Function, default: null },
        tableData: { type: Object, required: true },
        dataUiPrefix: { type: String, default: null },
        sortOptions: { type: Object, default: null },
        pageOptions: { type: Object, default: null },
        disableSort: { type: Boolean, default: false },
        disablePagination: { type: Boolean, default: false },
        hasTableRowListener: { type: Boolean, default: false },
        search: { type: String, default: undefined },
        customFilter: { type: Function, default: undefined },
        noDataText: { type: String, default: undefined },
        noResultsText: { type: String, default: undefined },
    },
    setup(props, { slots, emit }) {
        const hasSlot = useHasSlot(slots);
        const { t } = useI18n();
        const items = computed(() => {
            return isRef(props.tableData.items)
                ? props.tableData.items.value
                : props.tableData.items;
        });
        const { sortOptionsRef, pageOptionsRef } = UseDataTable.createMutatableTableOptions(props);
        const sortRow = (item) => {
            if (!item.sortable) {
                return;
            }
            emit('sort', item.value);
        };
        const sortingAriaLabels = (header, type) => {
            if (props.sortOptions && props.sortOptions.value) {
                const headingNotSelected = props.sortOptions.value !== header.value;
                const label = t((props.sortOptions.order) ? 'aria.selectAsc' : 'aria.selectDesc', { field: header.text });
                if (type === 'sort') {
                    return !headingNotSelected ? { 'aria-sort': props.sortOptions.order ? 'descending' : 'ascending' } : {};
                }
                if (type === 'label') {
                    return label;
                }
            }
            return {};
        };
        const handleRowEnterPress = (item, evt) => {
            if (evt.target && evt.target.tagName === 'TR') {
                emit('table-row-click', item);
            }
        };
        return {
            handleRowEnterPress,
            sortingAriaLabels,
            sortRow,
            hasSlot,
            items,
            sortOptionsRef,
            pageOptionsRef,
        };
    },
});

/* script */
const __vue_script__$V = script$V;
/* template */
var __vue_render__$W = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._b({staticClass:"p-data-table-desktop",attrs:{"hide-default-footer":"","hide-default-header":"","items":_vm.items,"items-per-page":_vm.pageOptions.itemsPerPage,"headers":_vm.tableData.headers,"page":_vm.pageOptionsRef.page,"sort-by":_vm.sortOptionsRef.value,"sort-desc":_vm.sortOptionsRef.order,"disable-pagination":_vm.disablePagination,"search":_vm.search,"custom-filter":_vm.customFilter,"no-data-text":_vm.noDataText || _vm.$t('noData'),"no-results-text":_vm.noResultsText || _vm.$t('noFilterData')},on:{"update:page":function($event){return _vm.$set(_vm.pageOptionsRef, "page", $event)},"update:sortBy":function($event){return _vm.$set(_vm.sortOptionsRef, "value", $event)},"update:sort-by":function($event){return _vm.$set(_vm.sortOptionsRef, "value", $event)},"update:sortDesc":function($event){return _vm.$set(_vm.sortOptionsRef, "order", $event)},"update:sort-desc":function($event){return _vm.$set(_vm.sortOptionsRef, "order", $event)},"page-count":function($event){return _vm.$emit('update-pagecount', $event)},"pagination":function($event){return _vm.$emit('update-pagination', $event)}},scopedSlots:_vm._u([{key:"top",fn:function(){return [_vm._t("top")]},proxy:true},{key:"header",fn:function(){return [_c('thead',[_c('tr',_vm._l((_vm.tableData.headers),function(header){return _c('th',_vm._b({key:header.value,class:[
            'p-data-table-desktop__head',
            'text-start',
            {'sorted-asc': _vm.sortOptionsRef.value === header.value && !_vm.sortOptionsRef.order },
            {'sorted-desc': _vm.sortOptionsRef.value === header.value && _vm.sortOptionsRef.order }
          ],attrs:{"scope":"col","id":("heading_" + (header.value))}},'th',Object.assign({}, (header.sortable ? _vm.sortingAriaLabels(header, 'sort') : {})),false),[_c('div',{staticClass:"p-data-table-desktop__head-container"},[(_vm.disableSort || !header.sortable)?_c('div',{staticClass:"p-data-table-desktop__head--text p-data-table-desktop__head--static",attrs:{"tabindex":header.sortable ? 0 : null}},[_c('span',[_vm._v(_vm._s(header.text))])]):_c('button',{staticClass:"p-data-table-desktop__head--text",attrs:{"aria-describedby":("sort-label-" + (header.value))},on:{"click":function($event){return _vm.sortRow(header)}}},[_c('span',{class:[{'mr-2': header.sortable}]},[_vm._v(_vm._s(header.text))]),_vm._v(" "),(header.sortable)?_c('v-icon',{attrs:{"small":""}},[_vm._v("\n                $icon-pijl-beneden\n              ")]):_vm._e()],1),_vm._v(" "),(header.sortable)?_c('div',{staticClass:"d-none",attrs:{"aria-hidden":"true","id":("sort-label-" + (header.value))}},[_vm._v("\n              "+_vm._s(_vm.sortingAriaLabels(header, 'label'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.hasSlot(("info-" + (header.value))))?_c('div',{staticClass:"p-data-table-desktop__head--info"},[_vm._t(("info-" + (header.value)))],2):_vm._e()])])}),0)])]},proxy:true},{key:"item",fn:function(ref){
          var item = ref.item;
          var index = ref.index;
return [_c('tr',{key:item.id || index,class:[
        'p-data-table-desktop__row',
        {
          'p-data-table-desktop__row--event' : _vm.hasTableRowListener,
          'p-data-table-desktop__row--parent': item.children && item.children.length,
        } ],attrs:{"tabindex":_vm.hasTableRowListener ? 0 : null},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleRowEnterPress(item, $event)},"click":function($event){return _vm.$emit('table-row-click', item)}}},_vm._l((_vm.tableData.headers),function(header,headerIndex){return _c('td',{key:headerIndex,staticClass:"p-data-table-desktop__cell",attrs:{"data-ui":_vm.dataUiPrefix ? _vm.dataUiPrefix + '-' + header.value : null}},[(_vm.hasSlot(header.value))?_vm._t(header.value,null,null,Object.assign({}, item, {item: item})):_c('span',[_vm._v(_vm._s(typeof header.format === 'function' ? header.format(item[header.value]) : item[header.value]))])],2)}),0),_vm._v(" "),_vm._l((item.children),function(child,childIndex){return _c('tr',{key:(index + "-" + childIndex),class:[
        'p-data-table-desktop__row',
        {
          'p-data-table-desktop__row--event' : _vm.hasTableRowListener,
          'p-data-table-desktop__row--child' : childIndex !== item.children.length - 1,
        }
      ],attrs:{"tabindex":_vm.hasTableRowListener ? 0 : null},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleRowEnterPress(item, $event)},"click":function($event){return _vm.$emit('table-row-click', child)}}},_vm._l((_vm.tableData.headers),function(header){return _c('td',{key:header.value,staticClass:"p-data-table-desktop__cell",attrs:{"data-ui":_vm.dataUiPrefix ? _vm.dataUiPrefix + '-' + header.value : null,"data-ui-value":!child[header.value] ? item[header.value] : null}},[(_vm.hasSlot(header.value))?_vm._t(header.value,null,null,Object.assign({}, child, {item: child})):(!child[header.value])?_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(typeof header.format === 'function' ? header.format(item[header.value]) : item[header.value]))]):_c('span',[_vm._v(_vm._s(typeof header.format === 'function' ? header.format(child[header.value]) : child[header.value]))])],2)}),0)})]}}],null,true)},'v-data-table',Object.assign({}, (_vm.customSorter ? {'custom-sort': _vm.customSorter} : {})),false))};
var __vue_staticRenderFns__$W = [];

  /* style */
  const __vue_inject_styles__$W = undefined;
  /* scoped */
  const __vue_scope_id__$W = "data-v-1c754bae";
  /* module identifier */
  const __vue_module_identifier__$W = undefined;
  /* functional template */
  const __vue_is_functional_template__$W = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$W = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$W, staticRenderFns: __vue_staticRenderFns__$W },
    __vue_inject_styles__$W,
    __vue_script__$V,
    __vue_scope_id__$W,
    __vue_is_functional_template__$W,
    __vue_module_identifier__$W,
    false,
    undefined,
    undefined,
    undefined
  );

function sortFunctionality(sortOptions) {
    function onSortBy(v) {
        sortOptions.value.value = v;
    }
    function onSortDesc(direction) {
        sortOptions.value.order = direction === sortingDirection.descending;
    }
    return {
        onSortBy,
        onSortDesc,
    };
}
function useCustomSorter() {
    function getSortHeaders(headers) {
        return headers.filter(head => head.sortable).map(head => ({ text: head.text, value: head.value }));
    }
    return {
        sortFunctionality,
        getSortHeaders,
    };
}

var script$U = defineComponent({
    name: 'PDataTableMobile',
    i18n: i18n$5,
    components: { VDataTable, PSelect: __vue_component__$Z },
    props: {
        dataUiPrefix: { type: String, default: null },
        customSorter: { type: Function, default: null },
        tableData: { type: Object, required: true },
        sortOptions: { type: Object, default: null },
        pageOptions: { type: Object, default: null },
        disableSort: { type: Boolean, default: false },
        disablePagination: { type: Boolean, default: false },
        search: { type: String, default: undefined },
        hasTableRowListener: { type: Boolean, default: false },
        customFilter: { type: Function, default: undefined },
    },
    setup(props, { slots, emit }) {
        const { t } = useI18n();
        const hasSlot = useHasSlot(slots);
        const items = computed(() => {
            return isRef(props.tableData.items)
                ? props.tableData.items.value
                : props.tableData.items;
        });
        const customSorterRef = ref(props.customSorter);
        const sortDirectionArray = [{
                text: t('sortDirection.descending'),
                value: sortingDirection.descending,
            }, {
                text: t('sortDirection.ascending'),
                value: sortingDirection.ascending,
            }];
        const sortDirection = ref(sortingDirection.descending);
        const { sortOptionsRef, pageOptionsRef } = UseDataTable.createMutatableTableOptions(props);
        const { getSortHeaders, sortFunctionality } = useCustomSorter();
        const { onSortDesc, onSortBy } = sortFunctionality(sortOptionsRef);
        const onSortDirectionChange = (direction) => {
            sortDirection.value = direction;
            onSortDesc(direction);
            onSortChange();
        };
        const onSortByChange = (v) => {
            onSortBy(v);
            onSortChange();
        };
        const onSortChange = () => {
            emit('sort', sortOptionsRef.value.value, sortOptionsRef.value.order);
        };
        return {
            hasSlot,
            items,
            sortOptionsRef,
            customSorterRef,
            pageOptionsRef,
            sortDirectionArray,
            sortDirection,
            onSortDirectionChange,
            sortHeaders: getSortHeaders(props.tableData.headers),
            onSortBy: onSortByChange,
        };
    },
});

/* script */
const __vue_script__$U = script$U;
/* template */
var __vue_render__$V = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._b({staticClass:"p-data-table-mobile",class:_vm.hasSlot('top') ? 'has-top' : '',attrs:{"hide-default-footer":"","headers":_vm.tableData.headers,"items":_vm.items,"items-per-page":_vm.pageOptions.itemsPerPage,"page":_vm.pageOptionsRef.page,"sort-by":_vm.sortOptionsRef.value,"sort-desc":_vm.sortOptionsRef.order,"disable-pagination":_vm.disablePagination,"disable-sort":_vm.disableSort,"search":_vm.search,"custom-filter":_vm.customFilter,"hide-default-header":""},on:{"update:page":function($event){return _vm.$set(_vm.pageOptionsRef, "page", $event)},"update:sortBy":function($event){return _vm.$set(_vm.sortOptionsRef, "value", $event)},"update:sort-by":function($event){return _vm.$set(_vm.sortOptionsRef, "value", $event)},"update:sortDesc":function($event){return _vm.$set(_vm.sortOptionsRef, "order", $event)},"update:sort-desc":function($event){return _vm.$set(_vm.sortOptionsRef, "order", $event)},"page-count":function($event){return _vm.$emit('update-pagecount', $event)},"pagination":function($event){return _vm.$emit('update-pagination', $event)}},scopedSlots:_vm._u([{key:"top",fn:function(){return [_vm._t("top")]},proxy:true},(!_vm.disableSort && _vm.sortHeaders.length)?{key:"header",fn:function(){return [_c('thead',{staticClass:"v-data-table-header v-data-table-header-mobile"},[_c('tr',[_c('th',{attrs:{"id":"custom-sort-header"}},[_c('div',{staticClass:"v-data-table-header-mobile__wrapper mb-5"},[_c('div',{staticClass:"p-data-table-header-mobile__wrapper__sorting d-flex flex-column"},[_c('p-select',{attrs:{"options":_vm.sortHeaders,"hide-details":"","value":Array.isArray(_vm.sortOptionsRef.value) ? _vm.sortOptionsRef.value[0] : _vm.sortOptionsRef.value,"label":_vm.$t('sort'),"data-ui":_vm.dataUiPrefix ? (_vm.dataUiPrefix + "-sortby") : null},on:{"input":_vm.onSortBy}}),_vm._v(" "),_c('p-select',{attrs:{"options":_vm.sortDirectionArray,"value":_vm.sortDirection,"hide-details":"","label":_vm.$t('sortDirection.label'),"data-ui":_vm.dataUiPrefix ? (_vm.dataUiPrefix + "-sortdirection") : null},on:{"input":_vm.onSortDirectionChange}})],1)])])])])]},proxy:true}:null,{key:"item",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('tr',{class:[
        'p-data-table-mobile__row',
        {
          'p-data-table-mobile__row--parent': item.children && item.children.length,
          'p-data-table-mobile__row--event' : _vm.hasTableRowListener,
        }
      ],on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('table-row-click', item)},"click":function($event){return _vm.$emit('table-row-click', item)}}},_vm._l((_vm.tableData.headers),function(header){return _c('td',{key:(index + "-" + (header.value)),staticClass:"p-data-table-mobile__cell v-data-table__mobile-row",attrs:{"data-ui":_vm.dataUiPrefix ? _vm.dataUiPrefix + '-' + header.value : null}},[(_vm.hasSlot(header.value))?_c('div',{staticClass:"p-data-table-mobile__row",class:header.hasLabel ? 'd-flex flex-column justify-space-between' : ''},[(header.hasLabel)?_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(header.text))]):_vm._e(),_vm._v(" "),_vm._t(header.value,null,null,Object.assign({}, item, {item: item}))],2):_c('div',{staticClass:"p-data-table-mobile__row d-flex flex-column justify-space-between"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(header.text))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(typeof header.format === 'function' ? header.format(item[header.value]) : item[header.value]))])])])}),0),_vm._v(" "),_vm._l((item.children),function(child,childIndex){return _c('tr',{key:("child-row-" + index + "-" + childIndex),class:[
        'p-data-table-mobile__row',
        { 'p-data-table-mobile__row--child' : childIndex !== item.children.length - 1,
          'p-data-table-mobile__row--event' : _vm.hasTableRowListener,
        } ],on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('table-row-click', child)},"click":function($event){return _vm.$emit('table-row-click', child)}}},_vm._l((_vm.tableData.headers),function(header){return _c('td',{key:("child-row-" + index + "-" + childIndex + "-" + (header.value)),class:['p-data-table-mobile__cell', 'v-data-table__mobile-row',
                 { 'pl-8' : child[header.value], 'sr-only': !child[header.value] }]},[(_vm.hasSlot(header.value))?_c('div',{staticClass:"p-data-table-mobile__row p-data-table-mobile__child",class:header.hasLabel ? 'd-flex flex-column justify-space-between' : ''},[(header.hasLabel)?_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(header.text))]):_vm._e(),_vm._v(" "),_vm._t(header.value,null,null,Object.assign({}, child, {item: child}))],2):_c('div',{staticClass:"p-data-table-mobile__row p-data-table-mobile__child d-flex flex-column justify-space-between"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(header.text))]),_vm._v(" "),(!child[header.value])?_c('span',[_vm._v(_vm._s(typeof header.format === 'function' ? header.format(item[header.value]) : item[header.value]))]):_c('span',[_vm._v(_vm._s(typeof header.format === 'function' ? header.format(child[header.value]) : child[header.value]))])])])}),0)})]}}],null,true)},'v-data-table',Object.assign({}, (_vm.customSorter ? {'custom-sort': _vm.customSorter} : {})),false))};
var __vue_staticRenderFns__$V = [];

  /* style */
  const __vue_inject_styles__$V = undefined;
  /* scoped */
  const __vue_scope_id__$V = undefined;
  /* module identifier */
  const __vue_module_identifier__$V = undefined;
  /* functional template */
  const __vue_is_functional_template__$V = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$V = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$V, staticRenderFns: __vue_staticRenderFns__$V },
    __vue_inject_styles__$V,
    __vue_script__$U,
    __vue_scope_id__$V,
    __vue_is_functional_template__$V,
    __vue_module_identifier__$V,
    false,
    undefined,
    undefined,
    undefined
  );

var dayjs_min = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return "["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0;}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return b},m.isValid=function(){return !(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g;}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));
});

var utc = createCommonjsModule(function (module, exports) {
!function(t,i){module.exports=i();}(commonjsGlobal,(function(){var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var o=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),o.call(this,t);};var r=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds();}else r.call(this);};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s,o=this;if(f)return o.$offset=u,o.$u=0===s,o;if(0!==s){var r=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(o=this.local().add(u+r,t)).$offset=u,o.$x.$localOffset=r;}else o=this.utc();return o};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return !!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return "s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)};}}));
});

var isBetween$1 = createCommonjsModule(function (module, exports) {
!function(e,i){module.exports=i();}(commonjsGlobal,(function(){return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return (r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))};}}));
});

var customParseFormat = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t();}(commonjsGlobal,(function(){var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d/,r=/\d\d/,i=/\d\d?/,o=/\d*[^-_:/,()\s\d]+/,s={},a=function(e){return (e=+e)+(e>68?1900:2e3)};var f=function(e){return function(t){this[e]=+t;}},h=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e);}],u=function(e){var t=s[e];return t&&(t.indexOf?t:t.s.concat(t.f))},d=function(e,t){var n,r=s.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},c={A:[o,function(e){this.afternoon=d(e,!1);}],a:[o,function(e){this.afternoon=d(e,!0);}],Q:[n,function(e){this.month=3*(e-1)+1;}],S:[n,function(e){this.milliseconds=100*+e;}],SS:[r,function(e){this.milliseconds=10*+e;}],SSS:[/\d{3}/,function(e){this.milliseconds=+e;}],s:[i,f("seconds")],ss:[i,f("seconds")],m:[i,f("minutes")],mm:[i,f("minutes")],H:[i,f("hours")],h:[i,f("hours")],HH:[i,f("hours")],hh:[i,f("hours")],D:[i,f("day")],DD:[r,f("day")],Do:[o,function(e){var t=s.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r);}],w:[i,f("week")],ww:[r,f("week")],M:[i,f("month")],MM:[r,f("month")],MMM:[o,function(e){var t=u("months"),n=(u("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n;}],MMMM:[o,function(e){var t=u("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t;}],Y:[/[+-]?\d+/,f("year")],YY:[r,function(e){this.year=a(e);}],YYYY:[/\d{4}/,f("year")],Z:h,ZZ:h};function l(n){var r,i;r=n,i=s&&s.formats;for(var o=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=o.length,f=0;f<a;f+=1){var h=o[f],u=c[h],d=u&&u[0],l=u&&u[1];o[f]=l?{regex:d,parser:l}:h.replace(/^\[|\]$/g,"");}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=o[n];if("string"==typeof i)r+=i.length;else {var s=i.regex,f=i.parser,h=e.slice(r),u=s.exec(h)[0];f.call(t,u),e=e.replace(u,"");}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon;}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(a=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,o=e.args;this.$u=r;var a=o[1];if("string"==typeof a){var f=!0===o[2],h=!0===o[3],u=f||h,d=o[2];h&&(d=o[2]),s=this.$locale(),!f&&d&&(s=n.Ls[d]),this.$d=function(e,t,n,r){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var i=l(t)(e),o=i.year,s=i.month,a=i.day,f=i.hours,h=i.minutes,u=i.seconds,d=i.milliseconds,c=i.zone,m=i.week,M=new Date,Y=a||(o||s?1:M.getDate()),p=o||M.getFullYear(),v=0;o&&!s||(v=s>0?s-1:M.getMonth());var D,w=f||0,g=h||0,y=u||0,L=d||0;return c?new Date(Date.UTC(p,v,Y,w,g,y,L+60*c.offset*1e3)):n?new Date(Date.UTC(p,v,Y,w,g,y,L)):(D=new Date(p,v,Y,w,g,y,L),m&&(D=r(D).week(m).toDate()),D)}catch(e){return new Date("")}}(t,a,r,n),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),s={};}else if(a instanceof Array)for(var c=a.length,m=1;m<=c;m+=1){o[1]=a[m-1];var M=n.apply(this,o);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===c&&(this.$d=new Date(""));}else i.call(this,e);};}}));
});

dayjs_min.extend(utc);
dayjs_min.extend(isBetween$1);
dayjs_min.extend(customParseFormat);
const ISO_FORMAT = 'YYYY-MM-DD';
const LOCALE_FORMAT = 'DD-MM-YYYY';
const DATE_LENGTH = 10;
function overrideVueI18nD(i18n) {
    const i18nWithOverride = i18n;
    if (i18nWithOverride.originalD) {
        logWarning('VueI18n.d already overridden');
    }
    else {
        i18nWithOverride.originalD = i18n.d;
        if (!i18nWithOverride.originalD) {
            logWarning('VueI18n instance is missing d method');
        }
        else {
            actualOverrideVueI18nD(i18n);
        }
    }
    return i18n;
}
function actualOverrideVueI18nD(i18n) {
    i18n.d = function (date, key = '') {
        if (!date) {
            return '';
        }
        const result = (key === 'dateTime' || key === 'dateTimeLong') ? date : toDateOrNull(date);
        if (!result) {
            logWarning(`Unable to convert ${toStringSave(date)} to a Date`);
            if (typeof date === 'string') {
                return date;
            }
            return '';
        }
        return this.originalD ? this.originalD(result, key) : toLocaleString(date, '');
    };
}
const invalidDate = new Date(NaN);
const invalidDateString = '';
const invalidDayjs = dayjs_min(NaN);
function dateStringFromString(date, invalidValue) {
    if (date.length < DATE_LENGTH) {
        date = addDashesFromFormat(date, LOCALE_FORMAT);
    }
    else if (date === dayjs_min(date, ISO_FORMAT).format(ISO_FORMAT)) {
        return date;
    }
    const d = dayjs_min(date, LOCALE_FORMAT);
    if (date === d.format(LOCALE_FORMAT)) {
        return d.format(ISO_FORMAT);
    }
    return invalidValue;
}
function dateString(date, invalidValue) {
    if (date) {
        if (typeof date === 'string') {
            return dateStringFromString(date, invalidValue);
        }
        if (date instanceof Date) {
            if (!isNaN(date.valueOf())) {
                return dayjs_min(date).format(ISO_FORMAT);
            }
        }
        else if (dayjs_min.isDayjs(date) && date.isValid()) {
            return dayjs_min(date).format(ISO_FORMAT);
        }
    }
    return invalidValue;
}
function dateStringOrEmpty(date) {
    return dateString(date, invalidDateString);
}
function today() {
    return dateStringOrEmpty(new Date());
}
function toDayjs(date, invalidValue) {
    if (dayjs_min.isDayjs(date) && date.isValid()) {
        return date;
    }
    if (typeof date === 'string' && date.length === DATE_LENGTH) {
        const asDayjs = dayjs_min(date, ISO_FORMAT);
        if (asDayjs.format(ISO_FORMAT) === date) {
            return asDayjs;
        }
    }
    const d = dateString(date, undefined);
    return d ? dayjs_min(d, ISO_FORMAT) : invalidValue;
}
function toDayjsOrInvalid(date) {
    return toDayjs(date, invalidDayjs);
}
function toDate(date, invalidValue) {
    const asDayjs = toDayjs(date, undefined);
    return asDayjs ? asDayjs.toDate() : invalidValue;
}
function toDateOrNull(date) {
    return toDate(date, null);
}
function addDashesFromFormat(date, format) {
    let cursor = 0;
    return format.split('-').map((value) => {
        cursor += value.length;
        return date.slice(cursor - value.length, cursor);
    }).join('-');
}
function toLocaleString(date, invalidValue) {
    const asDayjs = toDayjs(date, null);
    return asDayjs ? asDayjs.format(LOCALE_FORMAT) : invalidValue;
}
function isAfter(date, compDate) {
    if (!date && compDate) {
        return true; // undefined is infinity
    }
    return toDayjsOrInvalid(date).isAfter(toDayjsOrInvalid(compDate));
}
function isBefore(date, compDate) {
    if (!compDate && date) {
        return true; // undefined is infinity
    }
    return toDayjsOrInvalid(date).isBefore(toDayjsOrInvalid(compDate));
}
/**
 * Compares a date if it fall between two other dates.
 * @param date Date to compare
 * @param compDates Array of two dates to compare with
 * @param options granularity: Sets the unit to compare with, default `'day'`; inclusive: include both compare dates; default `true`
 * @returns Boolean
 */
function isBetween(date, compDates, options = {}) {
    let firstDate = compDates[0];
    let lastDate = compDates[1];
    if (toDayjsOrInvalid(lastDate).isBefore(toDayjsOrInvalid(firstDate))) {
        lastDate = compDates[0];
        firstDate = compDates[1];
    }
    const { granularity = 'day', inclusive = true } = options;
    return toDayjsOrInvalid(date).isBetween(toDayjsOrInvalid(firstDate), toDayjsOrInvalid(lastDate), granularity, inclusive ? '[]' : '()');
}
function endOf(date, type) {
    return dateStringOrEmpty(toDayjsOrInvalid(date).endOf(type));
}
function startOf(date, type) {
    return dateStringOrEmpty(toDayjsOrInvalid(date).startOf(type));
}
function add(date, num, type) {
    return dateStringOrEmpty(toDayjsOrInvalid(date).add(num, type));
}
function subtract(date, num, type) {
    return dateStringOrEmpty(toDayjsOrInvalid(date).subtract(num, type));
}
function diff(date1, date2, unit = 'day') {
    return toDayjsOrInvalid(date1).diff(toDayjsOrInvalid(date2), unit);
}
/**
 * Get the months between two dates in an object with years and months
 * @param date1 First date to get month from
 * @param date2 Last date to get month from
 * @returns Object with years as keys and month numbers (0-11) in an array per year
 *
 * @example
 * ```
 * const months = monthsBetween('01-10-2021', '31-03-2022')
 * console.log(months) // { '2021': [ 9, 10, 11 ], '2022': [ 0, 1, 2 ] }
 * ```
 */
function monthsBetween(date1, date2 = undefined) {
    if (!date1) {
        return {};
    }
    const dayjsDateStart = toDayjsOrInvalid(date1);
    const dayjsDateEnd = !date2 ? dayjs_min() : toDayjsOrInvalid(date2);
    const list = {};
    let startMonth = dayjsDateStart.month();
    for (let year = dayjsDateStart.year(); year <= dayjsDateEnd.year(); year++) {
        const months = [];
        const tillMonth = year < dayjsDateEnd.year() ? 11 : dayjsDateEnd.month();
        for (let month = startMonth; month <= tillMonth; month++) {
            months.push(month);
            if (month === 11) {
                startMonth = 0;
            }
        }
        list[year] = months;
    }
    return list;
}

function dateFormat(v) {
    return toLocaleString(v, '-');
}
function childDateFormat(v) {
    return toLocaleString(v, '');
}
function percentageFormat(v) {
    return `${v} %`;
}
function createHeader(caption, prop, options) {
    return Object.assign(Object.assign({ sortable: false, filterable: true, hasLabel: true }, options), { text: caption, value: prop });
}
const getSelectedFilters = (state) => {
    return state.filters.filter(({ selected }) => {
        return selected;
    });
};
const isNothingSelected = (selectedFilters, searchString) => {
    return selectedFilters.length === 0 && !searchString;
};
const isFilterHit = (filter, item) => {
    return String(filter.selected) === String(item[filter.id || filter.label]);
};
const isSearchHit = (value, searchString) => {
    if (typeof value === 'object') {
        value = JSON.stringify(value);
    }
    // to match the shown (Dutch) way of dates to the data type
    const dateLikeRegex = /^(\d{2})[ .-](\d{2})?-?$/s;
    const fullDateRegex = /^(?<d>\d{2})[ .-](?<m>\d{2})[ .-]'?((?<Y>\d{4})|(?<y>\d{2}))$/s;
    if (searchString.match(dateLikeRegex)) {
        searchString = searchString.replace(dateLikeRegex, (_m, p1, p2) => {
            return p2 ? `${p2}-${p1}` : p1;
        });
    }
    if (searchString.match(fullDateRegex)) {
        searchString = searchString.replace(fullDateRegex, (_m, ...args) => {
            const { d, m, y, Y } = args.pop(); // args.at(-1)
            return y ? `${Number(y) <= Number(new Date().getFullYear().toString().slice(-2)) ? '20' : '19'}${y}-${m}-${d}` : `${Y}-${m}-${d}`;
        });
    }
    // to match the shown (Dutch) way of amounts to the data type
    const withCentsRegex = /^-?[0-9.]+,(?:\d|-){0,2}$/s; // 'e.g. 1.234,56' or '-1,23' or '1,-', etc.
    const withKSeperatorRegex = /[0-9]+(?:\.\d{3})+/s; // 'e.g. 1.234.567'
    if (searchString.match(withCentsRegex)) {
        searchString = searchString.replace(/[.,]/g, m => (m === '.' ? '' : '.')).replace(/\.[-0]*$/g, '.00');
        value = String(value).match(/\.\d{2}/g) ? value : value + '.00';
        return String(value) === searchString;
    }
    else if (searchString.match(withKSeperatorRegex)) {
        searchString = searchString.replace('.', '');
    }
    return String(value).toLowerCase().includes(searchString.toLowerCase());
};
const canBeSearched = (key, searchableKeys) => {
    return searchableKeys.includes(key);
};
const isAndCombination = (filterHits, selectedFilters) => {
    // if multiple filters are selected, item has to have a hit on all
    return filterHits.length > 0 && filterHits.length === selectedFilters.length;
};
const customFilter = ({ filters, searchableKeys, searchFilter }) => (value, search, item) => {
    // the custom filter loops over every cell in the datatable and to show the row it needs to return true.
    let show = false;
    const filterHits = [];
    const state = JSON.parse(search);
    const selectedFilters = getSelectedFilters(state);
    const searchString = state.search;
    // if searchFilter prop is set, let it handle it (the whole state, when it has filters, the string when not)
    if (searchFilter) {
        return searchFilter(value, filters.length > 0 ? state : searchString, item);
    }
    if (isNothingSelected(selectedFilters, searchString)) {
        show = true;
    }
    for (const filter of selectedFilters) {
        if (isFilterHit(filter, item)) {
            filterHits.push(true);
        }
    }
    if (searchString) {
        return show || shouldShowInCombinationWithSearchString(item, searchableKeys, searchString, selectedFilters, filterHits);
    }
    else if (isAndCombination(filterHits, selectedFilters)) {
        return true;
    }
    return show;
};
function shouldShowInCombinationWithSearchString(item, searchableKeys, searchString, selectedFilters, filterHits) {
    for (const [key, val] of Object.entries(item)) {
        if (canBeSearched(key, searchableKeys) &&
            isSearchHit(val, searchString) &&
            (selectedFilters.length === 0 || isAndCombination(filterHits, selectedFilters))) {
            return true;
        }
    }
    return false;
}

const pAriaLiveFunctionsProviderName = 'p-aria-live-functions';
const pAriaLiveDataProviderName = 'p-aria-live-data';

var usePAriaLive = () => {
    const { announcePolite, announceAssertive } = inject(pAriaLiveFunctionsProviderName);
    return {
        announcePolite,
        announceAssertive,
    };
};

var script$T = defineComponent({
    name: 'PDataTable',
    i18n: i18n$5,
    components: {
        PDataTableDesktop: __vue_component__$W,
        PDataTableMobile: __vue_component__$V,
        VPagination,
        PSelect: __vue_component__$Z,
        PFilters: __vue_component__$X,
    },
    props: {
        data: { type: Object, required: true },
        dataUi: { type: String, default: null },
        defaultSort: { type: String, default: null },
        defaultSortDescending: { type: Boolean, default: false },
        disablePagination: { type: Boolean, default: false },
        itemsPerPageChoices: { type: Array, default: () => itemsPerPageChoices },
        itemsPerPage: { type: Number, default: itemsPerPage },
        disableSort: { type: Boolean, default: false },
        filters: { type: Array, default: () => [] },
        filterDescriptions: { type: Object, default: undefined },
        itemTypesI18n: { type: String, default: undefined },
        searchEnabled: { type: Boolean, default: false },
        searchInColumns: { type: Array, default: undefined },
        searchFilter: { type: Function, default: undefined },
        customSearch: { type: String, default: null },
    },
    setup(props, { listeners, slots, emit }) {
        const dataTable = ref(null);
        const search = ref(props.customSearch);
        const isFiltered = ref(false);
        const pageCountLabelId = useIdGenerator('p-data-table-select-input').next();
        const { isMobileView, isTabletView } = useBreakpoints();
        const dataTableComposables = useDataTable(props);
        const { announcePolite } = usePAriaLive();
        const { tc } = useI18n();
        const showTopFilters = computed(() => (useHasSlot(slots)('top-filters') || !!props.searchFilter || props.searchEnabled || props.filters.length > 0));
        const searchableKeys = computed(() => (props.searchInColumns || props.data.headers.filter(({ filterable }) => filterable).map(({ value }) => value)));
        const customFilter$1 = computed(() => customFilter({ filters: props.filters, searchableKeys: searchableKeys.value, searchFilter: props.searchFilter }));
        const resultsMsg = computed(() => {
            return (tc(isFiltered.value ? 'filteredResults' : 'unfilteredResults', dataTableComposables.filteredLength.value, {
                filteredLength: dataTableComposables.filteredLength.value,
                itemTypes: tc(props.itemTypesI18n || 'results', dataTableComposables.filteredLength.value),
            }));
        });
        const onFiltersInputHandler = (state) => {
            search.value = JSON.stringify(state);
            isFiltered.value = !isNothingSelected(getSelectedFilters(state), state.search);
            emit('filters-state', state);
            const a11yMsg = () => announcePolite(resultsMsg.value);
            Vue$1.nextTick().then(a11yMsg);
        };
        const onPaginationUpdateHandler = (event) => {
            dataTableComposables.filteredLength.value = event.itemsLength;
            emit('update-pagination', Object.assign(Object.assign({}, event), { totalLength: dataTableComposables.itemLength.value }));
        };
        const onPageOptionChangeHandler = () => {
            if (isMobileView.value && dataTable.value) {
                const offset = dataTable.value.getBoundingClientRect();
                window.scrollTo({ top: offset.top + window.scrollY - 100 });
            }
        };
        watch(() => props.customSearch, (newSearch) => {
            search.value = JSON.stringify({ search: newSearch, filters: [] });
        });
        onMounted(() => {
            dataTableComposables.toggleSort(props.defaultSort, props.defaultSortDescending);
        });
        return Object.assign(Object.assign({}, dataTableComposables), { showTopFilters,
            dataTable,
            isMobileView,
            isTabletView,
            customFilter: customFilter$1,
            onPageOptionChangeHandler,
            onPaginationUpdateHandler,
            onFiltersInputHandler,
            search,
            resultsMsg, hasTableRowListener: !!listeners['table-row-click'], pageCountLabelId,
            showAll });
    },
});

/* script */
const __vue_script__$T = script$T;
/* template */
var __vue_render__$U = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dataTable",staticClass:"p-data-table",attrs:{"data-ui":_vm.dataUi}},[_c(_vm.isMobileView ? 'p-data-table-mobile' : 'p-data-table-desktop',{tag:"component",attrs:{"table-data":_vm.data,"data-ui-prefix":_vm.dataUi,"sort-options":_vm.sortOptions,"page-options":_vm.pageOptions,"custom-sorter":_vm.customSorter,"custom-filter":_vm.customFilter,"disable-pagination":_vm.disablePagination,"disable-sort":_vm.disableSort,"has-table-row-listener":_vm.hasTableRowListener,"search":_vm.search},on:{"table-row-click":function($event){return _vm.$emit('table-row-click', $event)},"sort":_vm.toggleSort,"update-pagecount":function($event){_vm.pageOptions.pageCount = $event;},"update-pagination":_vm.onPaginationUpdateHandler},scopedSlots:_vm._u([(_vm.showTopFilters)?{key:"top",fn:function(){return [_c('div',{staticClass:"top-slot"},[_vm._t("top-filters",function(){return [(_vm.filters || _vm.searchEnabled || !!_vm.searchFilter)?_c('p-filters',{attrs:{"filters":_vm.filters,"descriptions":_vm.filterDescriptions,"search-enabled":_vm.searchEnabled || !!_vm.searchFilter,"inline-labels":_vm.filters.length === 1,"one-line":(_vm.searchEnabled || !!_vm.searchFilter) && _vm.filters.length < 3,"data-ui":_vm.dataUi + '-filters'},on:{"input":_vm.onFiltersInputHandler},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots).filter(function (a) { return a.startsWith('filter-info-'); })),function(slot){return {key:slot,fn:function(props){return [_vm._t(slot,null,null,props)]}}})],null,true)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p-data-table__items-found"},[_vm._v("\n            "+_vm._s(_vm.resultsMsg)+"\n          ")])]})],2)]},proxy:true}:null,_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(props){return [_vm._t(slot,null,null,props)]}}})],null,true)}),_vm._v(" "),(_vm.itemLength > _vm.pageOptions.itemsPerPageChoices[0].value && !_vm.disablePagination)?_c('div',{class:[
      'p-data-table__navigation',
      'd-flex justify-space-between',
      {
        'flex-column': _vm.isMobileView,
        'pt-9': !_vm.isMobileView,
      } ]},[_c('p-select',{staticClass:"p-data-table__select-input",attrs:{"options":_vm.pageOptions.itemsPerPageChoices,"label":_vm.$t('amountRows'),"inline-label":"","hide-details":""},on:{"input":_vm.onPageOptionChangeHandler},model:{value:(_vm.pageOptions.itemsPerPage),callback:function ($$v) {_vm.$set(_vm.pageOptions, "itemsPerPage", $$v);},expression:"pageOptions.itemsPerPage"}}),_vm._v(" "),_c('div',{class:[
        'p-data-table__pagination d-flex',
        { 'flex-column': _vm.isMobileView,
          'align-start': _vm.isMobileView,
          'align-center': !_vm.isMobileView,
          'pt-6': _vm.isMobileView } ]},[_c('span',{class:[
          'mr-5',
          { 'pb-3': _vm.isMobileView } ]},[_vm._v("\n        "+_vm._s(_vm.$t('shownResults', { shownEntries: _vm.shownEntries, total: _vm.itemLength }))+"\n      ")]),_vm._v(" "),(_vm.itemLength > _vm.pageOptions.itemsPerPage && _vm.pageOptions.itemsPerPage !== _vm.showAll)?_c('v-pagination',{staticClass:"pgb-pagination",attrs:{"total-visible":5,"length":_vm.pageOptions.pageCount},on:{"input":_vm.onPageOptionChangeHandler},model:{value:(_vm.pageOptions.page),callback:function ($$v) {_vm.$set(_vm.pageOptions, "page", $$v);},expression:"pageOptions.page"}}):_vm._e()],1)],1):_vm._e()],1)};
var __vue_staticRenderFns__$U = [];

  /* style */
  const __vue_inject_styles__$U = undefined;
  /* scoped */
  const __vue_scope_id__$U = "data-v-d6d2c04c";
  /* module identifier */
  const __vue_module_identifier__$U = undefined;
  /* functional template */
  const __vue_is_functional_template__$U = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$U = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$U, staticRenderFns: __vue_staticRenderFns__$U },
    __vue_inject_styles__$U,
    __vue_script__$T,
    __vue_scope_id__$U,
    __vue_is_functional_template__$U,
    __vue_module_identifier__$U,
    false,
    undefined,
    undefined,
    undefined
  );

/* script */

/* template */
var __vue_render__$T = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-button',_vm._g(_vm._b({attrs:{"small":""}},'p-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)};
var __vue_staticRenderFns__$T = [];

  /* style */
  const __vue_inject_styles__$T = undefined;
  /* scoped */
  const __vue_scope_id__$T = undefined;
  /* module identifier */
  const __vue_module_identifier__$T = undefined;
  /* functional template */
  const __vue_is_functional_template__$T = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$T = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$T, staticRenderFns: __vue_staticRenderFns__$T },
    __vue_inject_styles__$T,
    {},
    __vue_scope_id__$T,
    __vue_is_functional_template__$T,
    __vue_module_identifier__$T,
    false,
    undefined,
    undefined,
    undefined
  );

class DelayedFormInputValidator {
    constructor(onStart, onValidate) {
        this._isValidating = ref(false);
        this._onStart = () => this.waitForValidation(onStart());
        this._onValidate = onValidate;
    }
    get isValidating() {
        return this._isValidating;
    }
    start(options) {
        this._isValidating.value = true;
        if (options) {
            this._waitForValidation = options.waitForValidation;
        }
        this._onStart();
    }
    validate() {
        return this._onValidate();
    }
    end() {
        this._isValidating.value = false;
        this._waitForValidation = undefined;
    }
    waitForValidation(promise) {
        if (this._waitForValidation) {
            this._waitForValidation(promise);
        }
    }
}
/// Register an additional formValidator via provide/inject to the PForm.
/// A form validator that will first wait for the repository with loading all required data and then check if the loaded data has a valid final state.
function registerDelayedFormInputValidator(waitFor, validate) {
    registerFormInputValidator(new DelayedFormInputValidator(waitFor, validate));
}

var script$S = defineComponent({
    name: 'PForm',
    props: {
        delayValidation: { type: Object, default: null },
    },
    setup(props) {
        const internalId = useIdGenerator('p-form').next();
        provide(formIdProvider, internalId);
        const inputValidators = [
            ...(props.delayValidation
                ? [new DelayedFormInputValidator(props.delayValidation.waitFor, props.delayValidation.isValid)]
                : []),
        ];
        let waitForValidationList;
        const waitForValidation = (promise) => {
            if (!waitForValidationList) {
                logError('Call to waitForValidation without being in a validation cycle');
                return;
            }
            waitForValidationList.push(promise);
        };
        const addFormInputValidator = (inputValidator) => {
            inputValidators.push(inputValidator);
        };
        const removeFormInputValidator = (inputValidator) => {
            const index = inputValidators.indexOf(inputValidator);
            if (index > -1) {
                inputValidators.splice(index, 1);
            }
        };
        provideRegisterFormInputValidator((inputValidator, remove) => {
            if (remove) {
                removeFormInputValidator(inputValidator);
            }
            else {
                addFormInputValidator(inputValidator);
            }
        });
        const startFormValidation = () => {
            waitForValidationList = [];
            inputValidators.forEach(v => {
                v.start({ waitForValidation });
            });
        };
        const endFormValidation = () => {
            inputValidators.forEach((v) => v.end());
            Vue$1.nextTick().then(findAndFocusOnFirstError);
        };
        const validateInputs = () => inputValidators.map(a => a.validate()).every(i => i);
        const runWaitForValidation = () => __awaiter(this, void 0, void 0, function* () {
            while (waitForValidationList.length) {
                const promise = waitForValidationList[0];
                waitForValidationList.splice(0, 1);
                yield promise;
                yield Vue$1.nextTick();
            }
        });
        const validate = () => __awaiter(this, void 0, void 0, function* () {
            try {
                startFormValidation();
                yield Vue$1.nextTick();
                yield runWaitForValidation();
                return validateInputs();
            }
            finally {
                endFormValidation();
            }
        });
        return {
            inputValidators,
            validate,
        };
    },
});
function findAndFocusOnFirstError() {
    const inputsWithError = document.querySelector('.p-input--error');
    if (inputsWithError) {
        const rect = inputsWithError.getBoundingClientRect();
        const win = document.body.getBoundingClientRect();
        window.scrollTo({ top: rect.top - (win.top + 120) });
        const inputElement = inputsWithError.querySelector('input,textarea,[role="combobox"]');
        if (inputElement) {
            inputElement.focus();
        }
    }
}

/* script */
const __vue_script__$S = script$S;

/* template */
var __vue_render__$S = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',_vm._b({attrs:{"novalidate":"novalidate"},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')}}},'form',_vm.$attrs,false),[_vm._t("default")],2)};
var __vue_staticRenderFns__$S = [];

  /* style */
  const __vue_inject_styles__$S = undefined;
  /* scoped */
  const __vue_scope_id__$S = undefined;
  /* module identifier */
  const __vue_module_identifier__$S = undefined;
  /* functional template */
  const __vue_is_functional_template__$S = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$S = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$S, staticRenderFns: __vue_staticRenderFns__$S },
    __vue_inject_styles__$S,
    __vue_script__$S,
    __vue_scope_id__$S,
    __vue_is_functional_template__$S,
    __vue_module_identifier__$S,
    false,
    undefined,
    undefined,
    undefined
  );

var usePageDirtyState = () => {
    const formsStateManager = inject(formsStateManagerKey, null);
    const setPristine = () => {
        if (!formsStateManager) {
            return;
        }
        const { updateAllElements } = formsStateManager;
        updateAllElements({
            isDirty: false,
        });
    };
    return {
        isDirty: computed(() => {
            if (!formsStateManager) {
                return false;
            }
            const { formsState } = formsStateManager;
            const formsStateObj = formsState.value || {};
            return Object.keys(formsStateObj).some((formId) => Object.keys(formsStateObj[formId]).some((elementId) => formsStateObj[formId][elementId].isDirty));
        }),
        setPristine,
    };
};

var script$R = defineComponent({
    name: 'AppFooter',
    components: { VContainer, VCol, VRow, VFooter },
    props: {
        links: { type: Array, required: true },
    },
    setup(_, { slots }) {
        const hasSlot = useHasSlot(slots);
        return {
            hasSlot,
        };
    },
});

/* script */
const __vue_script__$R = script$R;
/* template */
var __vue_render__$R = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',_vm._b({staticClass:"p-footer flex-column align-stretch",attrs:{"padless":""}},'v-footer',_vm.$attrs,false),[(_vm.hasSlot('footer-top'))?_c('div',{staticClass:"p-footer__top"},[_vm._t("footer-top")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p-footer__links py-1"},[_c('v-container',{staticClass:"pa-0 px-2"},[_c('v-row',{staticClass:"pt-0 pb-0 justify-start justify-md-center",attrs:{"align":"start","no-gutters":""}},[(_vm.hasSlot('footer-left-bottom'))?_c('v-col',{key:"pFooterLeftBottom",staticClass:"px-4",attrs:{"align-self":"center","sm":"3","md":"auto","cols":"6"}},[_vm._t("footer-left-bottom")],2):_vm._e(),_vm._v(" "),_vm._l((_vm.links),function(link){return _c('v-col',{key:link.label,attrs:{"align-self":"center","sm":"3","cols":"6","md":"auto"}},[_c('a',{staticClass:"p-footer__links--single px-4 d-flex align-center",attrs:{"href":link.url,"title":link.label}},[_vm._v("\n            "+_vm._s(link.label)+"\n          ")])])}),_vm._v(" "),(_vm.hasSlot('footer-right-bottom'))?_c('v-col',{key:"pFooterRightBottom",staticClass:"px-4",attrs:{"align-self":"center","cols":"6","sm":"3","md":"auto"}},[_vm._t("footer-right-bottom")],2):_vm._e()],2)],1)],1)])};
var __vue_staticRenderFns__$R = [];

  /* style */
  const __vue_inject_styles__$R = undefined;
  /* scoped */
  const __vue_scope_id__$R = "data-v-2a1e1cda";
  /* module identifier */
  const __vue_module_identifier__$R = undefined;
  /* functional template */
  const __vue_is_functional_template__$R = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$R = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$R, staticRenderFns: __vue_staticRenderFns__$R },
    __vue_inject_styles__$R,
    __vue_script__$R,
    __vue_scope_id__$R,
    __vue_is_functional_template__$R,
    __vue_module_identifier__$R,
    false,
    undefined,
    undefined,
    undefined
  );

var script$Q = defineComponent({
    name: 'TopMenu',
    components: { VIcon, VBtn },
    props: {
        items: { type: Array, default: null },
        version: { type: String, default: null },
    },
    setup(props, { root }) {
        const menuIcon = computed(() => activeMenu.value ? '$icon-sluiten' : '$icon-menu-hamburger');
        const resolvedItems = useRouteResolverMulti(props.items || []);
        if (props.items && props.items.filter((i) => i.menu).length > 1) {
            throw Error('Toolbar can only have 1 menu');
        }
        const { activeMenu, menuElement, activator, closeIfElementIsOutside, focusOnActivator, closeActiveMenu, toggleActiveMenu } = useMenuHandlers(root);
        const { clickOnBtn, onTab, onEsc } = useMenuEvents(focusOnActivator, closeActiveMenu, toggleActiveMenu, closeIfElementIsOutside);
        // Watch menu events and remove them when menu is closed
        watch(activeMenu, () => {
            if (activeMenu.value) {
                window.addEventListener('click', closeIfElementIsOutside);
            }
            else {
                window.removeEventListener('click', closeIfElementIsOutside);
            }
        });
        return {
            clickOnBtn,
            activeMenu,
            menuElement,
            menuIcon,
            activator,
            closeActiveMenu,
            focusOnActivator,
            onEsc,
            onTab,
            closeIfElementIsOutside,
            resolvedItems,
        };
    },
});
function useActiveMenu() {
    const activeMenu = ref(false);
    function closeActiveMenu() {
        activeMenu.value = false;
    }
    function toggleActiveMenu() {
        activeMenu.value = !activeMenu.value;
    }
    return {
        activeMenu,
        closeActiveMenu,
        toggleActiveMenu,
    };
}
function useMenuHandlers(root) {
    const menuElement = ref(null);
    const activator = ref(null);
    const { activeMenu, closeActiveMenu, toggleActiveMenu } = useActiveMenu();
    // Check if the focus persists within the menu, if not, hide the menu
    // noEvent option to be able to use this function for both events and independent elements
    function closeIfElementIsOutside(node, noEvent = false) {
        const activatorValue = activator.value && activator.value[0] ? activator.value[0].$el : null;
        if (node && menuElement.value && node !== activatorValue &&
            !menuElement.value.contains(noEvent ? node : (node.target || node))) {
            closeActiveMenu();
        }
    }
    function focusOnActivator() {
        root.$nextTick(() => {
            if (activator.value && activator.value[0]) {
                activator.value[0].$el.focus();
            }
        });
    }
    return {
        activeMenu,
        menuElement,
        activator,
        closeIfElementIsOutside,
        focusOnActivator,
        closeActiveMenu,
        toggleActiveMenu,
    };
}
function useMenuEvents(focusOnActivator, closeActiveMenu, toggleActiveMenu, closeIfElementIsOutside) {
    function clickOnBtn(item, e) {
        if (item.href) {
            return;
        }
        e.stopPropagation();
        if (item.menu) {
            toggleActiveMenu();
            focusOnActivator();
            return;
        }
        closeActiveMenu();
    }
    function onTab() {
        return new Promise((resolve) => {
            setTimeout(() => {
                // We want the activeElement to be the element that is being focussed on instead of what its being focussed from
                // So we set a setTimeout to finish render steps and look for the activeElement afterwards
                closeIfElementIsOutside(window.document.activeElement, true);
                resolve(window.document.activeElement);
                // FF seems to be a bit slow when receiving the new focussed element. So we use a 100ms timeout
            }, 100);
        });
    }
    function onEsc() {
        closeActiveMenu();
        focusOnActivator();
    }
    return { clickOnBtn, onTab, onEsc };
}

/* script */
const __vue_script__$Q = script$Q;
/* template */
var __vue_render__$Q = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"top-menu",on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onEsc.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onTab.apply(null, arguments)}]}},[_c('div',{staticClass:"top-menu__top d-flex align-center"},[_vm._t("top-header")],2),_vm._v(" "),(_vm.resolvedItems.length)?_c('nav',{staticClass:"top-menu__nav d-flex align-center"},[_c('div',{staticClass:"container px-1 py-0"},[_c('ul',{staticClass:"d-flex pa-0 top-menu__list",attrs:{"role":"menubar"}},[_vm._l((_vm.resolvedItems),function(item,key){
var _obj;
return _c('li',{key:key,class:{ 'd-none d-sm-block': item.hiddenMobile },attrs:{"role":"none"}},[_c('v-btn',_vm._b({ref:item.menu ? 'activator' : null,refInFor:true,staticClass:"top-menu__btn",attrs:{"text":"","active-class":"no-active","id":item.id,"color":"white","role":"menuitem","aria-current":null,"data-ui":item.dataUi},on:{"click":function($event){return _vm.clickOnBtn(item, $event)}}},'v-btn',Object.assign(( _obj = {}, _obj[item.to ? 'to' : 'href'] = item.to || item.href, _obj ),
              (item.menu ? {'aria-expanded': !!_vm.activeMenu ? 'true' : 'false'} : {} )),false),[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n              "+_vm._s(item.menu ? _vm.menuIcon : item.icon)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])],1)],1)}),_vm._v(" "),(_vm.version)?_c('li',{staticClass:"top-menu__version pa-1",attrs:{"role":"none"}},[_vm._v("\n          "+_vm._s(_vm.version)+"\n        ")]):_vm._e()],2)]),_vm._v(" "),_c('div',{ref:"menuElement",staticClass:"top-menu__menu"},[_vm._t("menu",null,{"isActive":_vm.activeMenu,"close":_vm.closeActiveMenu})],2)]):_vm._e(),_vm._v(" "),_vm._t("support-modal")],2)};
var __vue_staticRenderFns__$Q = [];

  /* style */
  const __vue_inject_styles__$Q = undefined;
  /* scoped */
  const __vue_scope_id__$Q = "data-v-2738de51";
  /* module identifier */
  const __vue_module_identifier__$Q = undefined;
  /* functional template */
  const __vue_is_functional_template__$Q = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Q = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$Q, staticRenderFns: __vue_staticRenderFns__$Q },
    __vue_inject_styles__$Q,
    __vue_script__$Q,
    __vue_scope_id__$Q,
    __vue_is_functional_template__$Q,
    __vue_module_identifier__$Q,
    false,
    undefined,
    undefined,
    undefined
  );

var script$P = defineComponent({
    name: 'PList',
    components: { VList },
    props: {
        flat: { type: Boolean, default: false },
        color: { type: String, default: 'transparent' },
    },
});

/* script */
const __vue_script__$P = script$P;

/* template */
var __vue_render__$P = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"color":_vm.color,"flat":_vm.flat}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$P = [];

  /* style */
  const __vue_inject_styles__$P = undefined;
  /* scoped */
  const __vue_scope_id__$P = undefined;
  /* module identifier */
  const __vue_module_identifier__$P = undefined;
  /* functional template */
  const __vue_is_functional_template__$P = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$P = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$P, staticRenderFns: __vue_staticRenderFns__$P },
    __vue_inject_styles__$P,
    __vue_script__$P,
    __vue_scope_id__$P,
    __vue_is_functional_template__$P,
    __vue_module_identifier__$P,
    false,
    undefined,
    undefined,
    undefined
  );

var script$O = defineComponent({
    name: 'PListItem',
    components: { VListItem },
    props: {
        to: { type: [String, Object], default: undefined },
        href: { type: String, default: undefined },
        exact: { type: Boolean, default: undefined },
        target: { type: String, default: undefined },
    },
    setup(props) {
        const { allowed, linkTo, linkHref } = useRouteResolver(props);
        return { linkTo, linkHref, allowed };
    },
});

/* script */
const __vue_script__$O = script$O;
/* template */
var __vue_render__$O = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allowed)?_c('v-list-item',_vm._g({attrs:{"to":_vm.linkTo,"href":_vm.linkHref,"exact":_vm.exact,"target":_vm.target}},_vm.$listeners),[_vm._t("default")],2):_vm._e()};
var __vue_staticRenderFns__$O = [];

  /* style */
  const __vue_inject_styles__$O = undefined;
  /* scoped */
  const __vue_scope_id__$O = "data-v-71b326fc";
  /* module identifier */
  const __vue_module_identifier__$O = undefined;
  /* functional template */
  const __vue_is_functional_template__$O = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$O = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$O, staticRenderFns: __vue_staticRenderFns__$O },
    __vue_inject_styles__$O,
    __vue_script__$O,
    __vue_scope_id__$O,
    __vue_is_functional_template__$O,
    __vue_module_identifier__$O,
    false,
    undefined,
    undefined,
    undefined
  );

var script$N = defineComponent({
    name: 'PListItemContent',
    components: { VListItemContent },
});

/* script */
const __vue_script__$N = script$N;
/* template */
var __vue_render__$N = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-content',_vm._g({},_vm.$listeners),[_vm._t("default")],2)};
var __vue_staticRenderFns__$N = [];

  /* style */
  const __vue_inject_styles__$N = undefined;
  /* scoped */
  const __vue_scope_id__$N = "data-v-05221a5e";
  /* module identifier */
  const __vue_module_identifier__$N = undefined;
  /* functional template */
  const __vue_is_functional_template__$N = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$N = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$N, staticRenderFns: __vue_staticRenderFns__$N },
    __vue_inject_styles__$N,
    __vue_script__$N,
    __vue_scope_id__$N,
    __vue_is_functional_template__$N,
    __vue_module_identifier__$N,
    false,
    undefined,
    undefined,
    undefined
  );

var script$M = defineComponent({
    name: 'PListItemTitle',
    components: { VListItemTitle },
});

/* script */
const __vue_script__$M = script$M;
/* template */
var __vue_render__$M = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-title',_vm._g({},_vm.$listeners),[_vm._t("default")],2)};
var __vue_staticRenderFns__$M = [];

  /* style */
  const __vue_inject_styles__$M = undefined;
  /* scoped */
  const __vue_scope_id__$M = "data-v-7a12b95a";
  /* module identifier */
  const __vue_module_identifier__$M = undefined;
  /* functional template */
  const __vue_is_functional_template__$M = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$M = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$M, staticRenderFns: __vue_staticRenderFns__$M },
    __vue_inject_styles__$M,
    __vue_script__$M,
    __vue_scope_id__$M,
    __vue_is_functional_template__$M,
    __vue_module_identifier__$M,
    false,
    undefined,
    undefined,
    undefined
  );

var script$L = defineComponent({
    name: 'PRow',
    components: { VRow },
});

/* script */
const __vue_script__$L = script$L;

/* template */
var __vue_render__$L = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_vm._t("default")],2)};
var __vue_staticRenderFns__$L = [];

  /* style */
  const __vue_inject_styles__$L = undefined;
  /* scoped */
  const __vue_scope_id__$L = undefined;
  /* module identifier */
  const __vue_module_identifier__$L = undefined;
  /* functional template */
  const __vue_is_functional_template__$L = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$L = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$L, staticRenderFns: __vue_staticRenderFns__$L },
    __vue_inject_styles__$L,
    __vue_script__$L,
    __vue_scope_id__$L,
    __vue_is_functional_template__$L,
    __vue_module_identifier__$L,
    false,
    undefined,
    undefined,
    undefined
  );

var script$K = defineComponent({
    name: 'PCol',
    components: { VCol },
    props: {
        cols: { type: [Boolean, String, Number], default: undefined },
        sm: { type: [Boolean, String, Number], default: undefined },
        md: { type: [Boolean, String, Number], default: undefined },
        lg: { type: [Boolean, String, Number], default: undefined },
    },
});

/* script */
const __vue_script__$K = script$K;

/* template */
var __vue_render__$K = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":_vm.cols,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$K = [];

  /* style */
  const __vue_inject_styles__$K = undefined;
  /* scoped */
  const __vue_scope_id__$K = undefined;
  /* module identifier */
  const __vue_module_identifier__$K = undefined;
  /* functional template */
  const __vue_is_functional_template__$K = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$K = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$K, staticRenderFns: __vue_staticRenderFns__$K },
    __vue_inject_styles__$K,
    __vue_script__$K,
    __vue_scope_id__$K,
    __vue_is_functional_template__$K,
    __vue_module_identifier__$K,
    false,
    undefined,
    undefined,
    undefined
  );

var i18n$4 = {
    messages: {
        nl: {
            contentTitle: 'Hoofdmenu inhoud',
        },
    },
};

const generateRouteDescriptionIds = (routes) => Object.keys(routes).reduce((prev, cur) => {
    return Object.assign(Object.assign({}, prev), { [cur]: useIdGenerator('main-menu-item').next() });
}, {});
const useMainMenuDescriptionIds = (mainRoutes, additionalRoutes) => {
    const containerDescriptionId = useIdGenerator('main-menu').next();
    return {
        mainRouteDescriptionIdIndex: computed(() => generateRouteDescriptionIds(mainRoutes.value)),
        additionalRouteDescriptionIdIndex: computed(() => generateRouteDescriptionIds(additionalRoutes.value)),
        containerDescriptionId,
    };
};

var script$J = defineComponent({
    name: 'MainMenu',
    components: {
        PContainer: __vue_component__$11,
        PRow: __vue_component__$L,
        PCol: __vue_component__$K,
        PList: __vue_component__$P,
        PListItem: __vue_component__$O,
        PListItemTitle: __vue_component__$M,
        PListItemContent: __vue_component__$N,
        VSlideYTransition,
    },
    i18n: i18n$4,
    props: {
        active: { type: Boolean, default: false },
        mainRoutes: { type: Object, required: true },
        additionalRoutes: { type: Object, default: null },
        toggleClose: { type: Function, default: null },
    },
    setup(props) {
        const { mainRoutes, additionalRoutes } = toRefs(props);
        return Object.assign({}, useMainMenuDescriptionIds(mainRoutes, additionalRoutes));
    },
});

/* script */
const __vue_script__$J = script$J;
/* template */
var __vue_render__$J = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-y-transition',[(_vm.active)?_c('div',{staticClass:"pgb-menu"},[_c('p-container',{staticClass:"pgb-menu__wrapper py-0",attrs:{"fluid":"","role":"list","aria-describedby":_vm.containerDescriptionId}},[_c('span',{staticClass:"sr-only",attrs:{"aria-hidden":"true","id":_vm.containerDescriptionId}},[_vm._v("\n        "+_vm._s(_vm.$t('contentTitle'))+"\n      ")]),_vm._v(" "),_c('p-row',{staticClass:"my-0"},[_c('p-col',{staticClass:"pgb-menu__container",attrs:{"md":_vm.additionalRoutes ? 9 : 12,"sm":"12","cols":"12"}},[_c('p-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('p-row',{staticClass:"my-0"},_vm._l((_vm.mainRoutes),function(category,key){return _c('p-col',{key:key,staticClass:"pgb-menu__category pa-0 mb-5 mt-2",class:['pgb-menu__category pa-0 mb-5 mt-2', {'tablet-view': _vm.$vuetify.breakpoint.sm }],attrs:{"md":"3","sm":"6","cols":"12"}},[_c('div',{staticClass:"pa-0",attrs:{"role":"listitem"}},[_c('p-list-item-title',{staticClass:"px-4",attrs:{"id":_vm.mainRouteDescriptionIdIndex[key]}},[_vm._v("\n                    "+_vm._s(category.title)+"\n                  ")]),_vm._v(" "),_c('p-list',{staticClass:"pa-0",attrs:{"aria-describedby":_vm.mainRouteDescriptionIdIndex[key]}},_vm._l((category.items),function(item,i){return _c('div',{key:i,attrs:{"role":"listitem"}},[_c('p-list-item',{staticClass:"pgb-menu__list-item",attrs:{"target":item.target,"to":item.to,"href":item.href,"role":null,"tabindex":null,"exact":""},on:{"click":_vm.toggleClose}},[_c('p-list-item-content',{staticClass:"py-2"},[_vm._v("\n                          "+_vm._s(item.title)+"\n                        ")])],1)],1)}),0)],1)])}),1)],1)],1),_vm._v(" "),(_vm.additionalRoutes)?_c('p-col',{key:"mainMenuColAdditionalRoutes",attrs:{"md":"3","sm":"12","cols":"12"}},[_c('p-container',{class:['pgb-menu__help', {'tablet-view': _vm.$vuetify.breakpoint.sm }]},[_c('div',{staticClass:"d-flex flex-column"},[_c('p-row',_vm._l((_vm.additionalRoutes),function(category,key,index){return _c('p-col',{key:key,staticClass:"px-0 pt-2 pb-2 pgb-menu__help-column ml-0",attrs:{"sm":"6","md":"12","cols":"12"}},[_c('div',{class:{'no-flex': _vm.$vuetify.breakpoint.sm || _vm.$vuetify.breakpoint.xs},attrs:{"role":"listitem"}},[_c('p-list-item-title',{staticClass:"px-4",attrs:{"id":_vm.additionalRouteDescriptionIdIndex[key]}},[_vm._v("\n                      "+_vm._s(category.title)+"\n                    ")]),_vm._v(" "),_c('p-list',{staticClass:"pa-0",attrs:{"aria-describedby":_vm.additionalRouteDescriptionIdIndex[key]}},[_vm._l((category.items),function(item,i){return _c('div',{key:i,attrs:{"role":"listitem"}},[_c('p-list-item',{staticClass:"pgb-menu__list-item",attrs:{"to":item.to,"href":item.href,"role":null,"tabindex":null},on:{"click":_vm.toggleClose}},[_c('p-list-item-content',{staticClass:"py-2"},[_vm._v("\n                            "+_vm._s(item.title)+"\n                          ")])],1)],1)}),_vm._v(" "),(index === Object.keys(_vm.additionalRoutes).length -1)?_c('div',{staticClass:"pl-4",attrs:{"role":"listitem"}},[_vm._t("support-slot")],2):_vm._e()],2)],1)])}),1)],1)])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"pgb-menu__backdrop",class:{'tablet-view': _vm.$vuetify.breakpoint.sm},on:{"click":function($event){$event.stopPropagation();return _vm.toggleClose.apply(null, arguments)}}})],1):_vm._e()])};
var __vue_staticRenderFns__$J = [];

  /* style */
  const __vue_inject_styles__$J = undefined;
  /* scoped */
  const __vue_scope_id__$J = "data-v-5f02ee9c";
  /* module identifier */
  const __vue_module_identifier__$J = undefined;
  /* functional template */
  const __vue_is_functional_template__$J = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$J = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$J, staticRenderFns: __vue_staticRenderFns__$J },
    __vue_inject_styles__$J,
    __vue_script__$J,
    __vue_scope_id__$J,
    __vue_is_functional_template__$J,
    __vue_module_identifier__$J,
    false,
    undefined,
    undefined,
    undefined
  );

var script$I = defineComponent({
    name: 'MainMenuMobile',
    components: {
        PContainer: __vue_component__$11,
        PDivider: __vue_component__$1j,
        VNavigationDrawer,
        PList: __vue_component__$P,
        PListItem: __vue_component__$O,
        PListItemContent: __vue_component__$N,
        PListItemTitle: __vue_component__$M,
    },
    i18n: i18n$4,
    props: {
        active: { type: Boolean, default: false },
        mainRoutes: { type: Object, required: true },
        additionalRoutes: { type: Object, default: null },
        toggleClose: { type: Function, default: null },
    },
    setup(props) {
        const { mainRoutes, additionalRoutes } = toRefs(props);
        const onChange = (active) => {
            if (!active) {
                // v-navigation drawer has its own closing input value
                // So we need to send a message to PgbToolbar that the menu has closed
                props.toggleClose();
            }
        };
        return Object.assign({ onChange }, useMainMenuDescriptionIds(mainRoutes, additionalRoutes));
    },
});

/* script */
const __vue_script__$I = script$I;
/* template */
var __vue_render__$I = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"main-menu-expander-mobile px-3",attrs:{"value":_vm.active,"width":"100%","fixed":""},on:{"input":_vm.onChange}},[_c('p-container',{staticClass:"pa-0",attrs:{"role":"list","aria-describedby":_vm.containerDescriptionId}},[_c('span',{staticClass:"sr-only",attrs:{"aria-hidden":"true","id":_vm.containerDescriptionId}},[_vm._v("\n      "+_vm._s(_vm.$t('contentTitle'))+"\n    ")]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._l((_vm.mainRoutes),function(category,key){return _c('div',{key:key,attrs:{"role":"listitem"}},[_c('p-divider'),_vm._v(" "),_c('p-list-item-title',{staticClass:"main-menu-expander-mobile__list-header px-4 pt-4 mb-0",attrs:{"id":_vm.mainRouteDescriptionIdIndex[key]}},[_vm._v("\n        "+_vm._s(category.title)+"\n      ")]),_vm._v(" "),_c('p-list',{staticClass:"main-menu-expander-mobile__list ",attrs:{"aria-describedby":_vm.mainRouteDescriptionIdIndex[key]}},_vm._l((category.items),function(item,i){return _c('div',{key:i,attrs:{"role":"listitem"}},[_c('p-list-item',{staticClass:"px-4 main-menu-expander-mobile__list-item",attrs:{"target":item.target,"to":item.to,"href":item.href,"role":null,"tabindex":null,"exact":""}},[_c('p-list-item-content',{staticClass:"py-2"},[_vm._v("\n              "+_vm._s(item.title)+"\n            ")])],1)],1)}),0)],1)}),_vm._v(" "),(_vm.additionalRoutes)?_c('div',{staticClass:"main-menu-expander-mobile__help pa-4"},_vm._l((_vm.additionalRoutes),function(category,key,index){return _c('div',{key:key,staticClass:"main-menu-expander-mobile__list px-0",attrs:{"role":"listitem"}},[_c('p-list-item-title',{staticClass:"main-menu-expander-mobile__list-header mb-0 mt-2",attrs:{"id":_vm.additionalRouteDescriptionIdIndex[key]}},[_vm._v("\n          "+_vm._s(category.title)+"\n        ")]),_vm._v(" "),_c('p-list',{attrs:{"aria-describedby":_vm.additionalRouteDescriptionIdIndex[key]}},[_vm._l((category.items),function(item,i){return _c('div',{key:i,attrs:{"role":"listitem"}},[_c('p-list-item',{staticClass:"pl-0 main-menu-expander-mobile__list-item",attrs:{"target":item.target,"to":item.to,"href":item.href,"role":null,"tabindex":null}},[_c('p-list-item-content',{staticClass:"py-2"},[_vm._v("\n                "+_vm._s(item.title)+"\n              ")])],1)],1)}),_vm._v(" "),(index === Object.keys(_vm.additionalRoutes).length -1)?_c('div',{attrs:{"role":"listitem"}},[_vm._t("support-slot")],2):_vm._e()],2)],1)}),0):_vm._e()],2)],1)};
var __vue_staticRenderFns__$I = [];

  /* style */
  const __vue_inject_styles__$I = undefined;
  /* scoped */
  const __vue_scope_id__$I = "data-v-51a3dd24";
  /* module identifier */
  const __vue_module_identifier__$I = undefined;
  /* functional template */
  const __vue_is_functional_template__$I = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$I = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$I, staticRenderFns: __vue_staticRenderFns__$I },
    __vue_inject_styles__$I,
    __vue_script__$I,
    __vue_scope_id__$I,
    __vue_is_functional_template__$I,
    __vue_module_identifier__$I,
    false,
    undefined,
    undefined,
    undefined
  );

var script$H = defineComponent({
    name: 'PHeader',
    components: { TopMenu: __vue_component__$Q, MainMenu: __vue_component__$J, MainMenuMobile: __vue_component__$I, PButton: __vue_component__$1f },
    props: {
        toolbarItems: { type: Array, default: () => [] },
        mainRoutes: { type: Object, default: () => ({}) },
        additionalRoutes: { type: Object, default: null },
        version: { type: String, default: '' },
        headerImage: { type: String, default: '' },
    },
    setup() {
        const { isMobileView } = useBreakpoints();
        return {
            isMobile: isMobileView,
        };
    },
});

/* script */
const __vue_script__$H = script$H;
/* template */
var __vue_render__$H = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('top-menu',{attrs:{"items":_vm.toolbarItems,"version":_vm.version},scopedSlots:_vm._u([{key:"menu",fn:function(scopedProps){return [(_vm.mainRoutes && scopedProps)?_c(!_vm.isMobile ? 'main-menu' : 'main-menu-mobile',{tag:"component",attrs:{"active":scopedProps.isActive,"main-routes":_vm.mainRoutes,"additional-routes":_vm.additionalRoutes,"toggle-close":scopedProps.close},scopedSlots:_vm._u([{key:"support-slot",fn:function(){return [_vm._t("support-slot")]},proxy:true}],null,true)},[(_vm.isMobile)?_vm._t("mobile-custom-items"):_vm._e()],2):_vm._e()]}},{key:"support-modal",fn:function(){return [_vm._t("support-modal")]},proxy:true}],null,true)},[_c('div',{staticClass:"topbar container py-0 d-flex justify-space-between align-center",attrs:{"slot":"top-header"},slot:"top-header"},[_c('img',{staticClass:"topbar__logo",attrs:{"src":_vm.headerImage,"alt":"Logo MijnPGB - PGB portaal","tabindex":"-1"}}),_vm._v(" "),_vm._t("skiplink"),_vm._v(" "),_c('div',{staticClass:"topbar__nav d-flex align-center"},[_vm._t("top-header-items")],2)],2)])};
var __vue_staticRenderFns__$H = [];

  /* style */
  const __vue_inject_styles__$H = undefined;
  /* scoped */
  const __vue_scope_id__$H = "data-v-1d234e5d";
  /* module identifier */
  const __vue_module_identifier__$H = undefined;
  /* functional template */
  const __vue_is_functional_template__$H = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$H = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$H, staticRenderFns: __vue_staticRenderFns__$H },
    __vue_inject_styles__$H,
    __vue_script__$H,
    __vue_scope_id__$H,
    __vue_is_functional_template__$H,
    __vue_module_identifier__$H,
    false,
    undefined,
    undefined,
    undefined
  );

//
var script$G = defineComponent({
  name: 'PHeaderButton',
  components: { VIcon, VBtn },
  props: {
    preset: {
      type: String,
      required: true,
      validator: function (value) {
        return ['signout', 'account'].indexOf(value) !== -1
      },
    },
  },
  setup (props) {
    const icons = {
      signout: '$icon-uitschrijven',
      account: '$icon-gebruiker',
    };
    return {
      icon: computed(() => icons[props.preset]),
    }
  },
});

/* script */
const __vue_script__$G = script$G;
/* template */
var __vue_render__$G = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"p-header-button px-4",attrs:{"color":"dark","text":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{staticClass:"p-header-button__icon mr-4",attrs:{"left":""}},[_vm._v("\n    "+_vm._s(_vm.icon)+"\n  ")]),_vm._v(" "),_vm._t("default")],2)};
var __vue_staticRenderFns__$G = [];

  /* style */
  const __vue_inject_styles__$G = undefined;
  /* scoped */
  const __vue_scope_id__$G = undefined;
  /* module identifier */
  const __vue_module_identifier__$G = undefined;
  /* functional template */
  const __vue_is_functional_template__$G = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$G = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$G, staticRenderFns: __vue_staticRenderFns__$G },
    __vue_inject_styles__$G,
    __vue_script__$G,
    __vue_scope_id__$G,
    __vue_is_functional_template__$G,
    __vue_module_identifier__$G,
    false,
    undefined,
    undefined,
    undefined
  );

var script$F = defineComponent({
    name: 'PIcon',
    components: { VIcon },
    props: {
        color: { type: String, default: undefined },
        left: { type: Boolean, default: undefined },
        right: { type: Boolean, default: undefined },
    },
});

/* script */
const __vue_script__$F = script$F;

/* template */
var __vue_render__$F = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":_vm.color,"left":_vm.left,"right":_vm.right}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$F = [];

  /* style */
  const __vue_inject_styles__$F = undefined;
  /* scoped */
  const __vue_scope_id__$F = undefined;
  /* module identifier */
  const __vue_module_identifier__$F = undefined;
  /* functional template */
  const __vue_is_functional_template__$F = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$F = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$F, staticRenderFns: __vue_staticRenderFns__$F },
    __vue_inject_styles__$F,
    __vue_script__$F,
    __vue_scope_id__$F,
    __vue_is_functional_template__$F,
    __vue_module_identifier__$F,
    false,
    undefined,
    undefined,
    undefined
  );

var script$E = defineComponent({
    name: 'PContactList',
    components: { PList: __vue_component__$P },
});

/* script */
const __vue_script__$E = script$E;

/* template */
var __vue_render__$E = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-list',{attrs:{"flat":""}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$E = [];

  /* style */
  const __vue_inject_styles__$E = undefined;
  /* scoped */
  const __vue_scope_id__$E = undefined;
  /* module identifier */
  const __vue_module_identifier__$E = undefined;
  /* functional template */
  const __vue_is_functional_template__$E = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$E = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$E, staticRenderFns: __vue_staticRenderFns__$E },
    __vue_inject_styles__$E,
    __vue_script__$E,
    __vue_scope_id__$E,
    __vue_is_functional_template__$E,
    __vue_module_identifier__$E,
    false,
    undefined,
    undefined,
    undefined
  );

var script$D = defineComponent({
    name: 'PListItemIcon',
    components: { VListItemIcon, PIcon: __vue_component__$F },
    props: {
        color: { type: String, default: undefined },
    },
});

/* script */
const __vue_script__$D = script$D;

/* template */
var __vue_render__$D = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-icon',_vm._g({},_vm.$listeners),[_c('p-icon',{attrs:{"color":_vm.color}},[_vm._t("default")],2)],1)};
var __vue_staticRenderFns__$D = [];

  /* style */
  const __vue_inject_styles__$D = undefined;
  /* scoped */
  const __vue_scope_id__$D = undefined;
  /* module identifier */
  const __vue_module_identifier__$D = undefined;
  /* functional template */
  const __vue_is_functional_template__$D = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$D = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$D, staticRenderFns: __vue_staticRenderFns__$D },
    __vue_inject_styles__$D,
    __vue_script__$D,
    __vue_scope_id__$D,
    __vue_is_functional_template__$D,
    __vue_module_identifier__$D,
    false,
    undefined,
    undefined,
    undefined
  );

const icon = {
    phone: '$icon-telefoon',
    email: '$icon-envelop',
    hulp: '$icon-helpdesk',
};
var script$C = defineComponent({
    name: 'PContactListItem',
    components: { PListItem: __vue_component__$O, PListItemContent: __vue_component__$N, PListItemIcon: __vue_component__$D },
    props: {
        type: {
            type: String,
            default: null,
            validator(value) {
                return ['phone', 'email', 'hulp'].indexOf(value) !== -1;
            },
        },
    },
    setup() {
        return {
            icon,
        };
    },
});

/* script */
const __vue_script__$C = script$C;
/* template */
var __vue_render__$C = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-list-item',{staticClass:"p-contact-list-item pb-1"},[(_vm.icon[_vm.type])?_c('p-list-item-icon',[_vm._v("\n    "+_vm._s(_vm.icon[_vm.type])+"\n  ")]):_vm._e(),_vm._v(" "),_c('p-list-item-content',[_vm._t("default")],2)],1)};
var __vue_staticRenderFns__$C = [];

  /* style */
  const __vue_inject_styles__$C = undefined;
  /* scoped */
  const __vue_scope_id__$C = "data-v-0f68c26a";
  /* module identifier */
  const __vue_module_identifier__$C = undefined;
  /* functional template */
  const __vue_is_functional_template__$C = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$C = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$C, staticRenderFns: __vue_staticRenderFns__$C },
    __vue_inject_styles__$C,
    __vue_script__$C,
    __vue_scope_id__$C,
    __vue_is_functional_template__$C,
    __vue_module_identifier__$C,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$B = defineComponent({
  name: 'PMenu',
  components: { VMenu },
  props: {
    offsetY: { type: Boolean, default: false },
    offsetX: { type: Boolean, default: false },
    left: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    contentClass: { type: String, default: undefined },
  },
});

/* script */
const __vue_script__$B = script$B;

/* template */
var __vue_render__$B = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',_vm._g({attrs:{"offset-x":_vm.offsetX,"offset-y":_vm.offsetY,"left":_vm.left,"right":_vm.right,"content-class":_vm.contentClass},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("activator",null,{"on":on,"attrs":attrs})]}}],null,true)},_vm.$listeners),[_vm._v(" "),_vm._t("default")],2)};
var __vue_staticRenderFns__$B = [];

  /* style */
  const __vue_inject_styles__$B = undefined;
  /* scoped */
  const __vue_scope_id__$B = undefined;
  /* module identifier */
  const __vue_module_identifier__$B = undefined;
  /* functional template */
  const __vue_is_functional_template__$B = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$B = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
    __vue_inject_styles__$B,
    __vue_script__$B,
    __vue_scope_id__$B,
    __vue_is_functional_template__$B,
    __vue_module_identifier__$B,
    false,
    undefined,
    undefined,
    undefined
  );

var script$A = defineComponent({
    name: 'PAriaLive',
    setup() {
        const politeMessage = ref(null);
        const assertiveMessage = ref(null);
        const announcePolite = (msg) => {
            politeMessage.value = { msg };
        };
        const announceAssertive = (msg) => {
            assertiveMessage.value = { msg };
        };
        provide(pAriaLiveDataProviderName, {
            politeMessage,
            assertiveMessage,
        });
        provide(pAriaLiveFunctionsProviderName, {
            announcePolite,
            announceAssertive,
        });
    },
});

/* script */
const __vue_script__$A = script$A;

/* template */
var __vue_render__$A = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)};
var __vue_staticRenderFns__$A = [];

  /* style */
  const __vue_inject_styles__$A = undefined;
  /* scoped */
  const __vue_scope_id__$A = undefined;
  /* module identifier */
  const __vue_module_identifier__$A = undefined;
  /* functional template */
  const __vue_is_functional_template__$A = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$A = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
    __vue_inject_styles__$A,
    __vue_script__$A,
    __vue_scope_id__$A,
    __vue_is_functional_template__$A,
    __vue_module_identifier__$A,
    false,
    undefined,
    undefined,
    undefined
  );

var script$z = defineComponent({
    name: 'PAriaLiveMessage',
    props: {
        ariaLive: {
            type: String,
            default: 'assertive',
            validator: (value) => ['assertive', 'polite'].indexOf(value) !== -1,
            required: true,
        },
        message: { type: Object, default: null },
    },
    setup(props) {
        const internalMessage = ref('');
        let timeoutIdentifier;
        watch(() => props.message, (message) => {
            if (!message || !message.msg) {
                return;
            }
            clearTimeout(timeoutIdentifier);
            timeoutIdentifier = undefined;
            internalMessage.value = message.msg;
            timeoutIdentifier = window.setTimeout(() => {
                internalMessage.value = '';
            }, 500);
        });
        return {
            internalMessage,
        };
    },
});

/* script */
const __vue_script__$z = script$z;

/* template */
var __vue_render__$z = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sr-only",attrs:{"aria-live":_vm.ariaLive,"aria-atomic":"true"}},[_vm._v("\n  "+_vm._s(_vm.internalMessage)+"\n")])};
var __vue_staticRenderFns__$z = [];

  /* style */
  const __vue_inject_styles__$z = undefined;
  /* scoped */
  const __vue_scope_id__$z = undefined;
  /* module identifier */
  const __vue_module_identifier__$z = undefined;
  /* functional template */
  const __vue_is_functional_template__$z = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$z = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
    __vue_inject_styles__$z,
    __vue_script__$z,
    __vue_scope_id__$z,
    __vue_is_functional_template__$z,
    __vue_module_identifier__$z,
    false,
    undefined,
    undefined,
    undefined
  );

var script$y = defineComponent({
    name: 'PAriaLiveMessagePair',
    components: { PAriaLiveMessage: __vue_component__$z },
    props: {
        ariaLive: {
            type: String,
            default: 'assertive',
            validator: (value) => ['assertive', 'polite'].indexOf(value) !== -1,
            required: true,
        },
        message: { type: Object, default: null },
    },
    setup(props) {
        const message1 = ref(null);
        const message2 = ref(null);
        let setFirstMessageField = true;
        watch(() => props.message, (message) => {
            if (!message || !message.msg) {
                return;
            }
            if (setFirstMessageField) {
                message1.value = { msg: message.msg };
                setFirstMessageField = false;
            }
            else {
                message2.value = { msg: message.msg };
                setFirstMessageField = true;
            }
        });
        return {
            message1,
            message2,
        };
    },
});

/* script */
const __vue_script__$y = script$y;

/* template */
var __vue_render__$y = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p-aria-live-message',{attrs:{"aria-live":_vm.ariaLive,"message":_vm.message1}}),_vm._v(" "),_c('p-aria-live-message',{attrs:{"aria-live":_vm.ariaLive,"message":_vm.message2}})],1)};
var __vue_staticRenderFns__$y = [];

  /* style */
  const __vue_inject_styles__$y = undefined;
  /* scoped */
  const __vue_scope_id__$y = undefined;
  /* module identifier */
  const __vue_module_identifier__$y = undefined;
  /* functional template */
  const __vue_is_functional_template__$y = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$y = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
    __vue_inject_styles__$y,
    __vue_script__$y,
    __vue_scope_id__$y,
    __vue_is_functional_template__$y,
    __vue_module_identifier__$y,
    false,
    undefined,
    undefined,
    undefined
  );

var script$x = defineComponent({
    name: 'PAriaLiveMessageBlock',
    components: { PAriaLiveMessagePair: __vue_component__$y },
    setup() {
        const ariaLiveProvider = inject(pAriaLiveDataProviderName);
        return {
            politeMessage: ariaLiveProvider ? ariaLiveProvider.politeMessage : null,
            assertiveMessage: ariaLiveProvider ? ariaLiveProvider.assertiveMessage : null,
        };
    },
});

/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$x = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p-aria-live-message-pair',{attrs:{"aria-live":"polite","message":_vm.politeMessage}}),_vm._v(" "),_c('p-aria-live-message-pair',{attrs:{"aria-live":"assertive","message":_vm.assertiveMessage}})],1)};
var __vue_staticRenderFns__$x = [];

  /* style */
  const __vue_inject_styles__$x = undefined;
  /* scoped */
  const __vue_scope_id__$x = undefined;
  /* module identifier */
  const __vue_module_identifier__$x = undefined;
  /* functional template */
  const __vue_is_functional_template__$x = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$x = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
    __vue_inject_styles__$x,
    __vue_script__$x,
    __vue_scope_id__$x,
    __vue_is_functional_template__$x,
    __vue_module_identifier__$x,
    false,
    undefined,
    undefined,
    undefined
  );

var script$w = defineComponent({
    name: 'PFormsStateManager',
    setup() {
        const formsState = ref({});
        const registerElement = (formId, elementId, state) => {
            // Element already registered, don't register again. For persistent form state.
            if (formsState.value[formId] && formsState.value[formId][elementId]) {
                return;
            }
            const newFormState = Object.assign(Object.assign({}, (formsState.value[formId] || {})), { [elementId]: Object.assign({}, state) });
            formsState.value = Object.assign(Object.assign({}, formsState.value), { [formId]: newFormState });
        };
        const deregisterElement = (formId, elementId) => {
            if (!formsState.value[formId]) {
                return;
            }
            if (Object.keys(formsState.value[formId]).length === 1) {
                const newAllState = Object.assign({}, formsState.value);
                delete newAllState[formId];
                formsState.value = newAllState;
            }
            else {
                const newFormState = Object.assign({}, formsState.value[formId]);
                delete newFormState[elementId];
                formsState.value = Object.assign(Object.assign({}, formsState.value), { [formId]: newFormState });
            }
        };
        const updateElement = (formId, elementId, partialState) => {
            if (!formsState.value[formId] || !formsState.value[formId][elementId]) {
                return;
            }
            const newFormState = Object.assign(Object.assign({}, formsState.value[formId]), { [elementId]: Object.assign(Object.assign({}, formsState.value[formId][elementId]), partialState) });
            if (JSON.stringify(newFormState) !== JSON.stringify(formsState.value[formId])) {
                formsState.value = Object.assign(Object.assign({}, formsState.value), { [formId]: newFormState });
            }
        };
        const updateAllElements = (partialState) => {
            if (!formsState.value) {
                return;
            }
            formsState.value = Object.keys(formsState.value).reduce((prevFormsState, formId) => (Object.assign(Object.assign({}, prevFormsState), { [formId]: Object.keys(formsState.value[formId]).reduce((prevForm, elementId) => (Object.assign(Object.assign({}, prevForm), { [elementId]: Object.assign(Object.assign({}, formsState.value[formId][elementId]), partialState) })), {}) })), {});
        };
        provide(formsStateManagerKey, {
            formsState,
            registerElement,
            deregisterElement,
            updateElement,
            updateAllElements,
        });
    },
});

/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$w = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)};
var __vue_staticRenderFns__$w = [];

  /* style */
  const __vue_inject_styles__$w = undefined;
  /* scoped */
  const __vue_scope_id__$w = undefined;
  /* module identifier */
  const __vue_module_identifier__$w = undefined;
  /* functional template */
  const __vue_is_functional_template__$w = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$w = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
    __vue_inject_styles__$w,
    __vue_script__$w,
    __vue_scope_id__$w,
    __vue_is_functional_template__$w,
    __vue_module_identifier__$w,
    false,
    undefined,
    undefined,
    undefined
  );

var script$v = defineComponent({
    name: 'PApp',
    components: { VApp, PAriaLive: __vue_component__$A, PAriaLiveMessageBlock: __vue_component__$x, PFormsStateManager: __vue_component__$w },
});

/* script */
const __vue_script__$v = script$v;
/* template */
var __vue_render__$v = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('p-forms-state-manager',[_c('p-aria-live',[_vm._t("default"),_vm._v(" "),_c('p-aria-live-message-block')],2)],1)],1)};
var __vue_staticRenderFns__$v = [];

  /* style */
  const __vue_inject_styles__$v = undefined;
  /* scoped */
  const __vue_scope_id__$v = undefined;
  /* module identifier */
  const __vue_module_identifier__$v = undefined;
  /* functional template */
  const __vue_is_functional_template__$v = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$v = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
    __vue_inject_styles__$v,
    __vue_script__$v,
    __vue_scope_id__$v,
    __vue_is_functional_template__$v,
    __vue_module_identifier__$v,
    false,
    undefined,
    undefined,
    undefined
  );

var script$u = defineComponent({
    name: 'PMain',
    components: { VMain },
});

/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$u = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',_vm._b({},'v-main',_vm.$attrs,false),[_vm._t("default")],2)};
var __vue_staticRenderFns__$u = [];

  /* style */
  const __vue_inject_styles__$u = undefined;
  /* scoped */
  const __vue_scope_id__$u = undefined;
  /* module identifier */
  const __vue_module_identifier__$u = undefined;
  /* functional template */
  const __vue_is_functional_template__$u = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$u = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
    __vue_inject_styles__$u,
    __vue_script__$u,
    __vue_scope_id__$u,
    __vue_is_functional_template__$u,
    __vue_module_identifier__$u,
    false,
    undefined,
    undefined,
    undefined
  );

var script$t = defineComponent({
    name: 'PLoadingIndicator',
    components: { VProgressCircular },
});

/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$t = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}},[_c('span',{staticClass:"sr-only",attrs:{"aria-live":"polite","aria-label":"Bezig met laden"}})])};
var __vue_staticRenderFns__$t = [];

  /* style */
  const __vue_inject_styles__$t = undefined;
  /* scoped */
  const __vue_scope_id__$t = undefined;
  /* module identifier */
  const __vue_module_identifier__$t = undefined;
  /* functional template */
  const __vue_is_functional_template__$t = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$t = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
    __vue_inject_styles__$t,
    __vue_script__$t,
    __vue_scope_id__$t,
    __vue_is_functional_template__$t,
    __vue_module_identifier__$t,
    false,
    undefined,
    undefined,
    undefined
  );

var script$s = defineComponent({
    name: 'PNotifyRequiredField',
});

/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$s = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ma-0",attrs:{"aria-hidden":"true"}},[_vm._v("\n  * = "+_vm._s(_vm.$t('requiredField'))+"\n")])};
var __vue_staticRenderFns__$s = [];

  /* style */
  const __vue_inject_styles__$s = undefined;
  /* scoped */
  const __vue_scope_id__$s = undefined;
  /* module identifier */
  const __vue_module_identifier__$s = undefined;
  /* functional template */
  const __vue_is_functional_template__$s = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$s = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
    __vue_inject_styles__$s,
    __vue_script__$s,
    __vue_scope_id__$s,
    __vue_is_functional_template__$s,
    __vue_module_identifier__$s,
    false,
    undefined,
    undefined,
    undefined
  );

var script$r = defineComponent({
    name: 'PTextField',
    components: { PInput: __vue_component__$$, VTextField },
    props: {
        value: { type: [String, Number], default: null },
        id: { type: String, default: null },
        dataUi: { type: String, default: null },
        label: { type: String, default: null },
        info: { type: String, default: null },
        suffix: { type: String, default: null },
        placeholder: { type: String, default: null },
        disabled: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        hint: { type: String, default: null },
        counter: { type: Boolean, default: false },
        autofocus: { type: Boolean, default: false },
        step: { type: Number, default: 1 },
        hideDetails: { type: Boolean, default: false },
        validation: { type: Object, default: () => ({ firstErrorMessage: null }) },
        currency: { type: Boolean, default: false },
        type: {
            type: String,
            default: 'text',
            validator: (value) => {
                return ['text', 'password', 'email', 'submit', 'number'].indexOf(value) !== -1;
            },
        },
        inputmode: { type: String, default: null },
        focus: { type: [String, Array], default: 'dark' },
    },
    setup(props, { slots, emit }) {
        const hasSlot = useHasSlot(slots);
        const customFocus = useCustomFocus(props.focus);
        const internalId = useIdGenerator('p-text-field').next();
        return {
            inputEventHandler: (payload) => {
                let content = payload instanceof Event || !['string', 'number'].includes(typeof payload)
                    ? props.value
                    : payload;
                if (typeof content === 'string') {
                    content = content.trim().replace(/\s+/g, props.currency ? '' : ' ');
                }
                emit('input', content);
            },
            hasSlot,
            customFocus,
            internalId,
        };
    },
});

/* script */
const __vue_script__$r = script$r;
/* template */
var __vue_render__$r = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-input',_vm._g({class:[
    'p-text-field',
    {'p-text-field--currency': _vm.currency},
    ("p-focus-" + (_vm.customFocus ? 'custom' : _vm.focus))
  ],style:(_vm.customFocus),attrs:{"id":_vm.id,"data-ui":_vm.dataUi,"label":_vm.label,"info":_vm.info,"disabled":_vm.disabled,"readonly":_vm.readonly,"autofocus":_vm.autofocus,"validation":_vm.validation,"hide-details":_vm.hideDetails,"hint":_vm.hint,"forms-state-manager-id":_vm.internalId},scopedSlots:_vm._u([{key:"post-label-input",fn:function(){return [_vm._t("label-info")]},proxy:true},{key:"default",fn:function(ref){
  var on = ref.on;
  var attrs = ref.attrs;
  var maxlength = ref.maxlength;
  var min = ref.min;
  var max = ref.max;
return [(_vm.readonly)?_c('input',_vm._b({staticClass:"p-text-field__readonly",attrs:{"type":_vm.type},domProps:{"value":_vm.value}},'input',Object.assign({}, attrs),false)):_c('v-text-field',_vm._g(_vm._b({attrs:{"value":_vm.value,"suffix":_vm.suffix,"type":_vm.type,"hide-details":"","inputmode":_vm.inputmode,"placeholder":_vm.placeholder,"maxlength":_vm.type === 'text' ? maxlength : null,"min":_vm.type === 'number' ? min : null,"max":_vm.type === 'number' ? max : null,"step":_vm.type === 'number' ? _vm.step : null,"counter":_vm.type === 'text' && maxlength ? _vm.counter : false,"outlined":""},on:{"input":_vm.inputEventHandler,"blur":_vm.inputEventHandler}},'v-text-field',attrs,false),on),[(_vm.currency)?_c('template',{slot:"prepend-inner"},[_vm._v("\n        €\n      ")]):_vm._e()],2)]}},(_vm.hasSlot('error-message'))?{key:"error-message",fn:function(){return [_vm._t("error-message")]},proxy:true}:null],null,true)},_vm.$listeners))};
var __vue_staticRenderFns__$r = [];

  /* style */
  const __vue_inject_styles__$r = undefined;
  /* scoped */
  const __vue_scope_id__$r = "data-v-a8565052";
  /* module identifier */
  const __vue_module_identifier__$r = undefined;
  /* functional template */
  const __vue_is_functional_template__$r = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$r = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
    __vue_inject_styles__$r,
    __vue_script__$r,
    __vue_scope_id__$r,
    __vue_is_functional_template__$r,
    __vue_module_identifier__$r,
    false,
    undefined,
    undefined,
    undefined
  );

var script$q = defineComponent({
    name: 'PTextarea',
    components: { PInput: __vue_component__$$, VTextarea },
    props: {
        value: { type: String, default: null },
        id: { type: String, default: null },
        dataUi: { type: String, default: null },
        label: { type: String, default: null },
        info: { type: String, default: null },
        placeholder: { type: String, default: null },
        disabled: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        counter: { type: Boolean, default: false },
        hint: { type: String, default: null },
        autofocus: { type: Boolean, default: false },
        noResize: { type: Boolean, default: false },
        rows: { type: Number, default: 5 },
        validation: { type: Object, default: () => ({ firstErrorMessage: null }) },
        focus: { type: [String, Array], default: 'dark' },
    },
    setup(props) {
        const customFocus = useCustomFocus(props.focus);
        const internalId = useIdGenerator('p-textarea').next();
        return {
            customFocus,
            internalId,
        };
    },
});

/* script */
const __vue_script__$q = script$q;
/* template */
var __vue_render__$q = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-input',_vm._g({class:[
    'p-textarea',
    ("p-focus-" + (_vm.customFocus ? 'custom' : _vm.focus))
  ],style:(_vm.customFocus),attrs:{"id":_vm.id,"data-ui":_vm.dataUi,"label":_vm.label,"info":_vm.info,"disabled":_vm.disabled,"readonly":_vm.readonly,"autofocus":_vm.autofocus,"validation":_vm.validation,"hint":_vm.hint,"forms-state-manager-id":_vm.internalId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var on = ref.on;
  var attrs = ref.attrs;
  var maxlength = ref.maxlength;
return [_c('v-textarea',_vm._g(_vm._b({attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"maxlength":maxlength,"counter":maxlength ? _vm.counter : false,"no-resize":_vm.noResize,"rows":_vm.rows,"outlined":""},on:{"input":function($event){return _vm.$emit('input', arguments[0])}}},'v-textarea',attrs,false),on))]}}])},_vm.$listeners))};
var __vue_staticRenderFns__$q = [];

  /* style */
  const __vue_inject_styles__$q = undefined;
  /* scoped */
  const __vue_scope_id__$q = "data-v-fcf0bcec";
  /* module identifier */
  const __vue_module_identifier__$q = undefined;
  /* functional template */
  const __vue_is_functional_template__$q = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$q = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
    __vue_inject_styles__$q,
    __vue_script__$q,
    __vue_scope_id__$q,
    __vue_is_functional_template__$q,
    __vue_module_identifier__$q,
    false,
    undefined,
    undefined,
    undefined
  );

var i18n$3 = {
    messages: {
        nl: {
            hint: 'Het datum formaat is DD-MM-JJJJ',
        },
    },
};

var script$p = defineComponent({
    name: 'PDatePickerTextField',
    components: { PInput: __vue_component__$$, VTextField },
    i18n: i18n$3,
    props: {
        value: { type: String, default: null },
        id: { type: String, default: null },
        internalId: { type: String, required: true },
        formsStateManagerId: { type: String, default: null },
        dataUi: { type: String, default: null },
        label: { type: String, default: null },
        info: { type: String, default: null },
        hint: { type: String, default: null },
        placeholder: { type: String, default: null },
        disabled: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        persistentHint: { type: Boolean, default: false },
        validation: { type: Object, required: true },
        holdValidation: { type: Boolean, default: false },
    },
});

/* script */
const __vue_script__$p = script$p;
/* template */
var __vue_render__$p = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-input',_vm._g({staticClass:"p-date-picker-text-field",attrs:{"id":_vm.id,"data-ui":_vm.dataUi,"label":_vm.label,"info":_vm.info,"validation":_vm.validation,"hold-validation":_vm.holdValidation,"hint":_vm.$t('hint'),"forms-state-manager-id":_vm.internalId,"persist-in-forms-state":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({staticClass:"p-date-picker-text-field__input",attrs:{"autocomplete":"off","value":_vm.value,"prepend-inner-icon":"$icon-kalender","placeholder":_vm.placeholder,"outlined":"","readonly":_vm.readonly},on:{"input":function($event){return _vm.$emit('input', arguments[0])}}},'v-text-field',attrs,false),on))]}}])},_vm.$listeners))};
var __vue_staticRenderFns__$p = [];

  /* style */
  const __vue_inject_styles__$p = undefined;
  /* scoped */
  const __vue_scope_id__$p = "data-v-5ad4bdbe";
  /* module identifier */
  const __vue_module_identifier__$p = undefined;
  /* functional template */
  const __vue_is_functional_template__$p = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$p = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
    __vue_inject_styles__$p,
    __vue_script__$p,
    __vue_scope_id__$p,
    __vue_is_functional_template__$p,
    __vue_module_identifier__$p,
    false,
    undefined,
    undefined,
    undefined
  );

var script$o = defineComponent({
    name: 'PDatePickerMenu',
    components: { VMenu, VDatePicker, PDatePickerTextField: __vue_component__$p },
    props: {
        label: { type: String, required: true },
        info: { type: String, default: null },
        validation: { type: Object, required: true },
        activePickerStart: { type: String, default: 'DATE' },
        pickerDate: { type: String, default: null },
        value: { type: String, default: null },
        id: { type: String, default: null },
        internalId: { type: String, required: true },
        dataUi: { type: String, default: '' },
    },
    setup(props, { emit }) {
        const toLocaleFormat = (d) => toLocaleString(d, '');
        const date = ref(props.value); // (ISO): yyyy-mm-dd
        const dateFormatted = ref(toLocaleFormat(date.value)); // (nl-NL): dd-mm-yyyy
        const menu = ref(false);
        const activePickerRef = ref(props.activePickerStart);
        const pickerDateRef = ref(props.pickerDate);
        const setDate = () => {
            date.value = dateString(dateFormatted.value, null);
        };
        const onPickerInput = (newDate) => {
            emit('picker-clicked');
            dateFormatted.value = toLocaleFormat(newDate);
            menu.value = false;
            setDate();
        };
        watch(() => date.value, (newValue) => {
            emit('input', newValue);
        });
        watch(() => props.value, (newValue) => {
            date.value = newValue;
            dateFormatted.value = toLocaleFormat(newValue);
        });
        watch(() => menu.value, (newValue) => {
            newValue && !date.value && setTimeout(() => (activePickerRef.value = props.activePickerStart));
        });
        watch(() => props.pickerDate, (newValue) => {
            pickerDateRef.value = newValue;
        });
        return {
            menu,
            date,
            dateFormatted,
            onPickerInput,
            setDate,
            activePickerRef,
            pickerDateRef,
        };
    },
});

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$o = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":0,"nudge-top":26,"transition":"scale-transition","offset-y":"","allow-overflow":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('p-date-picker-text-field',_vm._g({attrs:{"id":_vm.id,"internal-id":_vm.internalId,"hold-validation":_vm.menu,"validation":_vm.validation,"info":_vm.info,"label":_vm.label,"data-ui":_vm.dataUi},on:{"blur":_vm.setDate,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }_vm.menu = false;}},model:{value:(_vm.dateFormatted),callback:function ($$v) {_vm.dateFormatted=$$v;},expression:"dateFormatted"}},on))]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v;},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"min":_vm.validation.minDate,"max":_vm.validation.maxDate,"active-picker":_vm.activePickerRef,"picker-date":_vm.pickerDateRef,"color":"primary"},on:{"input":function($event){return _vm.onPickerInput($event)},"update:activePicker":function($event){_vm.activePickerRef=$event;},"update:active-picker":function($event){_vm.activePickerRef=$event;},"update:pickerDate":function($event){_vm.pickerDateRef=$event;},"update:picker-date":function($event){_vm.pickerDateRef=$event;}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v;},expression:"date"}})],1)};
var __vue_staticRenderFns__$o = [];

  /* style */
  const __vue_inject_styles__$o = undefined;
  /* scoped */
  const __vue_scope_id__$o = undefined;
  /* module identifier */
  const __vue_module_identifier__$o = undefined;
  /* functional template */
  const __vue_is_functional_template__$o = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$o = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
    __vue_inject_styles__$o,
    __vue_script__$o,
    __vue_scope_id__$o,
    __vue_is_functional_template__$o,
    __vue_module_identifier__$o,
    false,
    undefined,
    undefined,
    undefined
  );

var script$n = defineComponent({
    name: 'PDatePickerDialog',
    components: {
        PDatePickerTextField: __vue_component__$p,
        PButton: __vue_component__$1f,
        PButtonContainer: __vue_component__$12,
        VDatePicker,
        VDialog,
    },
    props: {
        label: { type: String, required: true },
        info: { type: String, default: null },
        validation: { type: Object, required: true },
        activePickerStart: { type: String, default: 'DATE' },
        pickerDate: { type: String, default: null },
        value: { type: String, default: null },
        id: { type: String, default: null },
        internalId: { type: String, required: true },
        dataUi: { type: String, default: '' },
    },
    setup(props, { emit }) {
        const date = ref(props.value);
        const selectedDate = ref(props.value);
        const modal = ref(false);
        const activePickerRef = ref(props.activePickerStart);
        const pickerDateRef = ref(props.pickerDate);
        watch(() => props.value, (newValue) => {
            date.value = newValue;
            selectedDate.value = newValue;
        });
        watch(() => modal.value, (newValue) => {
            newValue && !date.value && setTimeout(() => (activePickerRef.value = props.activePickerStart));
        });
        watch(() => props.pickerDate, (newValue) => {
            pickerDateRef.value = newValue;
        });
        const setDateFromInput = (data) => {
            modal.value = false;
            emit('input', data);
        };
        const cancel = () => {
            modal.value = false;
            selectedDate.value = date.value;
        };
        const onPickerInput = () => {
            emit('picker-clicked');
        };
        return {
            modal,
            date,
            selectedDate,
            cancel,
            setDateFromInput,
            onPickerInput,
            activePickerRef,
            pickerDateRef,
        };
    },
});

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$n = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.date,"persistent":"","width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event;},"update:return-value":function($event){_vm.date=$event;}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('p-date-picker-text-field',_vm._g(_vm._b({attrs:{"id":_vm.id,"value":_vm.$d(_vm.date, 'long'),"readonly":"","validation":_vm.validation,"info":_vm.info,"label":_vm.label,"data-ui":_vm.dataUi,"internal-id":_vm.internalId}},'p-date-picker-text-field',_vm.$attrs,false),on))]}}]),model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v;},expression:"modal"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":"","min":_vm.validation.minDate,"max":_vm.validation.maxDate,"color":"primary","active-picker":_vm.activePickerRef,"picker-date":_vm.pickerDateRef},on:{"input":function($event){return _vm.onPickerInput()},"update:activePicker":function($event){_vm.activePickerRef=$event;},"update:active-picker":function($event){_vm.activePickerRef=$event;},"update:pickerDate":function($event){_vm.pickerDateRef=$event;},"update:picker-date":function($event){_vm.pickerDateRef=$event;}},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v;},expression:"selectedDate"}},[_c('p-button-container',{staticClass:"flex-row flex-sm-column justify-space-between mb-2"},[_c('p-button',{on:{"click":function($event){return _vm.cancel()}}},[_vm._v("\n        "+_vm._s(_vm.$t('cancel'))+"\n      ")]),_vm._v(" "),_c('p-button',{on:{"click":function($event){return _vm.setDateFromInput(_vm.selectedDate)}}},[_vm._v("\n        "+_vm._s(_vm.$t('ok'))+"\n      ")])],1)],1)],1)};
var __vue_staticRenderFns__$n = [];

  /* style */
  const __vue_inject_styles__$n = undefined;
  /* scoped */
  const __vue_scope_id__$n = undefined;
  /* module identifier */
  const __vue_module_identifier__$n = undefined;
  /* functional template */
  const __vue_is_functional_template__$n = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$n = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
    __vue_inject_styles__$n,
    __vue_script__$n,
    __vue_scope_id__$n,
    __vue_is_functional_template__$n,
    __vue_module_identifier__$n,
    false,
    undefined,
    undefined,
    undefined
  );

var script$m = defineComponent({
    name: 'PDatePicker',
    components: { PDatePickerDialog: __vue_component__$n, PDatePickerMenu: __vue_component__$o },
    props: {
        label: { type: String, required: true },
        info: { type: String, default: null },
        validation: { type: Object, default: undefined },
        activePickerStart: { type: String, default: undefined },
        pickerDate: { type: String, default: null },
        value: { type: String, default: null },
        id: { type: String, default: null },
        dataUi: { type: String, default: '' },
        focus: { type: [String, Array], default: 'dark' },
    },
    setup(props, { emit }) {
        const internalId = useIdGenerator('p-date-picker').next();
        const updatedValue = ref(props.value || null);
        const customFocus = useCustomFocus(props.focus);
        const { manualDeregister, setDirty } = useFormsStateManager(internalId);
        const activePickerStartRef = ref(props.activePickerStart);
        const pickerDateRef = ref(props.pickerDate);
        watch(() => updatedValue.value, (newDate) => {
            emit('input', newDate);
        });
        watch(() => props.value, (newDate) => {
            updatedValue.value = newDate;
        });
        watch(() => props.activePickerStart, (newActivePickerStart) => {
            activePickerStartRef.value = newActivePickerStart;
        });
        watch(() => props.pickerDate, (newPickerDate) => {
            pickerDateRef.value = newPickerDate;
        });
        const onPickerClickedHandler = () => {
            setDirty();
        };
        manualDeregister();
        return Object.assign(Object.assign({ internalId }, useBreakpoints()), { updatedValue, fieldValidation: props.validation || { firstErrorMessage: null }, activePickerStartRef,
            pickerDateRef,
            customFocus,
            onPickerClickedHandler });
    },
});

/* script */
const __vue_script__$m = script$m;
/* template */
var __vue_render__$m = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'p-date-picker',
    ("p-focus-" + (_vm.customFocus ? 'custom' : _vm.focus))
  ],style:(_vm.customFocus)},[_c(_vm.isMobileView ? 'p-date-picker-dialog' : 'p-date-picker-menu',{ref:"pickerRef",tag:"component",attrs:{"label":_vm.label,"info":_vm.info,"validation":_vm.fieldValidation,"active-picker-start":_vm.activePickerStartRef,"picker-date":_vm.pickerDateRef,"id":_vm.id,"internal-id":_vm.internalId,"data-ui":_vm.dataUi},on:{"picker-clicked":_vm.onPickerClickedHandler},model:{value:(_vm.updatedValue),callback:function ($$v) {_vm.updatedValue=$$v;},expression:"updatedValue"}},[_vm._t("default")],2)],1)};
var __vue_staticRenderFns__$m = [];

  /* style */
  const __vue_inject_styles__$m = undefined;
  /* scoped */
  const __vue_scope_id__$m = undefined;
  /* module identifier */
  const __vue_module_identifier__$m = undefined;
  /* functional template */
  const __vue_is_functional_template__$m = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$m = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
    __vue_inject_styles__$m,
    __vue_script__$m,
    __vue_scope_id__$m,
    __vue_is_functional_template__$m,
    __vue_module_identifier__$m,
    false,
    undefined,
    undefined,
    undefined
  );

var script$l = defineComponent({
    name: 'PCheckbox',
    components: { VCheckbox, PInput: __vue_component__$$ },
    inheritAttrs: false,
    props: {
        id: { type: String, default: null },
        label: { type: String, required: true },
        value: { type: [String, Number, Boolean], default: false },
        disabled: { type: Boolean, default: false },
        autofocus: { type: Boolean, default: false },
        info: { type: String, default: null },
        dataUi: { type: String, default: null },
        readonly: { type: Boolean, default: false },
        validation: { type: Object, default: undefined },
        hideDetails: { type: Boolean, default: false },
        focus: { type: [String, Array], default: 'dark' },
        invert: { type: Boolean, default: false },
    },
    setup(props, { slots, emit }) {
        const internalId = useIdGenerator('p-checkbox').next();
        const hasSlot = useHasSlot(slots);
        const inputState = ref(props.value);
        const customFocus = useCustomFocus(props.focus);
        const handleChange = (payload) => {
            emit('input', payload);
        };
        watch(() => props.value, (v) => {
            inputState.value = v;
        });
        return {
            inputState,
            handleChange,
            hasSlot,
            checkboxValidation: props.validation || { firstErrorMessage: null },
            customFocus,
            internalId,
        };
    },
});

/* script */
const __vue_script__$l = script$l;
/* template */
var __vue_render__$l = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-input',_vm._g({class:[
    'p-checkbox',
    ("p-focus-" + (_vm.customFocus ? 'custom' : _vm.focus))
  ],style:(_vm.customFocus),attrs:{"id":_vm.id,"data-ui":_vm.dataUi,"validation":_vm.checkboxValidation,"disabled":_vm.disabled,"readonly":_vm.readonly,"autofocus":_vm.autofocus,"hide-details":_vm.hideDetails,"forms-state-manager-id":_vm.internalId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var on = ref.on;
  var attrs = ref.attrs;
  var required = ref.required;
return [_c('v-checkbox',_vm._g(_vm._b({staticClass:"p-checkbox__button",attrs:{"ripple":"","info":_vm.info,"dark":_vm.invert},on:{"change":_vm.handleChange},model:{value:(_vm.inputState),callback:function ($$v) {_vm.inputState=$$v;},expression:"inputState"}},'v-checkbox',attrs,false),on),[_c('template',{slot:"label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n      "),(required)?_c('span',{staticClass:"ml-1",attrs:{"aria-hidden":"true"}},[_vm._v("\n        *\n      ")]):_vm._e(),_vm._v(" "),_vm._t("label-info")],2)],2)]}}],null,true)},_vm.$listeners))};
var __vue_staticRenderFns__$l = [];

  /* style */
  const __vue_inject_styles__$l = undefined;
  /* scoped */
  const __vue_scope_id__$l = "data-v-f4f52d14";
  /* module identifier */
  const __vue_module_identifier__$l = undefined;
  /* functional template */
  const __vue_is_functional_template__$l = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$l = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
    __vue_inject_styles__$l,
    __vue_script__$l,
    __vue_scope_id__$l,
    __vue_is_functional_template__$l,
    __vue_module_identifier__$l,
    false,
    undefined,
    undefined,
    undefined
  );

class UseGroupValidation {
    constructor(props) {
        this.props = props;
        this.errorMessage = ref('');
        this.shouldValidate = ref(false);
        this.linkedFormFields = ref({});
        this.linkedFormFieldsInError = ref(false);
        this.i18n = useI18n();
        this.validation = new UseValidation({ validation: props.validation }, this.i18n, this.validate.bind(this), () => this.shouldValidate.value);
        watch(this.linkedFormFields, () => {
            this.linkedFormFieldsInError.value = Object.keys(this.linkedFormFields.value).some(key => (this.linkedFormFields.value)[key].isInError);
        });
    }
    validate(force) {
        if (force) {
            this.shouldValidate.value = true;
        }
        this.errorMessage.value = this.shouldValidate.value ? this.validation.getValidationMessage() : '';
        this.forceErrorState(!!this.errorMessage.value);
        return !this.validation.isInError.value;
    }
    forceErrorState(state) {
        this.validation.isInError.value = state;
    }
    setGroupField(id, isInError) {
        this.linkedFormFields.value = Object.assign(Object.assign({}, this.linkedFormFields.value), { [id]: { isInError } });
    }
    deleteGroupField(id) {
        const newFields = Object.assign({}, this.linkedFormFields.value);
        delete newFields[id];
        this.linkedFormFields.value = newFields;
    }
    initValidator() {
        const errorId = useIdGenerator('p-group-validation-error').next();
        provide(groupValidationProviderName, reactive({
            hasGroupValidation: true,
            isInError: computed(() => !this.linkedFormFieldsInError.value && this.validation.isInError.value),
            errorMessage: computed(() => this.linkedFormFieldsInError.value ? '' : this.errorMessage.value),
            errorId,
            setAriaDescribedby: computed(() => !this.linkedFormFieldsInError.value && !this.props.noAriaDescribedby),
            setGroupField: this.setGroupField.bind(this),
            deleteGroupField: this.deleteGroupField.bind(this),
            validate: this.validate.bind(this),
            hideChildValidationOnError: computed(() => !this.props.alwaysReserveChildErrorSpace),
            isRequired: computed(() => this.validation.isRequired.value),
        }));
    }
}

var script$k = defineComponent({
    name: 'PGroupValidation',
    props: {
        validation: {
            type: Object,
            required: true,
        },
        noAriaDescribedby: { type: Boolean },
        alwaysReserveChildErrorSpace: { type: Boolean },
    },
    setup(props) {
        new UseGroupValidation(props).initValidator();
    },
});

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$k = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)};
var __vue_staticRenderFns__$k = [];

  /* style */
  const __vue_inject_styles__$k = undefined;
  /* scoped */
  const __vue_scope_id__$k = undefined;
  /* module identifier */
  const __vue_module_identifier__$k = undefined;
  /* functional template */
  const __vue_is_functional_template__$k = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$k = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
    __vue_inject_styles__$k,
    __vue_script__$k,
    __vue_scope_id__$k,
    __vue_is_functional_template__$k,
    __vue_module_identifier__$k,
    false,
    undefined,
    undefined,
    undefined
  );

var i18n$2 = {
    messages: {
        nl: {
            requiredLegendText: 'Verplicht',
        },
    },
};

var script$j = defineComponent({
    name: 'PGroupValidationError',
    props: {
        ariaLive: {
            type: String,
            default: 'assertive',
            validator: (value) => ['assertive', 'polite', 'off'].indexOf(value) !== -1,
        },
    },
    setup(_, { slots }) {
        const groupValidationApi = inject(groupValidationProviderName);
        const hasSlot = useHasSlot(slots);
        return {
            groupValidationApi,
            hasSlot,
        };
    },
});

/* script */
const __vue_script__$j = script$j;
/* template */
var __vue_render__$j = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"aria-live":_vm.ariaLive === 'off' ? null : _vm.ariaLive,"aria-atomic":_vm.ariaLive === 'off' ? null : 'true'}},[(_vm.hasSlot('default'))?[_vm._t("default",null,{"isInError":_vm.groupValidationApi.isInError,"errorMessage":_vm.groupValidationApi.errorMessage})]:_c('div',{class:[
      'p-group-validation-error__message v-messages theme--light',
      _vm.groupValidationApi.isInError? 'p-group-validation-error__message--has-error pr-4': ''
    ]},[(_vm.groupValidationApi.isInError)?_c('span',{staticClass:"p-input__error v-messages__message error--text",attrs:{"id":_vm.groupValidationApi.setAriaDescribedby ? _vm.groupValidationApi.errorId : null}},[_vm._v(_vm._s(_vm.groupValidationApi.errorMessage))]):_vm._e()])],2)};
var __vue_staticRenderFns__$j = [];

  /* style */
  const __vue_inject_styles__$j = undefined;
  /* scoped */
  const __vue_scope_id__$j = "data-v-f944d66e";
  /* module identifier */
  const __vue_module_identifier__$j = undefined;
  /* functional template */
  const __vue_is_functional_template__$j = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$j = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    false,
    undefined,
    undefined,
    undefined
  );

var script$i = defineComponent({
    name: 'PFieldsetLegend',
    components: { PInfo: __vue_component__$16, PGroupValidationError: __vue_component__$j },
    i18n: i18n$2,
    props: {
        legendText: { type: String, default: '', required: true },
        useStandardLabels: { type: Boolean },
        info: { type: String, default: null },
        hint: { type: String, default: null },
    },
    setup() {
        const groupValidationApi = inject(groupValidationProviderName, { hasGroupValidation: false, isInError: false, hideChildValidationOnError: false });
        return {
            groupValidationApi,
        };
    },
});

/* script */
const __vue_script__$i = script$i;
/* template */
var __vue_render__$i = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('legend',{class:[
    'p-fieldset-legend',
    _vm.useStandardLabels ? 'pb-4' : 'pb-2',
    {
      'p-fieldset-legend--as-label': !_vm.useStandardLabels,
      'error--text': !_vm.useStandardLabels && _vm.groupValidationApi.isInError
    }
  ]},[_c('span',{staticClass:"p-fieldset-legend__text-container d-flex"},[_vm._v("\n    "+_vm._s(_vm.legendText)+"\n    "),(_vm.groupValidationApi.isRequired)?_c('span',{staticClass:"ml-1",attrs:{"aria-hidden":"true"}},[_vm._v("\n      *\n    ")]):_vm._e(),_vm._v(" "),(_vm.groupValidationApi.isRequired)?_c('span',{staticClass:"sr-only"},[_vm._v(" "+_vm._s(_vm.$t('requiredLegendText')))]):_vm._e(),_vm._v(" "),_c('p-group-validation-error',{scopedSlots:_vm._u([{key:"default",fn:function(){return [(_vm.groupValidationApi.isInError)?_c('span',{staticClass:"sr-only"},[_vm._v(" "+_vm._s(_vm.groupValidationApi.errorMessage))]):_vm._e()]},proxy:true}])}),_vm._v(" "),_vm._t("label-info",function(){return [(_vm.info && !_vm.useStandardLabels)?_c('p-info',{attrs:{"linked-label-text":_vm.legendText,"message":_vm.info}}):_vm._e()]})],2),_vm._v(" "),(_vm.hint && !_vm.useStandardLabels)?_c('span',{staticClass:"p-fieldset-legend__hint font-italic font-weight-regular"},[_vm._v("\n    "+_vm._s(_vm.hint)+"\n  ")]):_vm._e()])};
var __vue_staticRenderFns__$i = [];

  /* style */
  const __vue_inject_styles__$i = undefined;
  /* scoped */
  const __vue_scope_id__$i = "data-v-82e30f72";
  /* module identifier */
  const __vue_module_identifier__$i = undefined;
  /* functional template */
  const __vue_is_functional_template__$i = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$i = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    false,
    undefined,
    undefined,
    undefined
  );

var script$h = defineComponent({
    name: 'PFieldset',
    props: {
        legendText: { type: String, default: '', required: true },
        useStandardLabels: { type: Boolean },
        alwaysReserveChildErrorSpace: { type: Boolean },
        validation: {
            type: Object,
            required: true,
        },
        info: { type: String, default: null },
        hint: { type: String, default: null },
    },
    components: {
        PFieldsetLegend: __vue_component__$i,
        PGroupValidation: __vue_component__$k,
    },
    setup(props) {
        if (props.legendText === '') {
            logWarning('PFieldset has no legend, please provide a `legend-text`');
        }
        provide(fieldsetProviderName, reactive({
            visuallyHideLabels: computed(() => !props.useStandardLabels),
        }));
    },
});

/* script */
const __vue_script__$h = script$h;
/* template */
var __vue_render__$h = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-group-validation',{attrs:{"validation":_vm.validation,"always-reserve-child-error-space":_vm.alwaysReserveChildErrorSpace,"no-aria-describedby":""}},[_c('fieldset',{staticClass:"p-fieldset"},[(_vm.legendText)?_c('p-fieldset-legend',{attrs:{"legend-text":_vm.legendText,"use-standard-labels":_vm.useStandardLabels,"hint":_vm.hint,"info":_vm.info},scopedSlots:_vm._u([{key:"label-info",fn:function(){return [_vm._t("label-info")]},proxy:true}],null,true)}):_vm._e(),_vm._v(" "),_vm._t("default")],2)])};
var __vue_staticRenderFns__$h = [];

  /* style */
  const __vue_inject_styles__$h = undefined;
  /* scoped */
  const __vue_scope_id__$h = "data-v-6eb49ee8";
  /* module identifier */
  const __vue_module_identifier__$h = undefined;
  /* functional template */
  const __vue_is_functional_template__$h = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$h = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    undefined,
    undefined,
    undefined
  );

var script$g = defineComponent({
    name: 'PFieldsetError',
    components: {
        PGroupValidationError: __vue_component__$j,
    },
});

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-group-validation-error',{attrs:{"aria-live":"off"}})};
var __vue_staticRenderFns__$g = [];

  /* style */
  const __vue_inject_styles__$g = undefined;
  /* scoped */
  const __vue_scope_id__$g = undefined;
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$g = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    undefined,
    undefined,
    undefined
  );

var script$f = defineComponent({
    name: 'PRadioGroup',
    components: { PFieldset: __vue_component__$h, PFieldsetError: __vue_component__$g, PInput: __vue_component__$$, VIcon },
    inheritAttrs: false,
    props: {
        value: { type: [String, Number, Boolean], default: null },
        items: { type: Array, required: true },
        isColumn: { type: Boolean, default: false },
        id: { type: String, default: undefined },
        name: { type: String, default: undefined },
        label: { type: String, required: true },
        info: { type: String, default: null },
        dataUi: { type: String, default: null },
        validation: { type: Object, default: undefined },
        focus: { type: [String, Array], default: 'dark' },
        invert: { type: Boolean, default: false },
    },
    setup(props, { emit }) {
        const internalId = useIdGenerator('p-radio-group').next();
        const radioGroupId = props.id || props.name || useIdGenerator('radio-group').next();
        const itemsWithIds = computed(() => props.items && props.items.map((item) => (Object.assign(Object.assign({}, (typeof item !== 'object' ? { value: item } : item)), { label: item.label || item.value || item, id: item.id || useIdGenerator(radioGroupId).next(), name: props.name || radioGroupId }))));
        const customFocus = useCustomFocus(props.focus);
        const modelValue = ref(props.value);
        watch(() => props.value, (v) => {
            modelValue.value = v;
        });
        watch(() => modelValue.value, (vnew, vold) => {
            if (vold !== undefined) {
                emit('input', vnew);
            }
        });
        return {
            radioGroupId,
            modelValue,
            radioValidation: props.validation || { firstErrorMessage: null },
            itemsWithIds,
            customFocus,
            internalId,
        };
    },
});

/* script */
const __vue_script__$f = script$f;
/* template */
var __vue_render__$f = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-fieldset',{class:[
    'p-radio-group',
    ("p-focus-" + (_vm.customFocus ? 'custom' : _vm.focus)),
    _vm.invert ? 'p-invert' : '' ],style:(_vm.customFocus),attrs:{"id":_vm.radioGroupId,"data-ui":_vm.dataUi,"validation":_vm.radioValidation,"legend-text":_vm.label,"info":_vm.info},scopedSlots:_vm._u([{key:"label-info",fn:function(){return [_vm._t("label-info")]},proxy:true}],null,true)},[_vm._v(" "),_c('div',{class:[_vm.isColumn ? 'p-radio-group--column' : 'p-radio-group--row', 'mt-1 mb-1 pt-0']},_vm._l((_vm.itemsWithIds),function(item,index){return _c('div',{key:item.value,class:['p-radio-button', index === (_vm.items.length - 1) && !_vm.isColumn ? 'mr-0' : 'mr-8']},[_c('p-input',{attrs:{"hide-details":true,"data-ui":_vm.dataUi ? (_vm.dataUi + "-" + index) : undefined,"forms-state-manager-id":_vm.internalId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var on = ref.on;
  var attrs = ref.attrs;
return [_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.modelValue),expression:"modelValue"}],staticClass:"sr-only",attrs:{"type":"radio","id":item.id,"name":item.name,"aria-required":_vm.radioValidation.required},domProps:{"value":item.value,"checked":_vm._q(_vm.modelValue,item.value)},on:{"change":function($event){_vm.modelValue=item.value;}}},'input',attrs,false),on)),_vm._v(" "),_c('label',{staticClass:"font-weight-regular pb-0",attrs:{"for":item.id}},[_c('div',{staticClass:"p-radio-icon"},[_c('v-icon',{staticClass:"p-radio-icon--off"},[_vm._v("\n                $radioOff\n              ")]),_vm._v(" "),_c('v-icon',{staticClass:"p-radio-icon--on"},[_vm._v("\n                $radioOn\n              ")])],1),_vm._v(" "),_c('span',{staticClass:"p-radio-label"},[_vm._v(_vm._s(item.label))])])]}}],null,true)})],1)}),0),_vm._v(" "),_c('div',{staticClass:"mb-4 mt-2 pr-4"},[_c('p-fieldset-error')],1)])};
var __vue_staticRenderFns__$f = [];

  /* style */
  const __vue_inject_styles__$f = undefined;
  /* scoped */
  const __vue_scope_id__$f = "data-v-652acbfc";
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    undefined,
    undefined,
    undefined
  );

/**
 * Creates a XHR request
 *
 * @param {Object} options
 */
const createRequest = (options) => {
  const xhr = new XMLHttpRequest();
  xhr.open(options.method || 'GET', options.url);
  xhr.responseType = 'json';
  if (options.headers) {
    Object.keys(options.headers).forEach(key => {
      xhr.setRequestHeader(key, options.headers[key]);
    });
  }

  return xhr
};

/**
 * Sends a XHR request with certain body
 *
 * @param {XMLHttpRequest} xhr
 * @param {Object} body
 */
const sendRequest = (xhr, body) => {
  return new Promise((resolve, reject) => {
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        var response;
        try {
          response = JSON.parse(xhr.response);
        } catch (err) {
          response = xhr.response;
        }
        resolve(response);
      } else {
        reject(xhr.response);
      }
    };
    xhr.onerror = () => reject(xhr.response);
    xhr.send(JSON.stringify(body));
  })
};

/**
 * Sends a XHR request with certain form data
 *
 * @param {XMLHttpRequest} xhr
 * @param {Object} data
 */
const sendFormRequest = (xhr, data) => {
  const body = new FormData();
  for (var name in data) {
    body.append(name, data[name]);
  }

  return new Promise((resolve, reject) => {
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        var response;
        try {
          response = JSON.parse(xhr.response);
        } catch (err) {
          response = xhr.response;
        }
        resolve(response);
      } else {
        reject(xhr.response);
      }
    };
    xhr.onerror = () => reject(xhr.response);
    xhr.send(body);
  })
};

/**
 * Creates and sends XHR request
 *
 * @param {Object} options
 *
 * @returns Promise
 */
function request (options) {
  const xhr = createRequest(options);

  return sendRequest(xhr, options.body)
}

class ChunkUploadHandler {
  /**
   * Constructor
   *
   * @param {File} file
   * @param {Object} options
   */
  constructor(file, options) {
    this.file = file;
    this.options = options;
    this.chunks = [];
    this.sessionId = null;
    this.chunkSize = null;
    this.speedInterval = null;
  }

  /**
   * Gets the max retries from options
   */
  get maxRetries() {
    return parseInt(this.options.maxRetries, 10)
  }

  /**
   * Gets the max number of active chunks being uploaded at once from options
   */
  get maxActiveChunks() {
    return parseInt(this.options.maxActive, 10)
  }

  /**
   * Gets the file type
   */
  get fileType() {
    return this.file.type
  }

  /**
   * Gets the file size
   */
  get fileSize() {
    return this.file.size
  }

  /**
   * Gets the file name
   */
  get fileName() {
    return this.file.name
  }

  /**
   * Gets action (url) to upload the file
   */
  get action() {
    return this.options.action || null
  }

  /**
   * Gets the body to be merged when sending the request in start phase
   */
  get startBody() {
    return this.options.startBody || {}
  }

  /**
   * Gets the body to be merged when sending the request in upload phase
   */
  get uploadBody() {
    return this.options.uploadBody || {}
  }

  /**
   * Gets the body to be merged when sending the request in finish phase
   */
  get finishBody() {
    return this.options.finishBody || {}
  }

  /**
   * Gets the headers of the requests from options
   */
  get headers() {
    return this.options.headers || {}
  }

  /**
   * Whether it's ready to upload files or not
   */
  get readyToUpload() {
    return !!this.chunks
  }

  /**
   * Gets the progress of the chunk upload
   * - Gets all the completed chunks
   * - Gets the progress of all the chunks that are being uploaded
   */
  get progress() {
    const completedProgress = (this.chunksUploaded.length / this.chunks.length) * 100;
    const uploadingProgress = this.chunksUploading.reduce((progress, chunk) => {
      return progress + ((chunk.progress | 0) / this.chunks.length)
    }, 0);

    return Math.min(completedProgress + uploadingProgress, 100)
  }

  /**
   * Gets all the chunks that are pending to be uploaded
   */
  get chunksToUpload() {
    return this.chunks.filter(chunk => {
      return !chunk.active && !chunk.uploaded
    })
  }

  /**
   * Whether there are chunks to upload or not
   */
  get hasChunksToUpload() {
    return this.chunksToUpload.length > 0
  }

  /**
   * Gets all the chunks that are uploading
   */
  get chunksUploading() {
    return this.chunks.filter(chunk => {
      return !!chunk.xhr && !!chunk.active
    })
  }

  /**
   * Gets all the chunks that have finished uploading
   */
  get chunksUploaded() {
    return this.chunks.filter(chunk => {
      return !!chunk.uploaded
    })
  }

  /**
   * Creates all the chunks in the initial state
   */
  createChunks() {
    this.chunks = [];

    let start = 0;
    let end = this.chunkSize;
    while (start < this.fileSize) {
      this.chunks.push({
        blob: this.file.file.slice(start, end),
        startOffset: start,
        active: false,
        retries: this.maxRetries
      });
      start = end;
      end = start + this.chunkSize;
    }
  }

  /**
   * Updates the progress of the file with the handler's progress
   */
  updateFileProgress() {
    this.file.progress = this.progress;
  }

  /**
   * Paues the upload process
   * - Stops all active requests
   * - Sets the file not active
   */
  pause() {
    this.file.active = false;
    this.stopChunks();
  }

  /**
   * Stops all the current chunks
   */
  stopChunks() {
    this.chunksUploading.forEach(chunk => {
      chunk.xhr.abort();
      chunk.active = false;
    });

    this.stopSpeedCalc();
  }

  /**
   * Resumes the file upload
   * - Sets the file active
   * - Starts the following chunks
   */
  resume() {
    this.file.active = true;
    this.startChunking();
  }

  /**
   * Starts the file upload
   *
   * @returns Promise
   * - resolve  The file was uploaded
   * - reject   The file upload failed
   */
  upload() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
    this.start();

    return this.promise
  }

  /**
   * Start phase
   * Sends a request to the backend to initialise the chunks
   */
  start() {
    request({
      method: 'POST',
      headers: Object.assign({}, this.headers, {
        'Content-Type': 'application/json'
      }),
      url: this.action,
      body: Object.assign(this.startBody, {
        phase: 'start',
        mime_type: this.fileType,
        size: this.fileSize,
        name: this.fileName
      })
    }).then(res => {
      if (res.status !== 'success') {
        this.file.response = res;
        return this.reject('server')
      }

      this.sessionId = res.data.session_id;
      this.chunkSize = res.data.end_offset;

      this.createChunks();
      this.startChunking();
    }).catch(res => {
      this.file.response = res;
      this.reject('server');
    });
  }

  /**
   * Starts to upload chunks
   */
  startChunking() {
    for (let i = 0; i < this.maxActiveChunks; i++) {
      this.uploadNextChunk();
    }

    this.startSpeedCalc();
  }

  /**
   * Uploads the next chunk
   * - Won't do anything if the process is paused
   * - Will start finish phase if there are no more chunks to upload
   */
  uploadNextChunk() {
    if (this.file.active) {
      if (this.hasChunksToUpload) {
        return this.uploadChunk(this.chunksToUpload[0])
      }

      if (this.chunksUploading.length === 0) {
        return this.finish()
      }
    }
  }

  /**
   * Uploads a chunk
   * - Sends the chunk to the backend
   * - Sets the chunk as uploaded if everything went well
   * - Decreases the number of retries if anything went wrong
   * - Fails if there are no more retries
   *
   * @param {Object} chunk
   */
  uploadChunk(chunk) {
    chunk.progress = 0;
    chunk.active = true;
    this.updateFileProgress();
    chunk.xhr = createRequest({
      method: 'POST',
      headers: this.headers,
      url: this.action
    });

    chunk.xhr.upload.addEventListener('progress', function (evt) {
      if (evt.lengthComputable) {
        chunk.progress = Math.round(evt.loaded / evt.total * 100);
      }
    }, false);

    sendFormRequest(chunk.xhr, Object.assign(this.uploadBody, {
      phase: 'upload',
      session_id: this.sessionId,
      start_offset: chunk.startOffset,
      chunk: chunk.blob
    })).then(res => {
      chunk.active = false;
      if (res.status === 'success') {
        chunk.uploaded = true;
      } else {
        if (chunk.retries-- <= 0) {
          this.stopChunks();
          return this.reject('upload')
        }
      }

      this.uploadNextChunk();
    }).catch(() => {
      chunk.active = false;
      if (chunk.retries-- <= 0) {
        this.stopChunks();
        return this.reject('upload')
      }

      this.uploadNextChunk();
    });
  }

  /**
   * Finish phase
   * Sends a request to the backend to finish the process
   */
  finish() {
    this.updateFileProgress();
    this.stopSpeedCalc();

    request({
      method: 'POST',
      headers: Object.assign({}, this.headers, {
        'Content-Type': 'application/json'
      }),
      url: this.action,
      body: Object.assign(this.finishBody, {
        phase: 'finish',
        session_id: this.sessionId
      })
    }).then(res => {
      this.file.response = res;
      if (res.status !== 'success') {
        return this.reject('server')
      }

      this.resolve(res);
    }).catch(res => {
      this.file.response = res;
      this.reject('server');
    });
  }


  /**
   * Sets an interval to calculate and
   * set upload speed every 3 seconds
   */
  startSpeedCalc() {
    this.file.speed = 0;
    let lastUploadedBytes = 0;
    if (!this.speedInterval) {
      this.speedInterval = window.setInterval(() => {
        let uploadedBytes = (this.progress / 100) * this.fileSize;
        this.file.speed = (uploadedBytes - lastUploadedBytes);
        lastUploadedBytes = uploadedBytes;
      }, 1000);
    }
  }

  /**
   * Removes the upload speed interval
   */
  stopSpeedCalc() {
    this.speedInterval && window.clearInterval(this.speedInterval);
    this.speedInterval = null;
    this.file.speed = 0;
  }
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$e = {
  methods: {
    change(e) {
      this.$parent.addInputFile(e.target);
      if (e.target.files) {
        e.target.value = '';
        if (e.target.files.length && !/safari/i.test(navigator.userAgent)) {
          e.target.type = '';
          e.target.type = 'file';
        }
      } else {
        // ie9 fix #219
        this.$destroy();
        // eslint-disable-next-line
        new this.constructor({
          parent: this.$parent,
          el: this.$el,
        });
      }
    }
  }
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","name":_vm.$parent.name,"id":_vm.$parent.inputId || _vm.$parent.name,"accept":_vm.$parent.accept,"capture":_vm.$parent.capture,"disabled":_vm.$parent.disabled,"webkitdirectory":_vm.$parent.directory && _vm.$parent.features.directory ? true : undefined,"directory":_vm.$parent.directory && _vm.$parent.features.directory ? true : undefined,"multiple":_vm.$parent.multiple && _vm.$parent.features.html5},on:{"change":_vm.change}})};
var __vue_staticRenderFns__$e = [];

  /* style */
  const __vue_inject_styles__$e = undefined;
  /* scoped */
  const __vue_scope_id__$e = undefined;
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    undefined,
    undefined,
    undefined
  );

//

const CHUNK_DEFAULT_OPTIONS = {
  headers: {},
  action: '',
  minSize: 1048576,
  maxActive: 3,
  maxRetries: 5,

  handler: ChunkUploadHandler
};

var script$d = {
  components: {
    InputFile: __vue_component__$e,
  },
  props: {
    inputId: {
      type: String,
    },

    name: {
      type: String,
      default: 'file',
    },

    accept: {
      type: String,
    },

    capture: {
    },

    disabled: {
    },

    multiple: {
      type: Boolean,
    },

    maximum: {
      type: Number,
      default() {
        return this.multiple ? 0 : 1
      }
    },

    addIndex: {
      type: [Boolean, Number],
    },

    directory: {
      type: Boolean,
    },

    postAction: {
      type: String,
    },

    putAction: {
      type: String,
    },

    customAction: {
      type: Function,
    },

    headers: {
      type: Object,
      default: Object,
    },

    data: {
      type: Object,
      default: Object,
    },

    timeout: {
      type: Number,
      default: 0,
    },


    drop: {
      default: false,
    },

    dropDirectory: {
      type: Boolean,
      default: true,
    },

    size: {
      type: Number,
      default: 0,
    },

    extensions: {
      default: Array,
    },


    value: {
      type: Array,
      default: Array,
    },

    thread: {
      type: Number,
      default: 1,
    },

    // Chunk upload enabled
    chunkEnabled: {
      type: Boolean,
      default: false
    },

    // Chunk upload properties
    chunk: {
      type: Object,
      default: () => {
        return CHUNK_DEFAULT_OPTIONS
      }
    }
  },

  data() {
    return {
      files: this.value,
      features: {
        html5: true,
        directory: false,
        drop: false,
      },

      active: false,
      dropActive: false,

      uploading: 0,

      destroy: false,
    }
  },


  /**
   * mounted
   * @return {[type]} [description]
   */
  mounted() {
    let input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;

    // html5 特征
    if (window.FormData && input.files) {
      // 上传目录特征
      if (typeof input.webkitdirectory === 'boolean' || typeof input.directory === 'boolean') {
        this.features.directory = true;
      }

      // 拖拽特征
      if (this.features.html5 && typeof input.ondrop !== 'undefined') {
        this.features.drop = true;
      }
    } else {
      this.features.html5 = false;
    }

    // files 定位缓存
    this.maps = {};
    if (this.files) {
      for (let i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        this.maps[file.id] = file;
      }
    }

    this.$nextTick(function () {

      // 更新下父级
      if (this.$parent) {
        this.$parent.$forceUpdate();
        // 拖拽渲染
        this.$parent.$nextTick(() => {
          this.watchDrop(this.drop);
        });
      } else {
        // 拖拽渲染
        this.watchDrop(this.drop);
      }
    });
  },

  /**
   * beforeDestroy
   * @return {[type]} [description]
   */
  beforeDestroy() {
    // 已销毁
    this.destroy = true;

    // 设置成不激活
    this.active = false;

    // 销毁拖拽事件
    this.watchDrop(false);
  },

  computed: {
    /**
     * uploading 正在上传的线程
     * @return {[type]} [description]
     */

    /**
     * uploaded 文件列表是否全部已上传
     * @return {[type]} [description]
     */
    uploaded() {
      let file;
      for (let i = 0; i < this.files.length; i++) {
        file = this.files[i];
        if (file.fileObject && !file.error && !file.success) {
          return false
        }
      }
      return true
    },

    chunkOptions () {
      return Object.assign(CHUNK_DEFAULT_OPTIONS, this.chunk)
    },

    className() {
      return [
        'file-uploads',
        this.features.html5 ? 'file-uploads-html5' : 'file-uploads-html4',
        this.features.directory && this.directory ? 'file-uploads-directory' : undefined,
        this.features.drop && this.drop ? 'file-uploads-drop' : undefined,
        this.disabled ? 'file-uploads-disabled' : undefined,
      ]
    }
  },


  watch: {
    active(active) {
      this.watchActive(active);
    },

    dropActive(value) {
      this.watchDropActive(value);
      if (this.$parent) {
        this.$parent.$forceUpdate();
      }
    },
    

    drop(value) {
      this.watchDrop(value);
    },

    value(files) {
      if (this.files === files) {
        return
      }
      this.files = files;

      let oldMaps = this.maps;

      // 重写 maps 缓存
      this.maps = {};
      for (let i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        this.maps[file.id] = file;
      }

      // add, update
      for (let key in this.maps) {
        let newFile = this.maps[key];
        let oldFile = oldMaps[key];
        if (newFile !== oldFile) {
          this.emitFile(newFile, oldFile);
        }
      }

      // delete
      for (let key in oldMaps) {
        if (!this.maps[key]) {
          this.emitFile(undefined, oldMaps[key]);
        }
      }
    },
  },

  methods: {

    // 清空
    clear() {
      if (this.files.length) {
        let files = this.files;
        this.files = [];

        // 定位
        this.maps = {};

        // 事件
        this.emitInput();
        for (let i = 0; i < files.length; i++) {
          this.emitFile(undefined, files[i]);
        }
      }
      return true
    },

    // 选择
    get(id) {
      if (!id) {
        return false
      }

      if (typeof id === 'object') {
        return this.maps[id.id] || false
      }

      return this.maps[id] || false
    },

    // 添加
    add(_files, index = this.addIndex) {
      let files = _files;
      let isArray = files instanceof Array;

      // 不是数组整理成数组
      if (!isArray) {
        files = [files];
      }

      // 遍历规范对象
      let addFiles = [];
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        if (this.features.html5 && file instanceof Blob) {
          file = {
            file,
            size: file.size,
            name: file.webkitRelativePath || file.relativePath || file.name || 'unknown',
            type: file.type,
          };
        }
        let fileObject = false;
        if (file.fileObject === false) ; else if (file.fileObject) {
          fileObject = true;
        } else if (typeof Element !== 'undefined' && file.el instanceof Element) {
          fileObject = true;
        } else if (typeof Blob !== 'undefined' && file.file instanceof Blob) {
          fileObject = true;
        }
        if (fileObject) {
          file = {
            fileObject: true,
            size: -1,
            name: 'Filename',
            type: '',
            active: false,
            error: '',
            success: false,
            putAction: this.putAction,
            postAction: this.postAction,
            timeout: this.timeout,
            ...file,
            response: {},

            progress: '0.00',          // 只读
            speed: 0,                  // 只读
            // xhr: false,                // 只读
            // iframe: false,             // 只读
          };

          file.data = {
            ...this.data,
            ...file.data ? file.data : {},
          };

          file.headers = {
            ...this.headers,
            ...file.headers ? file.headers : {},
          };
        }

        // 必须包含 id
        if (!file.id) {
          file.id = Math.random().toString(36).substr(2);
        }

        if (this.emitFilter(file, undefined)) {
          continue
        }

        // 最大数量限制
        if (this.maximum > 1 && (addFiles.length + this.files.length) >= this.maximum) {
          break
        }

        addFiles.push(file);

        // 最大数量限制
        if (this.maximum === 1) {
          break
        }
      }

      // 没有文件
      if (!addFiles.length) {
        return false
      }

      // 如果是 1 清空
      if (this.maximum === 1) {
        this.clear();
      }


      // 添加进去 files
      let newFiles;
      if (index === true || index === 0) {
        newFiles = addFiles.concat(this.files);
      } else if (index) {
        newFiles = this.files.concat([]);
        newFiles.splice(index, 0, ...addFiles);
      } else {
        newFiles = this.files.concat(addFiles);
      }

      this.files = newFiles;

      // 定位
      for (let i = 0; i < addFiles.length; i++) {
        let file = addFiles[i];
        this.maps[file.id] = file;
      }

      // 事件
      this.emitInput();
      for (let i = 0; i < addFiles.length; i++) {
        this.emitFile(addFiles[i], undefined);
      }

      return isArray ? addFiles : addFiles[0]
    },



    // 添加表单文件
    addInputFile(el) {
      let files = [];
      if (el.files) {
        for (let i = 0; i < el.files.length; i++) {
          let file = el.files[i];
          files.push({
            size: file.size,
            name: file.webkitRelativePath || file.relativePath || file.name,
            type: file.type,
            file,
          });
        }
      } else {
        var names = el.value.replace(/\\/g, '/').split('/');
        delete el.__vuex__;
        files.push({
          name: names[names.length - 1],
          el,
        });
      }
      return this.add(files)
    },


    // 添加 DataTransfer
    addDataTransfer(dataTransfer) {
      let files = [];
      if (dataTransfer.items && dataTransfer.items.length) {
        let items = [];
        for (let i = 0; i < dataTransfer.items.length; i++) {
          let item = dataTransfer.items[i];
          if (item.getAsEntry) {
            item = item.getAsEntry() || item.getAsFile();
          } else if (item.webkitGetAsEntry) {
            item = item.webkitGetAsEntry() || item.getAsFile();
          } else {
            item = item.getAsFile();
          }
          if (item) {
            items.push(item);
          }
        }

        return new Promise((resolve, reject) => {
          let forEach = (i) => {
            let item = items[i];
            // 结束 文件数量大于 最大数量
            if (!item || (this.maximum > 0 && files.length >= this.maximum)) {
              return resolve(this.add(files))
            }
            this.getEntry(item).then(function (results) {
              files.push(...results);
              forEach(i + 1);
            });
          };
          forEach(0);
        })
      }

      if (dataTransfer.files.length) {
        for (let i = 0; i < dataTransfer.files.length; i++) {
          files.push(dataTransfer.files[i]);
          if (this.maximum > 0 && files.length >= this.maximum) {
            break
          }
        }
        return Promise.resolve(this.add(files))
      }

      return Promise.resolve([])
    },


    // 获得 entry
    getEntry(entry, path = '') {
      return new Promise((resolve, reject) => {
        if (entry.isFile) {
          entry.file(function (file) {
            resolve([
              {
                size: file.size,
                name: path + file.name,
                type: file.type,
                file,
              }
            ]);
          });
        } else if (entry.isDirectory && this.dropDirectory) {
          let files = [];
          let dirReader = entry.createReader();
          let readEntries = () => {
            dirReader.readEntries((entries) => {
              let forEach = (i) => {
                if ((!entries[i] && i === 0) || (this.maximum > 0 && files.length >= this.maximum)) {
                  return resolve(files)
                }
                if (!entries[i]) {
                  return readEntries()
                }
                this.getEntry(entries[i], path + entry.name + '/').then((results) => {
                  files.push(...results);
                  forEach(i + 1);
                });
              };
              forEach(0);
            });
          };
          readEntries();
        } else {
          resolve([]);
        }
      })
    },


    replace(id1, id2) {
      let file1 = this.get(id1);
      let file2 = this.get(id2);
      if (!file1 || !file2 || file1 === file2) {
        return false
      }
      let files = this.files.concat([]);
      let index1 = files.indexOf(file1);
      let index2 = files.indexOf(file2);
      if (index1 === -1 || index2 === -1) {
        return false
      }
      files[index1] = file2;
      files[index2] = file1;
      this.files = files;
      this.emitInput();
      return true
    },

    // 移除
    remove(id) {
      let file = this.get(id);
      if (file) {
        if (this.emitFilter(undefined, file)) {
          return false
        }
        let files = this.files.concat([]);
        let index = files.indexOf(file);
        if (index === -1) {
          console.error('remove', file);
          return false
        }
        files.splice(index, 1);
        this.files = files;

        // 定位
        delete this.maps[file.id];

        // 事件
        this.emitInput();
        this.emitFile(undefined, file);
      }
      return file
    },

    // 更新
    update(id, data) {
      let file = this.get(id);
      if (file) {
        let newFile = {
          ...file,
          ...data
        };
        // 停用必须加上错误
        if (file.fileObject && file.active && !newFile.active && !newFile.error && !newFile.success) {
          newFile.error = 'abort';
        }

        if (this.emitFilter(newFile, file)) {
          return false
        }

        let files = this.files.concat([]);
        let index = files.indexOf(file);
        if (index === -1) {
          console.error('update', file);
          return false
        }
        files.splice(index, 1, newFile);
        this.files = files;

        // 删除  旧定位 写入 新定位 （已便支持修改id)
        delete this.maps[file.id];
        this.maps[newFile.id] = newFile;

        // 事件
        this.emitInput();
        this.emitFile(newFile, file);
        return newFile
      }
      return false
    },



    // 预处理 事件 过滤器
    emitFilter(newFile, oldFile) {
      let isPrevent = false;
      this.$emit('input-filter', newFile, oldFile, function () {
        isPrevent = true;
        return isPrevent
      });
      return isPrevent
    },

    // 处理后 事件 分发
    emitFile(newFile, oldFile) {
      this.$emit('input-file', newFile, oldFile);
      if (newFile && newFile.fileObject && newFile.active && (!oldFile || !oldFile.active)) {
        this.uploading++;
        // 激活
        this.$nextTick(function () {
          setTimeout(() => {
            this.upload(newFile).then(() => {
              // eslint-disable-next-line
              newFile = this.get(newFile);
              if (newFile && newFile.fileObject) {
                this.update(newFile, {
                  active: false,
                  success: !newFile.error
                });
              }
            }).catch((e) => {
              this.update(newFile, {
                active: false,
                success: false,
                error: e.code || e.error || e.message || e
              });
            });
          }, parseInt(Math.random() * 50 + 50, 10));
        });
      } else if ((!newFile || !newFile.fileObject || !newFile.active) && oldFile && oldFile.fileObject && oldFile.active) {
        // 停止
        this.uploading--;
      }

      // 自动延续激活
      if (this.active && (Boolean(newFile) !== Boolean(oldFile) || newFile.active !== oldFile.active)) {
        this.watchActive(true);
      }
    },

    emitInput() {
      this.$emit('input', this.files);
    },


    // 上传
    upload(id) {
      let file = this.get(id);

      // 被删除
      if (!file) {
        return Promise.reject('not_exists')
      }

      // 不是文件对象
      if (!file.fileObject) {
        return Promise.reject('file_object')
      }

      // 有错误直接响应
      if (file.error) {
        return Promise.reject(file.error)
      }

      // 已完成直接响应
      if (file.success) {
        return Promise.resolve(file)
      }

      // 后缀
      let extensions = this.extensions;
      if (extensions && (extensions.length || typeof extensions.length === 'undefined')) {
        if (typeof extensions !== 'object' || !(extensions instanceof RegExp)) {
          if (typeof extensions === 'string') {
            extensions = extensions.split(',').map(value => value.trim()).filter(value => value);
          }
          extensions = new RegExp('\\.(' + extensions.join('|').replace(/\./g, '\\.') + ')$', 'i');
        }
        if (file.name.search(extensions) === -1) {
          return Promise.reject('extension')
        }
      }

      // 大小
      if (this.size > 0 && file.size >= 0 && file.size > this.size) {
        return Promise.reject('size')
      }

      if (this.customAction) {
        return this.customAction(file, this)
      }

      if (this.features.html5) {
        if (this.shouldUseChunkUpload(file)) {
          return this.uploadChunk(file)
        }
        if (file.putAction) {
          return this.uploadPut(file)
        }
        if (file.postAction) {
          return this.uploadHtml5(file)
        }
      }
      if (file.postAction) {
        return this.uploadHtml4(file)
      }
      return Promise.reject('No action configured')
    },

    /**
     * Whether this file should be uploaded using chunk upload or not
     *
     * @param Object file
     */
    shouldUseChunkUpload (file) {
      return this.chunkEnabled &&
        !!this.chunkOptions.handler &&
        file.size > this.chunkOptions.minSize
    },

    /**
     * Upload a file using Chunk method
     *
     * @param File file
     */
    uploadChunk (file) {
      const HandlerClass = this.chunkOptions.handler;
      file.chunk = new HandlerClass(file, this.chunkOptions);

      return file.chunk.upload()
    },

    uploadPut(file) {
      let querys = [];
      let value;
      for (let key in file.data) {
        value = file.data[key];
        if (value !== null && value !== undefined) {
          querys.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
      }
      let queryString = querys.length ? (file.putAction.indexOf('?') === -1 ? '?' : '&') + querys.join('&') : '';
      let xhr = new XMLHttpRequest();
      xhr.open('PUT', file.putAction + queryString);
      return this.uploadXhr(xhr, file, file.file)
    },

    uploadHtml5(file) {
      let form = new window.FormData();
      let value;
      for (let key in file.data) {
        value = file.data[key];
        if (value && typeof value === 'object' && typeof value.toString !== 'function') {
          if (value instanceof File) {
            form.append(key, value, value.name);
          } else {
            form.append(key, JSON.stringify(value));
          }
        } else if (value !== null && value !== undefined) {
          form.append(key, value);
        }
      }
      form.append(this.name, file.file, file.file.filename || file.name);
      let xhr = new XMLHttpRequest();
      xhr.open('POST', file.postAction);
      return this.uploadXhr(xhr, file, form)
    },

    uploadXhr(xhr, _file, body) {
      let file = _file;
      let speedTime = 0;
      let speedLoaded = 0;

      // 进度条
      xhr.upload.onprogress = (e) => {
        // 还未开始上传 已删除 未激活
        file = this.get(file);
        if (!e.lengthComputable || !file || !file.fileObject || !file.active) {
          return
        }

        // 进度 速度 每秒更新一次
        let speedTime2 = Math.round(Date.now() / 1000);
        if (speedTime2 === speedTime) {
          return
        }
        speedTime = speedTime2;

        file = this.update(file, {
          progress: (e.loaded / e.total * 100).toFixed(2),
          speed: e.loaded - speedLoaded,
        });
        speedLoaded = e.loaded;
      };

      // 检查激活状态
      let interval = setInterval(() => {
        file = this.get(file);
        if (file && file.fileObject && !file.success && !file.error && file.active) {
          return
        }

        if (interval) {
          clearInterval(interval);
          interval = false;
        }

        try {
          xhr.abort();
          xhr.timeout = 1;
        } catch (e) {
        }
      }, 100);

      return new Promise((resolve, reject) => {
        let complete;
        let fn = (e) => {
          // 已经处理过了
          if (complete) {
            return
          }
          complete = true;
          if (interval) {
            clearInterval(interval);
            interval = false;
          }

          file = this.get(file);

          // 不存在直接响应
          if (!file) {
            return reject('not_exists')
          }

          // 不是文件对象
          if (!file.fileObject) {
            return reject('file_object')
          }

          // 有错误自动响应
          if (file.error) {
            return reject(file.error)
          }

          // 未激活
          if (!file.active) {
            return reject('abort')
          }


          // 已完成 直接相应
          if (file.success) {
            return resolve(file)
          }

          let data = {};

          switch (e.type) {
            case 'timeout':
            case 'abort':
              data.error = e.type;
              break
            case 'error':
              if (!xhr.status) {
                data.error = 'network';
              } else if (xhr.status >= 500) {
                data.error = 'server';
              } else if (xhr.status >= 400) {
                data.error = 'denied';
              }
              break
            default:
              if (xhr.status >= 500) {
                data.error = 'server';
              } else if (xhr.status >= 400) {
                data.error = 'denied';
              } else {
                data.progress = '100.00';
              }
          }

          if (xhr.responseText) {
            let contentType = xhr.getResponseHeader('Content-Type');
            if (contentType && contentType.indexOf('/json') !== -1) {
              data.response = JSON.parse(xhr.responseText);
            } else {
              data.response = xhr.responseText;
            }
          }

          // 更新
          file = this.update(file, data);

          // 相应错误
          if (file.error) {
            return reject(file.error)
          }

          // 响应
          return resolve(file)
        };

        // 事件
        xhr.onload = fn;
        xhr.onerror = fn;
        xhr.onabort = fn;
        xhr.ontimeout = fn;

        // 超时
        if (file.timeout) {
          xhr.timeout = file.timeout;
        }

        // headers
        for (let key in file.headers) {
          xhr.setRequestHeader(key, file.headers[key]);
        }

        // 更新 xhr
        file = this.update(file, { xhr });

        // 开始上传
        xhr.send(body);
      })
    },




    uploadHtml4(_file) {
      let file = _file;
      let onKeydown = function (e) {
        if (e.keyCode === 27) {
          e.preventDefault();
        }
      };

      let iframe = document.createElement('iframe');
      iframe.id = 'upload-iframe-' + file.id;
      iframe.name = 'upload-iframe-' + file.id;
      iframe.src = 'about:blank';
      iframe.setAttribute('style', 'width:1px;height:1px;top:-999em;position:absolute; margin-top:-999em;');


      let form = document.createElement('form');

      form.action = file.postAction;

      form.name = 'upload-form-' + file.id;


      form.setAttribute('method', 'POST');
      form.setAttribute('target', 'upload-iframe-' + file.id);
      form.setAttribute('enctype', 'multipart/form-data');

      let value;
      let input;
      for (let key in file.data) {
        value = file.data[key];
        if (value && typeof value === 'object' && typeof value.toString !== 'function') {
          value = JSON.stringify(value);
        }
        if (value !== null && value !== undefined) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.appendChild(input);
        }
      }
      form.appendChild(file.el);

      document.body.appendChild(iframe).appendChild(form);




      let getResponseData = function () {
        let doc;
        try {
          if (iframe.contentWindow) {
            doc = iframe.contentWindow.document;
          }
        } catch (err) {
        }
        if (!doc) {
          try {
            doc = iframe.contentDocument ? iframe.contentDocument : iframe.document;
          } catch (err) {
            doc = iframe.document;
          }
        }
        if (doc && doc.body) {
          return doc.body.innerHTML
        }
        return null
      };


      return new Promise((resolve, reject) => {
        setTimeout(() => {
          file = this.update(file, { iframe });

          // 不存在
          if (!file) {
            return reject('not_exists')
          }

          // 定时检查
          let interval = setInterval(() => {
            file = this.get(file);
            if (file && file.fileObject && !file.success && !file.error && file.active) {
              return
            }

            if (interval) {
              clearInterval(interval);
              interval = false;
            }

            iframe.onabort({ type: file ? 'abort' : 'not_exists' });
          }, 100);


          let complete;
          let fn = (e) => {
            // 已经处理过了
            if (complete) {
              return
            }
            complete = true;


            if (interval) {
              clearInterval(interval);
              interval = false;
            }

            // 关闭 esc 事件
            document.body.removeEventListener('keydown', onKeydown);

            file = this.get(file);

            // 不存在直接响应
            if (!file) {
              return reject('not_exists')
            }

            // 不是文件对象
            if (!file.fileObject) {
              return reject('file_object')
            }

            // 有错误自动响应
            if (file.error) {
              return reject(file.error)
            }

            // 未激活
            if (!file.active) {
              return reject('abort')
            }

            // 已完成 直接相应
            if (file.success) {
              return resolve(file)
            }

            let response = getResponseData();
            let data = {};
            switch (e.type) {
              case 'abort':
                data.error = 'abort';
                break
              case 'error':
                if (file.error) {
                  data.error = file.error;
                } else if (response === null) {
                  data.error = 'network';
                } else {
                  data.error = 'denied';
                }
                break
              default:
                if (file.error) {
                  data.error = file.error;
                } else if (data === null) {
                  data.error = 'network';
                } else {
                  data.progress = '100.00';
                }
            }

            if (response !== null) {
              if (response && response.substr(0, 1) === '{' && response.substr(response.length - 1, 1) === '}') {
                try {
                  response = JSON.parse(response);
                } catch (err) {
                }
              }
              data.response = response;
            }

            // 更新
            file = this.update(file, data);

            if (file.error) {
              return reject(file.error)
            }

            // 响应
            return resolve(file)
          };


          // 添加事件
          iframe.onload = fn;
          iframe.onerror = fn;
          iframe.onabort = fn;


          // 禁止 esc 键
          document.body.addEventListener('keydown', onKeydown);

          // 提交
          form.submit();
        }, 50);
      }).then(function (res) {
        iframe.parentNode && iframe.parentNode.removeChild(iframe);
        return res
      }).catch(function (res) {
        iframe.parentNode && iframe.parentNode.removeChild(iframe);
        return res
      })
    },



    watchActive(active) {
      let file;
      let index = 0;
      while ((file = this.files[index])) {
        index++;
        if (!file.fileObject) ; else if (active && !this.destroy) {
          if (this.uploading >= this.thread || (this.uploading && !this.features.html5)) {
            break
          }
          if (!file.active && !file.error && !file.success) {
            this.update(file, { active: true });
          }
        } else {
          if (file.active) {
            this.update(file, { active: false });
          }
        }
      }
      if (this.uploading === 0) {
        this.active = false;
      }
    },


    watchDrop(_el) {
      let el = _el;
      if (!this.features.drop) {
        return
      }

      // 移除挂载
      if (this.dropElement) {
        try {
          document.removeEventListener('dragenter', this.onDocumentDragenter, false);
          document.removeEventListener('dragleave', this.onDocumentDragleave, false);
          document.removeEventListener('dragover', this.onDocumentDragover, false);
          document.removeEventListener('drop', this.onDocumentDrop, false);
          this.dropElement.removeEventListener('dragover', this.onDragover, false);
          this.dropElement.removeEventListener('drop', this.onDrop, false);
        } catch (e) {
        }
      }

      if (!el) {
        el = false;
      } else if (typeof el === 'string') {
        el = document.querySelector(el) || this.$root.$el.querySelector(el);
      } else if (el === true) {
        el = this.$parent.$el;
      }

      this.dropElement = el;

      if (this.dropElement) {
        document.addEventListener('dragenter', this.onDocumentDragenter, false);
        document.addEventListener('dragleave', this.onDocumentDragleave, false);
        document.addEventListener('dragover', this.onDocumentDragover, false);
        document.addEventListener('drop', this.onDocumentDrop, false);
        this.dropElement.addEventListener('dragover', this.onDragover, false);
        this.dropElement.addEventListener('drop', this.onDrop, false);
      }
    },

    watchDropActive(newDropActive, oldDropActive) {
      if (newDropActive === oldDropActive) {
        return
      }
      if (this.dropTimeout) {
        clearTimeout(this.dropTimeout);
        this.dropTimeout = null;
      }
      if (newDropActive) {
        this.dropTimeout = setTimeout(this.onDocumentDrop, 1000);
      }
    },


    onDocumentDragenter(e) {
      if (this.dropActive) {
        return
      }
      if (!e.dataTransfer) {
        return
      }
      let dt = e.dataTransfer;
      if (dt.files && dt.files.length) {
        this.dropActive = true;
      } else if (!dt.types) {
        this.dropActive = true;
      } else if (dt.types.indexOf && dt.types.indexOf('Files') !== -1) {
        this.dropActive = true;
      } else if (dt.types.contains && dt.types.contains('Files')) {
        this.dropActive = true;
      }
      if (this.dropActive) {
        this.watchDropActive(true);
      }
    },

    onDocumentDragleave(e) {
      if (!this.dropActive) {
        return
      }
      if (e.target === e.explicitOriginalTarget || (!e.fromElement && (e.clientX <= 0 || e.clientY <= 0 || e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))) {
        this.dropActive = false;
        this.watchDropActive(false);
      }
    },

    onDocumentDragover() {
      this.watchDropActive(true);
    },

    onDocumentDrop() {
      this.dropActive = false;
      this.watchDropActive(false);
    },

    onDragover(e) {
      e.preventDefault();
    },


    onDrop(e) {
      e.preventDefault();
      e.dataTransfer && this.addDataTransfer(e.dataTransfer);
    },
  }
};

/* script */
const __vue_script__$d = script$d;
/* template */
var __vue_render__$d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.className},[_vm._t("default"),_vm._v(" "),_c('label',{attrs:{"for":_vm.inputId || _vm.name}}),_vm._v(" "),_c('input-file')],2)};
var __vue_staticRenderFns__$d = [];

  /* style */
  const __vue_inject_styles__$d = undefined;
  /* scoped */
  const __vue_scope_id__$d = undefined;
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    undefined,
    undefined,
    undefined
  );

function friendlyByteSize(bytes) {
    const i = bytes === 0 ? 0 : Math.floor(Math.log(bytes) / Math.log(1024));
    const unit = ['B', 'KB', 'MB', 'GB', 'TB'][i];
    return `${Number((bytes / Math.pow(1024, i)).toFixed(2))} ${unit}`;
}

class UseFileUploadHelper {
    constructor(maxSize, maxTotalSize) {
        this.maxSize = maxSize;
        this.maxTotalSize = maxTotalSize;
        this._totalFileSize = 0;
        this.maxSize = maxSize;
        this.maxTotalSize = maxTotalSize;
    }
    calculateTotalSize(collection) {
        this._totalFileSize = collection.reduce((prev, curr) => prev + (curr && curr.size ? curr.size : 0), 0);
    }
    get combinedFileSize() {
        return this._totalFileSize;
    }
    maxFileSize() {
        return {
            file: friendlyByteSize(this.maxSize),
            total: friendlyByteSize(this.maxTotalSize),
        };
    }
    isAllowedFileSize(file) {
        return this.maxSize === 0 || (file && file.size && file.size <= this.maxSize) || false;
    }
    isDuplicate(file, collection) {
        const allFiles = [file, ...collection];
        const uniqueValues = new Set(allFiles.map((f) => `${f.name}-${f.size}-${f.type}`));
        return uniqueValues.size < allFiles.length;
    }
    isFileAllowed(file, extensions) {
        if (extensions.length > 0 && file.name) {
            const escapedExtensions = extensions.map(e => `\\.${e}`);
            const rxExtensions = new RegExp(`(${escapedExtensions.join('|')})$`, 'i');
            return rxExtensions.test(file.name);
        }
        return true;
    }
}

class UseFileUpload {
    constructor(props, i18n, inputRef) {
        this.props = props;
        this.i18n = i18n;
        this.inputRef = inputRef;
        this.events = { uploaded: 'file:uploaded', downloaded: 'file:downloaded', removed: 'file:removed' };
        this.errorMessage = ref('');
        this.warningMessage = ref('');
        this.batchCompletionTimer = null;
        this.queuedTotalFiles = 0;
        this.queuedTotalFileSize = 0;
        this.shouldValidate = ref(false);
        this.validation = new UseValidation(props, this.i18n, this.validate.bind(this), () => this.shouldValidate.value);
        this.service = props.service;
        this.uploadedFiles = ref(props.value);
        this.failedUploads = ref([]);
        this.extensionsList = (props.extensions || []).map(x => `.${x}`).join(', ');
        this.helper = new UseFileUploadHelper(props.size || 0, props.totalSize || 0);
        onMounted(() => Vue$1.nextTick().then(() => this.onMountedHandler()));
    }
    onMountedHandler() {
        this.fileComponent = this.inputRef.value;
        if (this.fileComponent) {
            this.validate();
            watch(() => this.uploadedFiles.value, () => this.helper.calculateTotalSize(this.uploadedFiles.value));
        }
    }
    setWarningMessage(message) {
        this.warningMessage.value = message;
    }
    clearWarningMessage() {
        this.setWarningMessage('');
    }
    validate(force) {
        if (force) {
            this.shouldValidate.value = true;
        }
        this.errorMessage.value = this.shouldValidate.value ? this.validation.getValidationMessage() : '';
        this.validation.isInError.value = !!this.errorMessage.value;
        return !this.validation.isInError.value;
    }
    validateNewFile(vueUploadItem) {
        if (this.helper.isDuplicate(vueUploadItem, this.uploadedFiles.value)) {
            return this.i18n.t('errorMessages.alreadyUploaded', { name: vueUploadItem.name });
        }
        if (!this.helper.isFileAllowed(vueUploadItem, this.props.extensions || [])) {
            return this.i18n.t('errorMessages.illegalTypes', { extensionsList: this.extensionsList });
        }
        if (!this.helper.isAllowedFileSize(vueUploadItem)) {
            return this.i18n.t('errorMessages.exceedFileSize', { maxFileSize: friendlyByteSize(this.props.size || 0) });
        }
        if (this.props.totalSize && ((this.queuedTotalFileSize + this.helper.combinedFileSize) > this.props.totalSize)) {
            return this.i18n.t('errorMessages.exceedMaxFileSize', { maxTotalSize: friendlyByteSize(this.props.totalSize || 0) });
        }
        const numberOfFiles = this.uploadedFiles.value.length + this.queuedTotalFiles;
        if (this.props.totalFiles && numberOfFiles > this.props.totalFiles) {
            return this.i18n.t('errorMessages.exceedMaxNumberOfFiles', { maxNumberOfFiles: this.props.totalFiles });
        }
        return '';
    }
    fileWasRemoved(vueUploadItem) {
        this.clearWarningMessage();
        this.service.removeFile(vueUploadItem);
    }
    handleFailedUpload(vueUploadItem, validationErrorMessage) {
        if (validationErrorMessage) {
            vueUploadItem.error = validationErrorMessage;
        }
        this.failedUploads.value.push(vueUploadItem);
        this.setWarningMessage(this.i18n.t('errorMessages.faultyFiles'));
    }
    removeFailedUpload(vueUploadItem) {
        this.failedUploads.value = this.failedUploads.value.filter((fileFromArray) => fileFromArray.id !== vueUploadItem.id);
        if (!this.failedUploads.value.length) {
            this.clearWarningMessage();
        }
    }
    checkIfAllUploadsAreQueued(vueUploadItem) {
        // To check if all uploads within the selection of multiple files have been queued, we declare a timeout of 200ms
        // Queueing a file should not take longer than 200ms, so if the timer expires, we assume that the last upload has been queued
        if (!this.batchCompletionTimer) {
            this.failedUploads.value = [];
        }
        this.queuedTotalFiles++;
        // To accurately check if we've uploaded too much data, we maintain a property that represents the total size of files that are stil queued
        this.queuedTotalFileSize += vueUploadItem.size;
        clearTimeout(this.batchCompletionTimer);
        this.batchCompletionTimer = setTimeout(() => {
            this.batchCompletionTimer = null;
            this.queuedTotalFiles = 0;
            this.queuedTotalFileSize = 0;
        }, 200);
    }
    fileWasAdded(vueUploadItem, prevent) {
        this.checkIfAllUploadsAreQueued(vueUploadItem);
        const validationErrorMessage = this.validateNewFile(vueUploadItem);
        if (validationErrorMessage) {
            this.handleFailedUpload(vueUploadItem, validationErrorMessage);
            prevent();
        }
        else {
            this.clearWarningMessage();
            this.service.uploadFile(vueUploadItem).then(() => {
                if (this.fileComponent) {
                    if (vueUploadItem.error) {
                        this.handleFailedUpload(vueUploadItem);
                        this.fileComponent.remove(vueUploadItem);
                    }
                    else {
                        this.fileComponent.update(vueUploadItem, { success: true });
                    }
                    this.validate();
                }
            });
        }
    }
    filterInput(newFile, oldFile, prevent) {
        if (!this.shouldValidate.value) {
            this.shouldValidate.value = true;
        }
        if (newFile && !oldFile) {
            this.fileWasAdded(newFile, prevent);
        }
        if (!newFile && oldFile) {
            this.fileWasRemoved(oldFile);
        }
        this.validate();
    }
    extractComposable() {
        return {
            uploadedFiles: this.uploadedFiles,
            failedUploads: this.failedUploads,
            errorMessage: this.errorMessage,
            warningMessage: this.warningMessage,
            extensionsList: this.extensionsList,
            extractedValidation: {
                shouldValidate: this.shouldValidate,
                errorMessage: this.errorMessage,
                isRequired: this.validation.isRequired,
                isInError: this.validation.isInError,
                hideValidation: ref(false),
            },
            filterInput: this.filterInput.bind(this),
            maxFileSize: this.helper.maxFileSize(),
            removeFailedUpload: this.removeFailedUpload.bind(this),
        };
    }
}
function useFileUpload(props, usei18n, inputRef) {
    return new UseFileUpload(props, usei18n, inputRef).extractComposable();
}

var i18n$1 = {
    messages: {
        nl: {
            dragOneFile: 'Sleep een bestand @:toThisArea',
            dragOneOrMoreFiles: 'Sleep één of meerdere bestand(en) @:toThisArea',
            toThisArea: 'naar dit vak.',
            orChooseFile: 'Of kies een bestand door op de knop te drukken.',
            chooseFile: 'Kies een bestand',
            allowedFileExtensions: 'Toegestane bestandsformaten zijn {extensionsList}.',
            maximumFileSize: 'Maximaal {maxFileSize} per bestand en de gezamenlijke uploadlimiet is {maxTotalSize}.',
            noMaximumFileSize: 'De gezamenlijke uploadlimiet is {maxTotalSize}.',
            noMaximumTotalSize: 'Maximaal {maxFileSize} per bestand.',
            allowedNumberOfFiles: 'U kunt maximaal {maxNumberOfFiles} bestanden per keer uploaden',
            remove: 'Verwijder',
            removeFile: 'Verwijder {file}',
            openFile: 'Open {file}',
            errorMessages: {
                illegalTypes: 'Het gekozen bestandstype is niet toegestaan, kies een ander bestandstype ({extensionsList})',
                exceedFileSize: 'Het geselecteerde bestand is te groot, kies een kleiner bestand (met een maximum van {maxFileSize})',
                exceedMaxFileSize: 'De gezamenlijke uploadlimiet van {maxTotalSize} is overschreden',
                exceedMaxNumberOfFiles: 'U kunt maximaal {maxNumberOfFiles} bestanden per keer uploaden',
                alreadyUploaded: 'U heeft het bestand {name} al geüpload',
                faultyFiles: 'Een of meerdere bestanden zijn foutief, vervang deze door andere bestanden en verwijder deze.',
            },
        },
    },
};

var script$c = defineComponent({
    name: 'PFile',
    props: {
        file: { type: Object, required: true },
    },
    components: {
        VList,
        VListItem,
        VListItemAction,
        VListItemContent,
        VListItemTitle,
        PButton: __vue_component__$1f,
        PAlert: __vue_component__$1b,
        PLoadingIndicator: __vue_component__$t,
    },
    i18n: i18n$1,
    setup(props) {
        const fileInfo = {
            friendlyByteSize: !props.file.isArchived ? friendlyByteSize(props.file.size) : '',
        };
        return {
            // file.success comes from vue-upload-component and must be strictly equal to false,
            // undefined means it isn't an upload file.
            // for computed reactiveness to work it must use the props parent.
            isUploading: computed(() => props.file.success === false && !props.file.error),
            hasBeenUploaded: computed(() => props.file.success),
            hasFailed: computed(() => props.file.success === false && props.file.error),
            fileInfo,
        };
    },
});

/* script */
const __vue_script__$c = script$c;
/* template */
var __vue_render__$c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUploading || _vm.hasBeenUploaded)?_c('v-list',{staticClass:"p-file"},[_c('v-list-item',[_c('v-list-item-content',{staticClass:"d-inline-block hidden-overflow"},[_c('a',{staticClass:"d-block",attrs:{"href":"#","title":_vm.file.name,"aria-label":_vm.$t('openFile', { file: _vm.file.name })},on:{"click":function($event){$event.preventDefault();return _vm.$emit('download', _vm.file)}}},[_c('v-list-item-title',[_vm._v("\n          "+_vm._s(_vm.file.name)+"\n          "),(_vm.isUploading)?_c('p-loading-indicator',{staticClass:"ml-2 my-1"}):_vm._e()],1)],1)]),_vm._v(" "),_c('v-list-item-action',[_vm._v("\n      "+_vm._s(_vm.fileInfo.friendlyByteSize)+"\n    ")]),_vm._v(" "),_c('v-list-item-action',[(_vm.hasBeenUploaded)?_c('p-button',{attrs:{"data-ui":"remove-file","small":"","aria-label":_vm.$t('removeFile', { file: _vm.file.name })},on:{"click":function($event){$event.preventDefault();return _vm.$emit('remove', _vm.file)}}},[_vm._v("\n        "+_vm._s(_vm.$t('remove'))+"\n      ")]):_vm._e()],1)],1)],1):(_vm.hasFailed)?_c('p-alert',{staticClass:"mb-0 mt-4",attrs:{"dismissible":true,"type":"error","truncate-title":"","title":_vm.file.name},on:{"input":function($event){return _vm.$emit('dismiss', _vm.file)}}},[_c('div',{staticClass:"d-flex flex-column"},[_c('span',[_vm._v(_vm._s(_vm.file.error))])])]):_vm._e()};
var __vue_staticRenderFns__$c = [];

  /* style */
  const __vue_inject_styles__$c = undefined;
  /* scoped */
  const __vue_scope_id__$c = "data-v-44cfbe68";
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    undefined,
    undefined,
    undefined
  );

var script$b = defineComponent({
    name: 'PFileUpload',
    inheritAttrs: false,
    components: { VueUploadComponent: __vue_component__$d, PFile: __vue_component__$c, VIcon, PButton: __vue_component__$1f, PInput: __vue_component__$$ },
    props: {
        service: { type: Object, required: true },
        value: { type: Array, default: () => [] },
        extensions: { type: Array, default: () => [] },
        size: { type: Number, default: 0 },
        totalSize: { type: Number, default: 0 },
        totalFiles: { type: Number, default: null },
        multiple: { type: Boolean, default: false },
        id: { type: String, default: undefined },
        validation: { type: Object, default: () => undefined },
        label: { type: String, default: null },
    },
    i18n: i18n$1,
    setup(props, { emit }) {
        const internalId = useIdGenerator('p-file-upload').next();
        const inputRef = ref(null);
        const vmI18n = useI18n();
        const dataContext = useFileUpload(props, vmI18n, inputRef);
        const inputState = ref(props.value);
        const InputIsfocussed = ref(false);
        const allFiles = computed(() => [...dataContext.uploadedFiles.value, ...dataContext.failedUploads.value]);
        const { setDirty } = useFormsStateManager(internalId);
        const onFileSelectHandler = () => {
            setDirty();
        };
        watch(() => dataContext.uploadedFiles.value, () => {
            emit('input', dataContext.uploadedFiles.value);
        });
        // the input is invisible and should not have a tabindex
        onMounted(() => {
            if (inputRef.value) {
                inputRef.value.$el.querySelector('input[type=file]').setAttribute('tabindex', '-1');
            }
        });
        // The input upload should be triggered as soon as the button is clicked
        function onButtonClick() {
            inputRef.value.$el.querySelector('input[type=file]').click();
        }
        return Object.assign(Object.assign({}, dataContext), { allFiles,
            inputRef,
            inputState,
            InputIsfocussed,
            onButtonClick, removeFile: (file) => inputRef.value.remove(file), onFileSelectHandler,
            internalId });
    },
});

/* script */
const __vue_script__$b = script$b;
/* template */
var __vue_render__$b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-file-upload"},[_c('p-input',_vm._g({attrs:{"id":_vm.id,"extracted-validation":_vm.extractedValidation,"label":_vm.label,"forms-state-manager-id":_vm.internalId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isInError = ref.isInError;
var attrs = ref.attrs; if ( attrs === void 0 ) attrs = {};
return [_c('div',{staticClass:"p-file-upload-cmp",class:isInError ? 'has-error' : ''},[_c('div',{staticClass:"icon"},[_c('v-icon',{attrs:{"size":"120"}},[_vm._v("\n          $icon-upload-cloud\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"p-file-upload__drag-file-copy",attrs:{"id":(_vm.internalId + "-description")}},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.multiple ? 'dragOneOrMoreFiles' : 'dragOneFile'))),_c('br'),_vm._v("\n        "+_vm._s(_vm.$t('orChooseFile'))+"\n      ")]),_vm._v(" "),_c('vue-upload-component',{ref:"inputRef",staticClass:"p-file-upload__input-cmp",attrs:{"input-id":attrs.id,"accept":_vm.extensionsList,"multiple":_vm.multiple,"drop":true,"drop-directory":false},on:{"input-filter":_vm.filterInput,"input":_vm.onFileSelectHandler},model:{value:(_vm.uploadedFiles),callback:function ($$v) {_vm.uploadedFiles=$$v;},expression:"uploadedFiles"}},[_c('p-button',{staticClass:"p-file-upload-button ma-1",attrs:{"preset":"outlined","aria-describedby":(_vm.internalId + "-description " + _vm.internalId + "-smallprint " + (attrs.id) + "_error"),"aria-invalid":isInError},on:{"click":_vm.onButtonClick}},[_vm._v("\n          "+_vm._s(_vm.$t('chooseFile'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"p-file-upload__smallprint",attrs:{"id":(_vm.internalId + "-smallprint")}},[(_vm.extensionsList)?_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('allowedFileExtensions', { extensionsList: _vm.extensionsList }))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.size && _vm.totalSize)?_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('maximumFileSize', { maxFileSize: _vm.maxFileSize.file, maxTotalSize: _vm.maxFileSize.total }))+"\n        ")]):(!_vm.size && _vm.totalSize)?_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('noMaximumFileSize', { maxTotalSize: _vm.maxFileSize.total }))+"\n        ")]):(_vm.size && !_vm.totalSize)?_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('noMaximumTotalSize', { maxFileSize: _vm.maxFileSize.file }))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.totalFiles)?_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('allowedNumberOfFiles', { maxNumberOfFiles: _vm.totalFiles }))+"\n        ")]):_vm._e()])],1)]}}])},_vm.$listeners)),_vm._v(" "),(_vm.allFiles.length)?_c('div',_vm._l((_vm.allFiles),function(file){return _c('p-file',{key:file.id,attrs:{"file":file},on:{"download":_vm.service.downloadFile,"remove":_vm.removeFile,"dismiss":_vm.removeFailedUpload}})}),1):_vm._e()],1)};
var __vue_staticRenderFns__$b = [];

  /* style */
  const __vue_inject_styles__$b = undefined;
  /* scoped */
  const __vue_scope_id__$b = "data-v-255e0104";
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    undefined,
    undefined,
    undefined
  );

var script$a = defineComponent({
    name: 'PRouterLink',
    props: {
        to: { type: [String, Object], default: undefined },
        href: { type: String, default: undefined },
    },
    setup(props) {
        const { allowed, linkTo, linkHref } = useRouteResolver(props);
        return {
            allowed, linkTo, linkHref,
        };
    },
});

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allowed && _vm.linkTo)?_c('router-link',{attrs:{"to":_vm.linkTo}},[_vm._t("default")],2):(_vm.allowed && _vm.linkHref)?_c('a',{attrs:{"href":_vm.linkHref}},[_vm._t("default")],2):_vm._e()};
var __vue_staticRenderFns__$a = [];

  /* style */
  const __vue_inject_styles__$a = undefined;
  /* scoped */
  const __vue_scope_id__$a = undefined;
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    undefined,
    undefined,
    undefined
  );

var script$9 = defineComponent({
    name: 'PSection',
    components: {
        PHeading: __vue_component__$1i,
    },
    props: {
        headingLevel: { type: [String, Number], required: true },
        headingText: { type: String, default: '' },
        headingClass: { type: String, default: null },
    },
    setup() {
        const headingId = useIdGenerator('p-heading').next();
        return { headingId };
    },
});

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"aria-labelledby":_vm.headingId}},[_c('p-heading',{class:_vm.headingClass,attrs:{"level":_vm.headingLevel,"id":_vm.headingId}},[(_vm.headingText)?[_vm._v("\n      "+_vm._s(_vm.headingText)+"\n    ")]:_vm._t("heading")],2),_vm._v(" "),_vm._t("default")],2)};
var __vue_staticRenderFns__$9 = [];

  /* style */
  const __vue_inject_styles__$9 = undefined;
  /* scoped */
  const __vue_scope_id__$9 = undefined;
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    undefined,
    undefined,
    undefined
  );

var script$8 = defineComponent({
    name: 'PGroupValidationExclude',
    props: {
        alwaysShowFieldValidator: { type: Boolean, default: false },
    },
    setup(props) {
        const groupValidationApi = inject(groupValidationProviderName);
        provide(groupValidationProviderName, reactive({
            hasGroupValidation: false,
            isInError: computed(() => groupValidationApi && groupValidationApi.isInError),
            hideChildValidationOnError: computed(() => !props.alwaysShowFieldValidator && groupValidationApi && groupValidationApi.hideChildValidationOnError),
        }));
    },
});

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)};
var __vue_staticRenderFns__$8 = [];

  /* style */
  const __vue_inject_styles__$8 = undefined;
  /* scoped */
  const __vue_scope_id__$8 = undefined;
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    undefined,
    undefined,
    undefined
  );

var script$7 = defineComponent({
    name: 'PGroupValidationSpacer',
    props: {
        mobileOnly: { type: Boolean },
    },
    setup() {
        const groupValidationApi = inject(groupValidationProviderName, {
            hasGroupValidation: false,
            isInError: false,
            hideChildValidationOnError: false,
        });
        return { groupValidationApi };
    },
});

/* script */
const __vue_script__$7 = script$7;
/* template */
var __vue_render__$7 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'pr-4',
    'p-group-validation-spacer',
    {
      'p-group-validation-spacer--has-error': _vm.groupValidationApi.isInError,
      'p-group-validation-spacer--mobile-only': _vm.mobileOnly,
    }
  ]})};
var __vue_staticRenderFns__$7 = [];

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = "data-v-4e8a5fee";
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    undefined,
    undefined,
    undefined
  );

var script$6 = defineComponent({
    name: 'PFieldsetValidationExclude',
    components: { PGroupValidationExclude: __vue_component__$8 },
});

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-group-validation-exclude',[_vm._t("default")],2)};
var __vue_staticRenderFns__$6 = [];

  /* style */
  const __vue_inject_styles__$6 = undefined;
  /* scoped */
  const __vue_scope_id__$6 = undefined;
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    undefined,
    undefined,
    undefined
  );

var script$5 = defineComponent({
    name: 'PFieldsetSpacer',
    components: { PGroupValidationSpacer: __vue_component__$7 },
    props: {
        mobileOnly: { type: Boolean },
    },
});

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-group-validation-spacer',{attrs:{"mobile-only":_vm.mobileOnly}})};
var __vue_staticRenderFns__$5 = [];

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

var components = /*#__PURE__*/Object.freeze({
	__proto__: null,
	PAlert: __vue_component__$1b,
	PCard: __vue_component__$1a,
	PHelp: __vue_component__$1d,
	PHelpMobileTrigger: __vue_component__$19,
	PValueGrid: __vue_component__$18,
	PValueRow: __vue_component__$15,
	PStep: __vue_component__$14,
	PStepper: __vue_component__$13,
	PButton: __vue_component__$1f,
	PButtonContainer: __vue_component__$12,
	PInfo: __vue_component__$16,
	PDataTable: __vue_component__$U,
	PDataTableButton: __vue_component__$T,
	PFilters: __vue_component__$X,
	PForm: __vue_component__$S,
	usePageDirtyState: usePageDirtyState,
	PFooter: __vue_component__$R,
	PHeader: __vue_component__$H,
	PHeaderButton: __vue_component__$G,
	PDialog: __vue_component__$17,
	PContainer: __vue_component__$11,
	PIcon: __vue_component__$F,
	PContactList: __vue_component__$E,
	PContactListItem: __vue_component__$C,
	PList: __vue_component__$P,
	PListItem: __vue_component__$O,
	PListItemIcon: __vue_component__$D,
	PListItemTitle: __vue_component__$M,
	PListItemContent: __vue_component__$N,
	PMenu: __vue_component__$B,
	PApp: __vue_component__$v,
	PMain: __vue_component__$u,
	PLoadingIndicator: __vue_component__$t,
	PDivider: __vue_component__$1j,
	PRow: __vue_component__$L,
	PCol: __vue_component__$K,
	PNotifyRequiredField: __vue_component__$s,
	PTextField: __vue_component__$r,
	PTextarea: __vue_component__$q,
	PDatePicker: __vue_component__$m,
	PCheckbox: __vue_component__$l,
	PRadioGroup: __vue_component__$f,
	PSearch: __vue_component__$Y,
	PFileUpload: __vue_component__$b,
	PRouterLink: __vue_component__$a,
	PHeading: __vue_component__$1i,
	PSection: __vue_component__$9,
	PGroupValidation: __vue_component__$k,
	PGroupValidationError: __vue_component__$j,
	PGroupValidationExclude: __vue_component__$8,
	PGroupValidationSpacer: __vue_component__$7,
	PFieldset: __vue_component__$h,
	PFieldsetError: __vue_component__$g,
	PFieldsetValidationExclude: __vue_component__$6,
	PFieldsetSpacer: __vue_component__$5,
	usePAriaLive: usePAriaLive,
	PSelect: __vue_component__$Z
});

var script$4 = defineComponent({
    name: 'PageLayoutFull',
    components: {
        PageLayoutBase: __vue_component__$1h,
        PHelp: __vue_component__$1d,
        PHelpMobileTrigger: __vue_component__$19,
        PButton: __vue_component__$1f,
        PCol: __vue_component__$K,
        PRow: __vue_component__$L,
    },
    props: {
        helpPanelItems: { type: Array, default: null },
        a11yFocusableOptions: { type: Object, default: null },
        pageTitle: { type: String, default: null },
        helpPanelPosition: {
            type: String,
            default: 'content-top-right',
            validator: propVal => {
                const approvedValues = ['header-inline-right', 'content-top-right'];
                return approvedValues.includes(propVal);
            },
        },
        printButton: { type: Boolean, default: false },
    },
    setup(_, { slots }) {
        const printer = useWindowPrint();
        const hasSlot = useHasSlot(slots);
        return {
            sendToPrinter: printer.sendToPrinter,
            hasSlot,
        };
    },
});

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout-base',{attrs:{"a11y-focusable-options":_vm.a11yFocusableOptions,"page-title":_vm.pageTitle,"divider":_vm.helpPanelPosition !== 'header-inline-right' && !_vm.hasSlot('headerInlineContent')},scopedSlots:_vm._u([(_vm.hasSlot('title'))?{key:"title",fn:function(){return [_vm._t("title")]},proxy:true}:null,{key:"headerInlineContent",fn:function(){return [_vm._t("headerInlineContent"),_vm._v(" "),(_vm.helpPanelPosition === 'header-inline-right')?_c('p-help',{attrs:{"items":_vm.helpPanelItems}}):_vm._e()]},proxy:true}],null,true)},[_vm._v(" "),_vm._v(" "),(_vm.helpPanelItems !== null)?_c('p-help-mobile-trigger',{staticClass:"text-right"}):_vm._e(),_vm._v(" "),_c('p-row',{staticClass:"flex-nowrap"},[(_vm.hasSlot('topRow'))?_c('p-col',{key:"pageLayoutFullColTopRow",staticClass:"flex-grow-1",attrs:{"cols":"12","md":"auto"}},[_vm._t("topRow")],2):_vm._e(),_vm._v(" "),(_vm.hasSlot('extraButton'))?_c('p-col',{staticClass:"flex-shrink-1 justify-end d-none d-md-block",attrs:{"md":"auto"}},[_vm._t("extraButton")],2):_vm._e(),_vm._v(" "),(_vm.printButton !== false)?_c('p-col',{key:"pageLayoutFullColPrintButton",staticClass:"flex-shrink-1 justify-end d-none d-md-block",attrs:{"md":"auto"}},[_c('p-button',{attrs:{"preset":"print","data-ui":"print-page-button"},on:{"click":_vm.sendToPrinter}},[_vm._v("\n        "+_vm._s(_vm.$t('printOverview'))+"\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.helpPanelItems !== null && _vm.helpPanelPosition === 'content-top-right')?_c('p-col',{key:"pageLayoutFullColHelpPanelItems",staticClass:"flex-shrink-1 justify-end pa-0 pa-md-3",attrs:{"md":"auto"}},[_c('p-help',{attrs:{"items":_vm.helpPanelItems}})],1):_vm._e()],1),_vm._v(" "),_c('p-row',[_c('p-col',[_vm._t("default")],2)],1),_vm._v(" "),_c('p-row',[(_vm.hasSlot('extraButton'))?_c('p-col',{staticClass:"d-flex d-md-none pt-0",attrs:{"cols":"12"}},[_vm._t("extraButton")],2):_vm._e(),_vm._v(" "),(_vm.printButton !== false)?_c('p-col',{staticClass:"d-flex d-md-none pt-0",attrs:{"cols":"12"}},[_c('p-button',{attrs:{"preset":"print"},on:{"click":_vm.sendToPrinter}},[_vm._v("\n        "+_vm._s(_vm.$t('printOverview'))+"\n      ")])],1):_vm._e()],1)],1)};
var __vue_staticRenderFns__$4 = [];

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

var i18n = {
    messages: {
        nl: {
            pageNotFoundTitle: '404 - Pagina niet gevonden',
            pageNotFoundBody: {
                notFound: 'Helaas, de door u opgevraagde pagina kan niet (meer) worden gevonden!',
                troubleshoot: {
                    title: 'Wat kunt u doen?',
                    typo: 'Controleer of het adres van de pagina correct is en geen typefouten bevat.',
                    previousPage: {
                        text: 'Ga terug naar de {0}.',
                        link: 'vorige pagina',
                    },
                    homepage: {
                        text: 'Begin opnieuw op de {0}.',
                        link: 'startpagina',
                    },
                    tryLater: 'Probeer het later nog eens, wellicht is de pagina dan wel te vinden.',
                },
                keepsPersisting: 'Blijft het probleem zich voordoen, neem dan {0} op met uw verstrekker.',
                contact: 'contact',
                timestamp: 'Vermeld hierin ook het volgende tijdstip: {time}',
            },
        },
    },
};

//
var script$3 = defineComponent({
  name: 'PageNotFound',
  components: { PageLayoutFull: __vue_component__$4 },
  i18n,
  setup () {
    return {
      time: new Date().toLocaleString('nl-NL').slice(0, -3),
    }
  },
});

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout-full',{attrs:{"page-title":_vm.$t('pageNotFoundTitle')}},[_c('p',{staticClass:"text-h6"},[_vm._v("\n    "+_vm._s(_vm.$t('pageNotFoundBody.notFound'))+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"text-h6"},[_vm._v("\n    "+_vm._s(_vm.$t('pageNotFoundBody.troubleshoot.title'))+"\n  ")]),_vm._v(" "),_c('ul',{staticClass:"mb-5"},[_c('li',[_vm._v(_vm._s(_vm.$t('pageNotFoundBody.troubleshoot.typo')))]),_vm._v(" "),_c('li',[_c('i18n',{attrs:{"path":"pageNotFoundBody.troubleshoot.previousPage.text"}},[_c('a',{attrs:{"data-ui":"previous-page-link","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('toPreviousPage')}}},[_vm._v(_vm._s(_vm.$t('pageNotFoundBody.troubleshoot.previousPage.link'))+"\n        ")])])],1),_vm._v(" "),_c('li',[_c('i18n',{attrs:{"path":"pageNotFoundBody.troubleshoot.homepage.text"}},[_c('a',{attrs:{"data-ui":"homepage-link","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('toHomepage')}}},[_vm._v(_vm._s(_vm.$t('pageNotFoundBody.troubleshoot.homepage.link'))+"\n        ")])])],1),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('pageNotFoundBody.troubleshoot.tryLater')))])]),_vm._v(" "),_c('p',[_c('i18n',{attrs:{"path":"pageNotFoundBody.keepsPersisting"}},[_c('a',{attrs:{"data-ui":"contact-page-link","href":"https://www.mijnpgb.nl/onderwerpen/contact"}},[_vm._v(_vm._s(_vm.$t('pageNotFoundBody.contact')))])])],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('pageNotFoundBody.timestamp', {time: _vm.time})))])])};
var __vue_staticRenderFns__$3 = [];

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

/*!
 * vue-i18n v8.28.2 
 * (c) 2022 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * constants
 */

var numberFormatKeys = [
  'compactDisplay',
  'currency',
  'currencyDisplay',
  'currencySign',
  'localeMatcher',
  'notation',
  'numberingSystem',
  'signDisplay',
  'style',
  'unit',
  'unitDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits'
];

var dateTimeFormatKeys = [
  'dateStyle',
  'timeStyle',
  'calendar',
  'localeMatcher',
  "hour12",
  "hourCycle",
  "timeZone",
  "formatMatcher",
  'weekday',
  'era',
  'year',
  'month',
  'day',
  'hour',
  'minute',
  'second',
  'timeZoneName' ];

/**
 * utilities
 */

function warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function error (msg, err) {
  if (typeof console !== 'undefined') {
    console.error('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.error(err.stack);
    }
  }
}

var isArray = Array.isArray;

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isBoolean (val) {
  return typeof val === 'boolean'
}

function isString (val) {
  return typeof val === 'string'
}

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return toString.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function isFunction (val) {
  return typeof val === 'function'
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject(args[0]) || isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (isObject(args[1]) || isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove (arr, item) {
  if (arr.delete(item)) {
    return arr
  }
}

function arrayFrom (arr) {
  var ret = [];
  arr.forEach(function (a) { return ret.push(a); });
  return ret
}

function includes (arr, item) {
  return !!~arr.indexOf(item)
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

function merge (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn(source, key)) {
          if (isObject(source[key])) {
            output[key] = merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = isArray(a);
      var isArrayB = isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Sanitizes html special characters from input strings. For mitigating risk of XSS attacks.
 * @param rawText The raw input from the user that should be escaped.
 */
function escapeHtml(rawText) {
  return rawText
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;')
}

/**
 * Escapes html tags and special symbols from all provided params which were returned from parseArgs().params.
 * This method performs an in-place operation on the params object.
 *
 * @param {any} params Parameters as provided from `parseArgs().params`.
 *                     May be either an array of strings or a string->any map.
 *
 * @returns The manipulated `params` object.
 */
function escapeParams(params) {
  if(params != null) {
    Object.keys(params).forEach(function (key) {
      if(typeof(params[key]) == 'string') {
        params[key] = escapeHtml(params[key]);
      }
    });
  }
  return params
}

/*  */

function extend (Vue) {
  if (!Vue.prototype.hasOwnProperty('$i18n')) {
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$i18n', {
      get: function get () { return this._i18n }
    });
  }

  Vue.prototype.$t = function (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

    var i18n = this.$i18n;
    return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ))
  };

  Vue.prototype.$tc = function (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

    var i18n = this.$i18n;
    return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this, choice ].concat( values ))
  };

  Vue.prototype.$te = function (key, locale) {
    var i18n = this.$i18n;
    return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
  };

  Vue.prototype.$d = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).d.apply(ref, [ value ].concat( args ))
  };

  Vue.prototype.$n = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).n.apply(ref, [ value ].concat( args ))
  };
}

/*  */

/**
 * Mixin
 * 
 * If `bridge` mode, empty mixin is returned,
 * else regulary mixin implementation is returned.
 */
function defineMixin (bridge) {
  if ( bridge === void 0 ) bridge = false;

  function mounted () {
    if (this !== this.$root && this.$options.__INTLIFY_META__ && this.$el) {
      this.$el.setAttribute('data-intlify', this.$options.__INTLIFY_META__);
    }
  }

  return bridge
    ? { mounted: mounted } // delegate `vue-i18n-bridge` mixin implementation
    : { // regulary 
    beforeCreate: function beforeCreate () {
      var options = this.$options;
      options.i18n = options.i18n || ((options.__i18nBridge || options.__i18n) ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          if ((options.__i18nBridge || options.__i18n)) {
            try {
              var localeMessages = options.i18n && options.i18n.messages ? options.i18n.messages : {};
              var _i18n = options.__i18nBridge || options.__i18n;
              _i18n.forEach(function (resource) {
                localeMessages = merge(localeMessages, JSON.parse(resource));
              });
              Object.keys(localeMessages).forEach(function (locale) {
                options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
              });
            } catch (e) {
              if (process.env.NODE_ENV !== 'production') {
                error("Cannot parse locale messages via custom blocks.", e);
              }
            }
          }
          this._i18n = options.i18n;
          this._i18nWatcher = this._i18n.watchI18nData();
        } else if (isPlainObject(options.i18n)) {
          var rootI18n = this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n
            ? this.$root.$i18n
            : null;
          // component local i18n
          if (rootI18n) {
            options.i18n.root = this.$root;
            options.i18n.formatter = rootI18n.formatter;
            options.i18n.fallbackLocale = rootI18n.fallbackLocale;
            options.i18n.formatFallbackMessages = rootI18n.formatFallbackMessages;
            options.i18n.silentTranslationWarn = rootI18n.silentTranslationWarn;
            options.i18n.silentFallbackWarn = rootI18n.silentFallbackWarn;
            options.i18n.pluralizationRules = rootI18n.pluralizationRules;
            options.i18n.preserveDirectiveContent = rootI18n.preserveDirectiveContent;
          }

          // init locale messages via custom blocks
          if ((options.__i18nBridge || options.__i18n)) {
            try {
              var localeMessages$1 = options.i18n && options.i18n.messages ? options.i18n.messages : {};
              var _i18n$1 = options.__i18nBridge || options.__i18n;
              _i18n$1.forEach(function (resource) {
                localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
              });
              options.i18n.messages = localeMessages$1;
            } catch (e) {
              if (process.env.NODE_ENV !== 'production') {
                warn("Cannot parse locale messages via custom blocks.", e);
              }
            }
          }

          var ref = options.i18n;
          var sharedMessages = ref.sharedMessages;
          if (sharedMessages && isPlainObject(sharedMessages)) {
            options.i18n.messages = merge(options.i18n.messages, sharedMessages);
          }

          this._i18n = new VueI18n(options.i18n);
          this._i18nWatcher = this._i18n.watchI18nData();

          if (options.i18n.sync === undefined || !!options.i18n.sync) {
            this._localeWatcher = this.$i18n.watchLocale();
          }

          if (rootI18n) {
            rootI18n.onComponentInstanceCreated(this._i18n);
          }
        } else {
          if (process.env.NODE_ENV !== 'production') {
            warn("Cannot be interpreted 'i18n' option.");
          }
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        // root i18n
        this._i18n = this.$root.$i18n;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        // parent i18n
        this._i18n = options.parent.$i18n;
      }
    },

    beforeMount: function beforeMount () {
      var options = this.$options;
      options.i18n = options.i18n || ((options.__i18nBridge || options.__i18n) ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else if (isPlainObject(options.i18n)) {
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else {
          if (process.env.NODE_ENV !== 'production') {
            warn("Cannot be interpreted 'i18n' option.");
          }
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      }
    },

    mounted: mounted,

    beforeDestroy: function beforeDestroy () {
      if (!this._i18n) { return }

      var self = this;
      this.$nextTick(function () {
        if (self._subscribing) {
          self._i18n.unsubscribeDataChanging(self);
          delete self._subscribing;
        }

        if (self._i18nWatcher) {
          self._i18nWatcher();
          self._i18n.destroyVM();
          delete self._i18nWatcher;
        }

        if (self._localeWatcher) {
          self._localeWatcher();
          delete self._localeWatcher;
        }
      });
    }
  }
}

/*  */

var interpolationComponent = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var data = ref.data;
    var parent = ref.parent;
    var props = ref.props;
    var slots = ref.slots;

    var $i18n = parent.$i18n;
    if (!$i18n) {
      if (process.env.NODE_ENV !== 'production') {
        warn('Cannot find VueI18n instance!');
      }
      return
    }

    var path = props.path;
    var locale = props.locale;
    var places = props.places;
    var params = slots();
    var children = $i18n.i(
      path,
      locale,
      onlyHasDefaultPlace(params) || places
        ? useLegacyPlaces(params.default, places)
        : params
    );

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag ? h(tag, data, children) : children
  }
};

function onlyHasDefaultPlace (params) {
  var prop;
  for (prop in params) {
    if (prop !== 'default') { return false }
  }
  return Boolean(prop)
}

function useLegacyPlaces (children, places) {
  var params = places ? createParamsFromPlaces(places) : {};

  if (!children) { return params }

  // Filter empty text nodes
  children = children.filter(function (child) {
    return child.tag || child.text.trim() !== ''
  });

  var everyPlace = children.every(vnodeHasPlaceAttribute);
  if (process.env.NODE_ENV !== 'production' && everyPlace) {
    warn('`place` attribute is deprecated in next major version. Please switch to Vue slots.');
  }

  return children.reduce(
    everyPlace ? assignChildPlace : assignChildIndex,
    params
  )
}

function createParamsFromPlaces (places) {
  if (process.env.NODE_ENV !== 'production') {
    warn('`places` prop is deprecated in next major version. Please switch to Vue slots.');
  }

  return Array.isArray(places)
    ? places.reduce(assignChildIndex, {})
    : Object.assign({}, places)
}

function assignChildPlace (params, child) {
  if (child.data && child.data.attrs && child.data.attrs.place) {
    params[child.data.attrs.place] = child;
  }
  return params
}

function assignChildIndex (params, child, index) {
  params[index] = child;
  return params
}

function vnodeHasPlaceAttribute (vnode) {
  return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place)
}

/*  */

var numberComponent = {
  name: 'i18n-n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    },
    locale: {
      type: String
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var parent = ref.parent;
    var data = ref.data;

    var i18n = parent.$i18n;

    if (!i18n) {
      if (process.env.NODE_ENV !== 'production') {
        warn('Cannot find VueI18n instance!');
      }
      return null
    }

    var key = null;
    var options = null;

    if (isString(props.format)) {
      key = props.format;
    } else if (isObject(props.format)) {
      if (props.format.key) {
        key = props.format.key;
      }

      // Filter out number format options only
      options = Object.keys(props.format).reduce(function (acc, prop) {
        var obj;

        if (includes(numberFormatKeys, prop)) {
          return Object.assign({}, acc, ( obj = {}, obj[prop] = props.format[prop], obj ))
        }
        return acc
      }, null);
    }

    var locale = props.locale || i18n.locale;
    var parts = i18n._ntp(props.value, locale, key, options);

    var values = parts.map(function (part, index) {
      var obj;

      var slot = data.scopedSlots && data.scopedSlots[part.type];
      return slot ? slot(( obj = {}, obj[part.type] = part.value, obj.index = index, obj.parts = parts, obj )) : part.value
    });

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag
      ? h(tag, {
        attrs: data.attrs,
        'class': data['class'],
        staticClass: data.staticClass
      }, values)
      : values
  }
};

/*  */

function bind (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t(el, binding, vnode);
}

function update (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  var i18n = vnode.context.$i18n;
  if (localeEqual(el, vnode) &&
    (looseEqual(binding.value, binding.oldValue) &&
     looseEqual(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) { return }

  t(el, binding, vnode);
}

function unbind (el, binding, vnode, oldVNode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return
  }

  var i18n = vnode.context.$i18n || {};
  if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
    el.textContent = '';
  }
  el._vt = undefined;
  delete el['_vt'];
  el._locale = undefined;
  delete el['_locale'];
  el._localeMessage = undefined;
  delete el['_localeMessage'];
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return false
  }

  if (!vm.$i18n) {
    warn('VueI18n instance does not exists in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t (el, binding, vnode) {
  var ref$1, ref$2;

  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    warn('value type not supported');
    return
  }

  if (!path) {
    warn('`path` is required in v-t directive');
    return
  }

  var vm = vnode.context;
  if (choice != null) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
  }
  el._locale = vm.$i18n.locale;
  el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
}

function parseValue (value) {
  var path;
  var locale;
  var args;
  var choice;

  if (isString(value)) {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }

  return { path: path, locale: locale, args: args, choice: choice }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }

  return params
}

var Vue;

function install$1 (_Vue, options) {
  if ( options === void 0 ) options = { bridge: false };

  /* istanbul ignore if */
  if (process.env.NODE_ENV !== 'production' && install$1.installed && _Vue === Vue) {
    warn('already installed.');
    return
  }
  install$1.installed = true;

  Vue = _Vue;

  var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
  /* istanbul ignore if */
  if (process.env.NODE_ENV !== 'production' && version < 2) {
    warn(("vue-i18n (" + (install$1.version) + ") need to use Vue 2.0 or later (Vue: " + (Vue.version) + ")."));
    return
  }

  extend(Vue);
  Vue.mixin(defineMixin(options.bridge));
  Vue.directive('t', { bind: bind, update: update, unbind: unbind });
  Vue.component(interpolationComponent.name, interpolationComponent);
  Vue.component(numberComponent.name, numberComponent);

  // use simple mergeStrategies to prevent i18n instance lose '__proto__'
  var strats = Vue.config.optionMergeStrategies;
  strats.i18n = function (parentVal, childVal) {
    return childVal === undefined
      ? parentVal
      : childVal
  };
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  if (!values) {
    return [message]
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};



var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

function parse (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== undefined && char !== '}') {
        sub += char;
        char = format[position++];
      }
      var isClosed = char === '}';

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : isObject(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        } else {
          if (process.env.NODE_ENV !== 'production') {
            warn(("Type of token '" + (token.type) + "' and format of value '" + mode + "' don't match!"));
          }
        }
        break
      case 'unknown':
        if (process.env.NODE_ENV !== 'production') {
          warn("Detect 'unknown' type of token!");
        }
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path parser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  return 'ident'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      if (key === undefined) { return false }
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!isObject(obj)) { return null }

  var paths = this.parsePath(path);
  if (paths.length === 0) {
    return null
  } else {
    var length = paths.length;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined || value === null) {
        return null
      }
      last = value;
      i++;
    }

    return last
  }
};

/*  */



var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
var linkKeyMatcher = /(?:@(?:\.[a-zA-Z]+)?:(?:[\w\-_|./]+|\([\w\-_:|./]+\)))/g;
var linkKeyPrefixMatcher = /^@(?:\.([a-zA-Z]+))?:/;
var bracketsMatcher = /[()]/g;
var defaultModifiers = {
  'upper': function (str) { return str.toLocaleUpperCase(); },
  'lower': function (str) { return str.toLocaleLowerCase(); },
  'capitalize': function (str) { return ("" + (str.charAt(0).toLocaleUpperCase()) + (str.substr(1))); }
};

var defaultFormatter = new BaseFormatter();

var VueI18n = function VueI18n (options) {
  var this$1$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #290
  /* istanbul ignore if */
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install$1(window.Vue);
  }

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale === false
    ? false
    : options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || options.datetimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || defaultFormatter;
  this._modifiers = options.modifiers || {};
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._fallbackRootWithEmptyString = options.fallbackRootWithEmptyString === undefined
    ? true
    : !!options.fallbackRootWithEmptyString;
  this._formatFallbackMessages = options.formatFallbackMessages === undefined
    ? false
    : !!options.formatFallbackMessages;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : options.silentTranslationWarn;
  this._silentFallbackWarn = options.silentFallbackWarn === undefined
    ? false
    : !!options.silentFallbackWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = new Set();
  this._componentInstanceCreatedListener = options.componentInstanceCreatedListener || null;
  this._preserveDirectiveContent = options.preserveDirectiveContent === undefined
    ? false
    : !!options.preserveDirectiveContent;
  this.pluralizationRules = options.pluralizationRules || {};
  this._warnHtmlInMessage = options.warnHtmlInMessage || 'off';
  this._postTranslation = options.postTranslation || null;
  this._escapeParameterHtml = options.escapeParameterHtml || false;

  if ('__VUE_I18N_BRIDGE__' in options) {
    this.__VUE_I18N_BRIDGE__ = options.__VUE_I18N_BRIDGE__;
  }

  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index
  */
  this.getChoiceIndex = function (choice, choicesLength) {
    var thisPrototype = Object.getPrototypeOf(this$1$1);
    if (thisPrototype && thisPrototype.getChoiceIndex) {
      var prototypeGetChoiceIndex = (thisPrototype.getChoiceIndex);
      return (prototypeGetChoiceIndex).call(this$1$1, choice, choicesLength)
    }

    // Default (old) getChoiceIndex implementation - english-compatible
    var defaultImpl = function (_choice, _choicesLength) {
      _choice = Math.abs(_choice);

      if (_choicesLength === 2) {
        return _choice
          ? _choice > 1
            ? 1
            : 0
          : 1
      }

      return _choice ? Math.min(_choice, 2) : 0
    };

    if (this$1$1.locale in this$1$1.pluralizationRules) {
      return this$1$1.pluralizationRules[this$1$1.locale].apply(this$1$1, [choice, choicesLength])
    } else {
      return defaultImpl(choice, choicesLength)
    }
  };


  this._exist = function (message, key) {
    if (!message || !key) { return false }
    if (!isNull(this$1$1._path.getPathValue(message, key))) { return true }
    // fallback for flat key
    if (message[key]) { return true }
    return false
  };

  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    Object.keys(messages).forEach(function (locale) {
      this$1$1._checkLocaleMessage(locale, this$1$1._warnHtmlInMessage, messages[locale]);
    });
  }

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },availableLocales: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },formatFallbackMessages: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true },silentFallbackWarn: { configurable: true },preserveDirectiveContent: { configurable: true },warnHtmlInMessage: { configurable: true },postTranslation: { configurable: true },sync: { configurable: true } };

VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage (locale, level, message) {
  var paths = [];

  var fn = function (level, locale, message, paths) {
    if (isPlainObject(message)) {
      Object.keys(message).forEach(function (key) {
        var val = message[key];
        if (isPlainObject(val)) {
          paths.push(key);
          paths.push('.');
          fn(level, locale, val, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(key);
          fn(level, locale, val, paths);
          paths.pop();
        }
      });
    } else if (isArray(message)) {
      message.forEach(function (item, index) {
        if (isPlainObject(item)) {
          paths.push(("[" + index + "]"));
          paths.push('.');
          fn(level, locale, item, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(("[" + index + "]"));
          fn(level, locale, item, paths);
          paths.pop();
        }
      });
    } else if (isString(message)) {
      var ret = htmlTagMatcher.test(message);
      if (ret) {
        var msg = "Detected HTML in message '" + message + "' of keypath '" + (paths.join('')) + "' at '" + locale + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
        if (level === 'warn') {
          warn(msg);
        } else if (level === 'error') {
          error(msg);
        }
      }
    }
  };

  fn(level, locale, message, paths);
};

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data: data, __VUE18N__INSTANCE__: true });
  Vue.config.silent = silent;
};

VueI18n.prototype.destroyVM = function destroyVM () {
  this._vm.$destroy();
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.add(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
    var this$1$1 = this;
  return this._vm.$watch('$data', function () {
    var listeners = arrayFrom(this$1$1._dataListeners);
    var i = listeners.length;
    while(i--) {
      Vue.nextTick(function () {
        listeners[i] && listeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale (composer) {
  if (!composer) {
    /* istanbul ignore if */
    if (!this._sync || !this._root) { return null }
    var target = this._vm;
    return this._root.$i18n.vm.$watch('locale', function (val) {
      target.$set(target, 'locale', val);
      target.$forceUpdate();
    }, { immediate: true })
  } else {
    // deal with vue-i18n-bridge
    if (!this.__VUE_I18N_BRIDGE__) { return null }
    var self = this;
    var target$1 = this._vm;
    return this.vm.$watch('locale', function (val) {
      target$1.$set(target$1, 'locale', val);
      if (self.__VUE_I18N_BRIDGE__ && composer) {
        composer.locale.value = val;
      }
      target$1.$forceUpdate();
    }, { immediate: true })
  }
};

VueI18n.prototype.onComponentInstanceCreated = function onComponentInstanceCreated (newI18n) {
  if (this._componentInstanceCreatedListener) {
    this._componentInstanceCreatedListener(newI18n, this);
  }
};

prototypeAccessors.vm.get = function () { return this._vm };

prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };
prototypeAccessors.availableLocales.get = function () { return Object.keys(this.messages).sort() };

prototypeAccessors.locale.get = function () { return this._vm.locale };
prototypeAccessors.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors.fallbackLocale.set = function (locale) {
  this._localeChainCache = {};
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors.formatFallbackMessages.get = function () { return this._formatFallbackMessages };
prototypeAccessors.formatFallbackMessages.set = function (fallback) { this._formatFallbackMessages = fallback; };

prototypeAccessors.missing.get = function () { return this._missing };
prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors.formatter.get = function () { return this._formatter };
prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

prototypeAccessors.silentFallbackWarn.get = function () { return this._silentFallbackWarn };
prototypeAccessors.silentFallbackWarn.set = function (silent) { this._silentFallbackWarn = silent; };

prototypeAccessors.preserveDirectiveContent.get = function () { return this._preserveDirectiveContent };
prototypeAccessors.preserveDirectiveContent.set = function (preserve) { this._preserveDirectiveContent = preserve; };

prototypeAccessors.warnHtmlInMessage.get = function () { return this._warnHtmlInMessage };
prototypeAccessors.warnHtmlInMessage.set = function (level) {
    var this$1$1 = this;

  var orgLevel = this._warnHtmlInMessage;
  this._warnHtmlInMessage = level;
  if (orgLevel !== level && (level === 'warn' || level === 'error')) {
    var messages = this._getMessages();
    Object.keys(messages).forEach(function (locale) {
      this$1$1._checkLocaleMessage(locale, this$1$1._warnHtmlInMessage, messages[locale]);
    });
  }
};

prototypeAccessors.postTranslation.get = function () { return this._postTranslation };
prototypeAccessors.postTranslation.set = function (handler) { this._postTranslation = handler; };

prototypeAccessors.sync.get = function () { return this._sync };
prototypeAccessors.sync.set = function (val) { this._sync = val; };

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values, interpolateMode) {
  if (!isNull(result)) { return result }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (isString(missingRet)) {
      return missingRet
    }
  } else {
    if (process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key)) {
      warn(
        "Cannot translate the value of keypath '" + key + "'. " +
        'Use the value of keypath as default.'
      );
    }
  }

  if (this._formatFallbackMessages) {
    var parsedArgs = parseArgs.apply(void 0, values);
    return this._render(key, interpolateMode, parsedArgs.params, key)
  } else {
    return key
  }
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return (this._fallbackRootWithEmptyString? !val : isNull(val)) && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn (key) {
  return this._silentFallbackWarn instanceof RegExp
    ? this._silentFallbackWarn.test(key)
    : this._silentFallbackWarn
};

VueI18n.prototype._isSilentFallback = function _isSilentFallback (locale, key) {
  return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale)
};

VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn (key) {
  return this._silentTranslationWarn instanceof RegExp
    ? this._silentTranslationWarn.test(key)
    : this._silentTranslationWarn
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (isArray(pathRet) || isPlainObject(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject(message)) {
      ret = message[key];
      if (!(isString(ret) || isFunction(ret))) {
        if (process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallback(locale, key)) {
          warn(("Value of key '" + key + "' is not a string or function !"));
        }
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (isString(pathRet) || isFunction(pathRet)) {
      ret = pathRet;
    } else {
      if (process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallback(locale, key)) {
        warn(("Value of key '" + key + "' is not a string or function!"));
      }
      return null
    }
  }

  // Check for the existence of links within the translated string
  if (isString(ret) && (ret.indexOf('@:') >= 0 || ret.indexOf('@.') >= 0)) {
    ret = this._link(locale, message, ret, host, 'raw', values, visitedLinkStack);
  }

  return this._render(ret, interpolateMode, values, key)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(linkKeyMatcher);

  // eslint-disable-next-line no-autofix/prefer-const
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
    var linkPrefix = linkKeyPrefixMatches[0];
      var formatterName = linkKeyPrefixMatches[1];

    // Remove the leading @:, @.case: and the brackets
    var linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');

    if (includes(visitedLinkStack, linkPlaceholder)) {
      if (process.env.NODE_ENV !== 'production') {
        warn(("Circular reference found. \"" + link + "\" is already visited in the chain of " + (visitedLinkStack.reverse().join(' <- '))));
      }
      return ret
    }
    visitedLinkStack.push(linkPlaceholder);

    // Translate the link
    var translated = this._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values,
      visitedLinkStack
    );

    if (this._isFallbackRoot(translated)) {
      if (process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(linkPlaceholder)) {
        warn(("Fall back to translate the link placeholder '" + linkPlaceholder + "' with root locale."));
      }
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      var root = this._root.$i18n;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this._warnDefault(
      locale, linkPlaceholder, translated, host,
      isArray(values) ? values : [values],
      interpolateMode
    );

    if (this._modifiers.hasOwnProperty(formatterName)) {
      translated = this._modifiers[formatterName](translated);
    } else if (defaultModifiers.hasOwnProperty(formatterName)) {
      translated = defaultModifiers[formatterName](translated);
    }

    visitedLinkStack.pop();

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._createMessageContext = function _createMessageContext (values, formatter, path, interpolateMode) {
    var this$1$1 = this;

  var _list = isArray(values) ? values : [];
  var _named = isObject(values) ? values : {};
  var list = function (index) { return _list[index]; };
  var named = function (key) { return _named[key]; };
  var messages = this._getMessages();
  var locale = this.locale;

  return {
    list: list,
    named: named,
    values: values,
    formatter: formatter,
    path: path,
    messages: messages,
    locale: locale,
    linked: function (linkedKey) { return this$1$1._interpolate(locale, messages[locale] || {}, linkedKey, null, interpolateMode, undefined, [linkedKey]); }
  }
};

VueI18n.prototype._render = function _render (message, interpolateMode, values, path) {
  if (isFunction(message)) {
    return message(
      this._createMessageContext(values, this._formatter || defaultFormatter, path, interpolateMode)
    )
  }

  var ret = this._formatter.interpolate(message, values, path);

  // If the custom formatter refuses to work - apply the default one
  if (!ret) {
    ret = defaultFormatter.interpolate(message, values, path);
  }

  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' && !isString(ret) ? ret.join('') : ret
};

VueI18n.prototype._appendItemToChain = function _appendItemToChain (chain, item, blocks) {
  var follow = false;
  if (!includes(chain, item)) {
    follow = true;
    if (item) {
      follow = item[item.length - 1] !== '!';
      item = item.replace(/!/g, '');
      chain.push(item);
      if (blocks && blocks[item]) {
        follow = blocks[item];
      }
    }
  }
  return follow
};

VueI18n.prototype._appendLocaleToChain = function _appendLocaleToChain (chain, locale, blocks) {
  var follow;
  var tokens = locale.split('-');
  do {
    var item = tokens.join('-');
    follow = this._appendItemToChain(chain, item, blocks);
    tokens.splice(-1, 1);
  } while (tokens.length && (follow === true))
  return follow
};

VueI18n.prototype._appendBlockToChain = function _appendBlockToChain (chain, block, blocks) {
  var follow = true;
  for (var i = 0; (i < block.length) && (isBoolean(follow)); i++) {
    var locale = block[i];
    if (isString(locale)) {
      follow = this._appendLocaleToChain(chain, locale, blocks);
    }
  }
  return follow
};

VueI18n.prototype._getLocaleChain = function _getLocaleChain (start, fallbackLocale) {
  if (start === '') { return [] }

  if (!this._localeChainCache) {
    this._localeChainCache = {};
  }

  var chain = this._localeChainCache[start];
  if (!chain) {
    if (!fallbackLocale) {
      fallbackLocale = this.fallbackLocale;
    }
    chain = [];

    // first block defined by start
    var block = [start];

    // while any intervening block found
    while (isArray(block)) {
      block = this._appendBlockToChain(
        chain,
        block,
        fallbackLocale
      );
    }

    // last block defined by default
    var defaults;
    if (isArray(fallbackLocale)) {
      defaults = fallbackLocale;
    } else if (isObject(fallbackLocale)) {
      /* $FlowFixMe */
      if (fallbackLocale['default']) {
        defaults = fallbackLocale['default'];
      } else {
        defaults = null;
      }
    } else {
      defaults = fallbackLocale;
    }

    // convert defaults to array
    if (isString(defaults)) {
      block = [defaults];
    } else {
      block = defaults;
    }
    if (block) {
      this._appendBlockToChain(
        chain,
        block,
        null
      );
    }
    this._localeChainCache[start] = chain;
  }
  return chain
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var chain = this._getLocaleChain(locale, fallback);
  var res;
  for (var i = 0; i < chain.length; i++) {
    var step = chain[i];
    res =
      this._interpolate(step, messages[step], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) {
      if (step !== locale && process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to translate the keypath '" + key + "' with '" + step + "' locale."));
      }
      return res
    }
  }
  return null
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var ref;

    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  if(this._escapeParameterHtml) {
    parsedArgs.params = escapeParams(parsedArgs.params);
  }

  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if (process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
      warn(("Fall back to translate the keypath '" + key + "' with root locale."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).$t.apply(ref, [ key ].concat( values ))
  } else {
    ret = this._warnDefault(locale, key, ret, host, values, 'string');
    if (this._postTranslation && ret !== null && ret !== undefined) {
      ret = this._postTranslation(ret, key);
    }
    return ret
  }
};

VueI18n.prototype.t = function t (key) {
    var ref;

    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if (process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key)) {
      warn(("Fall back to interpolate the keypath '" + key + "' with root locale."));
    }
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host, [values], 'raw')
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (!isString(locale)) {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
  host,
  choice
) {
    var ref;

    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
  if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }

  var predefined = { 'count': choice, 'n': choice };
  var parsedArgs = parseArgs.apply(void 0, values);
  parsedArgs.params = Object.assign(predefined, parsedArgs.params);
  values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
  return this.fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
};

VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message || !isString(message)) { return null }
  var choices = message.split('|');

  choice = this.getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
};

VueI18n.prototype.tc = function tc (key, choice) {
    var ref;

    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, message);
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, merge(
    typeof this._vm.messages[locale] !== 'undefined' && Object.keys(this._vm.messages[locale]).length
      ? Object.assign({}, this._vm.messages[locale])
      : {},
    message
  ));
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, merge(this._vm.dateTimeFormats[locale] || {}, format));
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype._clearDateTimeFormat = function _clearDateTimeFormat (locale, format) {
  // eslint-disable-next-line no-autofix/prefer-const
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._dateTimeFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._dateTimeFormatters[id];
  }
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = dateTimeFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to '" + step + "' datetime formats from '" + current + "' datetime formats."));
      }
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      formatter = new Intl.DateTimeFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._dateTimeFormatters[id];
      if (!formatter) {
        formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
      }
    }

    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key, options) {
  /* istanbul ignore if */
  if (process.env.NODE_ENV !== 'production' && !VueI18n.availabilities.dateTimeFormat) {
    warn('Cannot format a Date value due to not supported Intl.DateTimeFormat.');
    return ''
  }

  if (!key) {
    var dtf = !options ? new Intl.DateTimeFormat(locale) : new Intl.DateTimeFormat(locale, options);
    return dtf.format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key, options);
  if (this._isFallbackRoot(ret)) {
    if (process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
      warn(("Fall back to datetime localization of root: key '" + key + "'."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }

    options = Object.keys(args[0]).reduce(function (acc, key) {
        var obj;

      if (includes(dateTimeFormatKeys, key)) {
        return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
      }
      return acc
    }, null);

  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._d(value, locale, key, options)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, merge(this._vm.numberFormats[locale] || {}, format));
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype._clearNumberFormat = function _clearNumberFormat (locale, format) {
  // eslint-disable-next-line no-autofix/prefer-const
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._numberFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._numberFormatters[id];
  }
};

VueI18n.prototype._getNumberFormatter = function _getNumberFormatter (
  value,
  locale,
  fallback,
  numberFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = numberFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to '" + step + "' number formats from '" + current + "' number formats."));
      }
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      // If options specified - create one time number formatter
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter
  }
};

VueI18n.prototype._n = function _n (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (process.env.NODE_ENV !== 'production') {
      warn('Cannot format a Number value due to not supported Intl.NumberFormat.');
    }
    return ''
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.format(value);
  if (this._isFallbackRoot(ret)) {
    if (process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
      warn(("Fall back to number localization of root: key '" + key + "'."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.n(value, Object.assign({}, { key: key, locale: locale }, options))
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }

      // Filter out number format options only
      options = Object.keys(args[0]).reduce(function (acc, key) {
          var obj;

        if (includes(numberFormatKeys, key)) {
          return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
        }
        return acc
      }, null);
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._n(value, locale, key, options)
};

VueI18n.prototype._ntp = function _ntp (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (process.env.NODE_ENV !== 'production') {
      warn('Cannot format to parts a Number value due to not supported Intl.NumberFormat.');
    }
    return []
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.formatToParts(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.formatToParts(value);
  if (this._isFallbackRoot(ret)) {
    if (process.env.NODE_ENV !== 'production' && !this._isSilentTranslationWarn(key)) {
      warn(("Fall back to format number to parts of root: key '" + key + "' ."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n._ntp(value, locale, key, options)
  } else {
    return ret || []
  }
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors );

var availabilities;
// $FlowFixMe
Object.defineProperty(VueI18n, 'availabilities', {
  get: function get () {
    if (!availabilities) {
      var intlDefined = typeof Intl !== 'undefined';
      availabilities = {
        dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
        numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
      };
    }

    return availabilities
  }
});

VueI18n.install = install$1;
VueI18n.version = '8.28.2';

var VueI18n$1 = VueI18n;

var common = {
    nl: {
        cancel: 'Annuleren',
        close: 'Sluiten',
        compose: 'Opstellen',
        complete: 'Afronden',
        continue: 'Doorgaan',
        days: '{count} dag | {count} dagen',
        edit: 'Wijzigen',
        implement: 'Doorvoeren',
        leavePage: 'Pagina verlaten',
        nextStep: 'Volgende',
        no: 'Nee',
        ok: 'Ok',
        previousStep: 'Vorige',
        printOverview: 'Print overzicht',
        print: 'Printen',
        requiredField: 'Verplicht veld',
        results: 'resultaat | resultaten',
        save: 'Opslaan',
        submit: 'Indienen',
        submitted: 'Ingediend',
        success: 'Succes',
        unknown: 'Onbekend',
        verification: 'Controle',
        yes: 'Ja',
    },
};

var errorMessages = {
    nl: {
        emptyField: 'Dit veld is nog niet ingevuld.',
        emptyDate: 'U heeft geen datum ingevuld. Vul een datum in.',
        emptyFiles: 'U heeft nog geen bestand gekozen om te uploaden.',
        invalid: 'De ingevoerde waarde is niet correct.',
        invalidDate: 'U heeft een ongeldige datum ingevuld.',
        maxDate: 'De ingevoerde datum mag niet na {maxDate} liggen.',
        minDate: 'De ingevoerde datum mag niet voor {minDate} liggen.',
        chooseOption: 'U heeft nog geen keuze gemaakt.',
        noMatch: 'U heeft een verkeerde waarde ingevoerd.',
        maxValue: 'De ingevoerde waarde mag niet groter dan {maxValue} zijn.',
        minValue: 'De ingevoerde waarde mag niet kleiner dan {minValue} zijn.',
        invalidNumber: 'U heeft een verkeerd getal ingevoerd.',
        invalidInteger: 'U heeft een verkeerd getal ingevoerd. Vul een geheel getal in.',
        positiveInteger: 'U heeft een verkeerd getal ingevoerd. Vul een geheel getal in groter dan of gelijk aan 0.',
        invalidRange: 'Waarde moet tussen {minValue} en {maxValue} liggen.',
        invalidRangeWithStep: 'Waarde moet tussen {minValue} en {maxValue} liggen en is een veelvoud van {step}.',
        notInCollection: 'U heeft een verkeerde waarde ingevoerd. Vul een van de volgende waardes in {values}.',
    },
};

const dateTimeFormats = {
    long: { year: 'numeric', month: 'long', day: 'numeric' },
    short: { year: 'numeric', month: '2-digit', day: '2-digit' },
    dateTime: { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false },
    dateTimeLong: { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false },
};
function buildI18n(settings) {
    return {
        locale: 'nl',
        fallbackLocale: 'nl',
        silentFallbackWarn: true,
        numberFormats: {
            nl: {
                currency: {
                    style: 'currency', currency: 'EUR', currencyDisplay: 'symbol',
                },
            },
        },
        dateTimeFormats: {
            nl: Object.assign({}, dateTimeFormats),
        },
        messages: {
            nl: Object.assign(Object.assign(Object.assign({}, (settings.common ? settings.common.nl : {})), common.nl), { errorMessages: Object.assign({}, errorMessages.nl) }),
        },
    };
}
function getI18n(VueI18nInstance, settings = {}, fillGlobalI18n) {
    const i18n = buildI18n(settings);
    if (fillGlobalI18n) {
        fillGlobalI18n(i18n);
    }
    return overrideVueI18nD(new VueI18nInstance(i18n));
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var inBrowser = typeof window !== 'undefined';
function freeze(item) {
  if (Array.isArray(item) || _typeof(item) === 'object') {
    return Object.freeze(item);
  }

  return item;
}
function combinePassengers(transports) {
  var slotProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return transports.reduce(function (passengers, transport) {
    var temp = transport.passengers[0];
    var newPassengers = typeof temp === 'function' ? temp(slotProps) : transport.passengers;
    return passengers.concat(newPassengers);
  }, []);
}
function stableSort(array, compareFn) {
  return array.map(function (v, idx) {
    return [idx, v];
  }).sort(function (a, b) {
    return compareFn(a[1], b[1]) || a[0] - b[0];
  }).map(function (c) {
    return c[1];
  });
}
function pick(obj, keys) {
  return keys.reduce(function (acc, key) {
    if (obj.hasOwnProperty(key)) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

var transports = {};
var targets = {};
var sources = {};
var Wormhole = Vue$1.extend({
  data: function data() {
    return {
      transports: transports,
      targets: targets,
      sources: sources,
      trackInstances: inBrowser
    };
  },
  methods: {
    open: function open(transport) {
      if (!inBrowser) return;
      var to = transport.to,
          from = transport.from,
          passengers = transport.passengers,
          _transport$order = transport.order,
          order = _transport$order === void 0 ? Infinity : _transport$order;
      if (!to || !from || !passengers) return;
      var newTransport = {
        to: to,
        from: from,
        passengers: freeze(passengers),
        order: order
      };
      var keys = Object.keys(this.transports);

      if (keys.indexOf(to) === -1) {
        Vue$1.set(this.transports, to, []);
      }

      var currentIndex = this.$_getTransportIndex(newTransport); // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays

      var newTransports = this.transports[to].slice(0);

      if (currentIndex === -1) {
        newTransports.push(newTransport);
      } else {
        newTransports[currentIndex] = newTransport;
      }

      this.transports[to] = stableSort(newTransports, function (a, b) {
        return a.order - b.order;
      });
    },
    close: function close(transport) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var to = transport.to,
          from = transport.from;
      if (!to || !from && force === false) return;

      if (!this.transports[to]) {
        return;
      }

      if (force) {
        this.transports[to] = [];
      } else {
        var index = this.$_getTransportIndex(transport);

        if (index >= 0) {
          // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays
          var newTransports = this.transports[to].slice(0);
          newTransports.splice(index, 1);
          this.transports[to] = newTransports;
        }
      }
    },
    registerTarget: function registerTarget(target, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.targets[target]) {
        console.warn("[portal-vue]: Target ".concat(target, " already exists"));
      }

      this.$set(this.targets, target, Object.freeze([vm]));
    },
    unregisterTarget: function unregisterTarget(target) {
      this.$delete(this.targets, target);
    },
    registerSource: function registerSource(source, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.sources[source]) {
        console.warn("[portal-vue]: source ".concat(source, " already exists"));
      }

      this.$set(this.sources, source, Object.freeze([vm]));
    },
    unregisterSource: function unregisterSource(source) {
      this.$delete(this.sources, source);
    },
    hasTarget: function hasTarget(to) {
      return !!(this.targets[to] && this.targets[to][0]);
    },
    hasSource: function hasSource(to) {
      return !!(this.sources[to] && this.sources[to][0]);
    },
    hasContentFor: function hasContentFor(to) {
      return !!this.transports[to] && !!this.transports[to].length;
    },
    // Internal
    $_getTransportIndex: function $_getTransportIndex(_ref) {
      var to = _ref.to,
          from = _ref.from;

      for (var i in this.transports[to]) {
        if (this.transports[to][i].from === from) {
          return +i;
        }
      }

      return -1;
    }
  }
});
var wormhole = new Wormhole(transports);

var _id = 1;
var Portal = Vue$1.extend({
  name: 'portal',
  props: {
    disabled: {
      type: Boolean
    },
    name: {
      type: String,
      default: function _default() {
        return String(_id++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerSource(_this.name, _this);
    });
  },
  mounted: function mounted() {
    if (!this.disabled) {
      this.sendUpdate();
    }
  },
  updated: function updated() {
    if (this.disabled) {
      this.clear();
    } else {
      this.sendUpdate();
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterSource(this.name);
    this.clear();
  },
  watch: {
    to: function to(newValue, oldValue) {
      oldValue && oldValue !== newValue && this.clear(oldValue);
      this.sendUpdate();
    }
  },
  methods: {
    clear: function clear(target) {
      var closer = {
        from: this.name,
        to: target || this.to
      };
      wormhole.close(closer);
    },
    normalizeSlots: function normalizeSlots() {
      return this.$scopedSlots.default ? [this.$scopedSlots.default] : this.$slots.default;
    },
    normalizeOwnChildren: function normalizeOwnChildren(children) {
      return typeof children === 'function' ? children(this.slotProps) : children;
    },
    sendUpdate: function sendUpdate() {
      var slotContent = this.normalizeSlots();

      if (slotContent) {
        var transport = {
          from: this.name,
          to: this.to,
          passengers: _toConsumableArray(slotContent),
          order: this.order
        };
        wormhole.open(transport);
      } else {
        this.clear();
      }
    }
  },
  render: function render(h) {
    var children = this.$slots.default || this.$scopedSlots.default || [];
    var Tag = this.tag;

    if (children && this.disabled) {
      return children.length <= 1 && this.slim ? this.normalizeOwnChildren(children)[0] : h(Tag, [this.normalizeOwnChildren(children)]);
    } else {
      return this.slim ? h() : h(Tag, {
        class: {
          'v-portal': true
        },
        style: {
          display: 'none'
        },
        key: 'v-portal-placeholder'
      });
    }
  }
});

var PortalTarget = Vue$1.extend({
  name: 'portalTarget',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    slim: {
      type: Boolean,
      default: false
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  data: function data() {
    return {
      transports: wormhole.transports,
      firstRender: true
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerTarget(_this.name, _this);
    });
  },
  watch: {
    ownTransports: function ownTransports() {
      this.$emit('change', this.children().length > 0);
    },
    name: function name(newVal, oldVal) {
      /**
       * TODO
       * This should warn as well ...
       */
      wormhole.unregisterTarget(oldVal);
      wormhole.registerTarget(newVal, this);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.transition) {
      this.$nextTick(function () {
        // only when we have a transition, because it causes a re-render
        _this2.firstRender = false;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterTarget(this.name);
  },
  computed: {
    ownTransports: function ownTransports() {
      var transports = this.transports[this.name] || [];

      if (this.multiple) {
        return transports;
      }

      return transports.length === 0 ? [] : [transports[transports.length - 1]];
    },
    passengers: function passengers() {
      return combinePassengers(this.ownTransports, this.slotProps);
    }
  },
  methods: {
    // can't be a computed prop because it has to "react" to $slot changes.
    children: function children() {
      return this.passengers.length !== 0 ? this.passengers : this.$scopedSlots.default ? this.$scopedSlots.default(this.slotProps) : this.$slots.default || [];
    },
    // can't be a computed prop because it has to "react" to this.children().
    noWrapper: function noWrapper() {
      var noWrapper = this.slim && !this.transition;

      if (noWrapper && this.children().length > 1) {
        console.warn('[portal-vue]: PortalTarget with `slim` option received more than one child element.');
      }

      return noWrapper;
    }
  },
  render: function render(h) {
    var noWrapper = this.noWrapper();
    var children = this.children();
    var Tag = this.transition || this.tag;
    return noWrapper ? children[0] : this.slim && !Tag ? h() : h(Tag, {
      props: {
        // if we have a transition component, pass the tag if it exists
        tag: this.transition && this.tag ? this.tag : undefined
      },
      class: {
        'vue-portal-target': true
      }
    }, children);
  }
});

var _id$1 = 0;
var portalProps = ['disabled', 'name', 'order', 'slim', 'slotProps', 'tag', 'to'];
var targetProps = ['multiple', 'transition'];
var MountingPortal = Vue$1.extend({
  name: 'MountingPortal',
  inheritAttrs: false,
  props: {
    append: {
      type: [Boolean, String]
    },
    bail: {
      type: Boolean
    },
    mountTo: {
      type: String,
      required: true
    },
    // Portal
    disabled: {
      type: Boolean
    },
    // name for the portal
    name: {
      type: String,
      default: function _default() {
        return 'mounted_' + String(_id$1++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    // name for the target
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    },
    // Target
    multiple: {
      type: Boolean,
      default: false
    },
    targetSlim: {
      type: Boolean
    },
    targetSlotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    targetTag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  created: function created() {
    if (typeof document === 'undefined') return;
    var el = document.querySelector(this.mountTo);

    if (!el) {
      console.error("[portal-vue]: Mount Point '".concat(this.mountTo, "' not found in document"));
      return;
    }

    var props = this.$props; // Target already exists

    if (wormhole.targets[props.name]) {
      if (props.bail) {
        console.warn("[portal-vue]: Target ".concat(props.name, " is already mounted.\n        Aborting because 'bail: true' is set"));
      } else {
        this.portalTarget = wormhole.targets[props.name];
      }

      return;
    }

    var append = props.append;

    if (append) {
      var type = typeof append === 'string' ? append : 'DIV';
      var mountEl = document.createElement(type);
      el.appendChild(mountEl);
      el = mountEl;
    } // get props for target from $props
    // we have to rename a few of them


    var _props = pick(this.$props, targetProps);

    _props.slim = this.targetSlim;
    _props.tag = this.targetTag;
    _props.slotProps = this.targetSlotProps;
    _props.name = this.to;
    this.portalTarget = new PortalTarget({
      el: el,
      parent: this.$parent || this,
      propsData: _props
    });
  },
  beforeDestroy: function beforeDestroy() {
    var target = this.portalTarget;

    if (this.append) {
      var el = target.$el;
      el.parentNode.removeChild(el);
    }

    target.$destroy();
  },
  render: function render(h) {
    if (!this.portalTarget) {
      console.warn("[portal-vue] Target wasn't mounted");
      return h();
    } // if there's no "manual" scoped slot, so we create a <Portal> ourselves


    if (!this.$scopedSlots.manual) {
      var props = pick(this.$props, portalProps);
      return h(Portal, {
        props: props,
        attrs: this.$attrs,
        on: this.$listeners,
        scopedSlots: this.$scopedSlots
      }, this.$slots.default);
    } // else, we render the scoped slot


    var content = this.$scopedSlots.manual({
      to: this.to
    }); // if user used <template> for the scoped slot
    // content will be an array

    if (Array.isArray(content)) {
      content = content[0];
    }

    if (!content) return h();
    return content;
  }
});

function install(Vue$$1) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue$$1.component(options.portalName || 'Portal', Portal);
  Vue$$1.component(options.portalTargetName || 'PortalTarget', PortalTarget);
  Vue$$1.component(options.MountingPortalName || 'MountingPortal', MountingPortal);
}

var index = {
  install: install
};

//

var script$2 = defineComponent({
  name: 'Announcer',
  props: {
    routeName: { type: String, default: '' },
  },
  setup (props, { root }) {
    const announcementText = ref('');
    let timeoutId = null;

    const routeAnnouncement = computed(() => {
      if (!props.routeName) {
        return ''
      }

      return `${root.$a11yRouting.options.routeAnnouncement} ${props.routeName}`
    });

    watch(routeAnnouncement, (routeAnnouncementText) => {
      clearTimeout(timeoutId);
      timeoutId = null;
      announcementText.value = routeAnnouncementText;
      // Clear the live region to avoid stale text being available to screen readers.
      timeoutId = setTimeout(() => {
        announcementText.value = '';
      }, 500);
    });

    return { announcementText }
  },
});

/* script */
const __vue_script__$2 = script$2;
/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a11y-announcer",attrs:{"aria-live":"polite","aria-atomic":"true"},domProps:{"textContent":_vm._s(_vm.announcementText)}})};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = "data-v-c7a151ce";
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$1 = defineComponent({
  name: 'Announcer',
  components: { AnnouncerCore: __vue_component__$2 },
  setup (_, { root }) {
    return {
      routeName: computed(() => root.$route.meta.title || root.$route.name || ''),
    }
  },
});

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('announcer-core',{attrs:{"route-name":_vm.routeName}})};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script = defineComponent({
  name: 'SkipLink',
  setup (_, { root }) {
    const focusOnContent = () => {
      root.$a11yRouting.findFocusableAndFocus();
    };
    return { focusOnContent }
  },
});

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"a11y__skiplink",attrs:{"href":"#to-content","id":_vm.$a11yRouting.options.skiplinkId},on:{"click":function($event){$event.preventDefault();return _vm.focusOnContent.apply(null, arguments)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.navigateToContent.apply(null, arguments)}}},[_vm._v("\n  Direct naar inhoud\n")])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-7fe4eb1d";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

const composer = {
    options: {
        focusableIdentifier: 'data-a11y-focusable',
        skiplinkId: 'a11y_skiplink',
        routeAnnouncement: 'Genavigeerd naar',
        fallbackElement: null,
    },
    appointedFocusable: null,
    focusOnElement(el, { wait = 0 } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise(resolve => {
                setTimeout(() => {
                    el.focus();
                    resolve();
                    composer.appointedFocusable = el;
                }, wait);
            });
        });
    },
    findFocusableAndFocus() {
        return __awaiter(this, void 0, void 0, function* () {
            // wait until event cycle finishes and all dom nodes are present
            yield new Promise(resolve => setTimeout(resolve));
            const focusables = document.querySelectorAll(`[${composer.options.focusableIdentifier}]`);
            if (focusables.length) {
                composer.focusOnElement(focusables[0]);
            }
            else if (composer.options.fallbackElement) {
                composer.focusOnElement(composer.options.fallbackElement);
            }
            if (focusables.length > 1) {
                // eslint-disable-next-line
                console.warn(`
        More than one a11y-focusable identifier has been found.
        To avoid confusing behavior only one element should be present OR elements that should not focus on route should have the "ignore" property on true`);
            }
            return focusables[0] || null;
        });
    },
};
function setElementAttributes(el, binding) {
    const expressions = binding.value || {};
    if (expressions.ignore) {
        el.removeAttribute(composer.options.focusableIdentifier);
        el.removeAttribute('tabindex');
        return;
    }
    el.setAttribute(composer.options.focusableIdentifier, 'true');
    if (expressions.dictate) {
        el.setAttribute('aria-label', expressions.dictate);
    }
    const hasTabIndex = el.getAttribute('tabIndex') !== null;
    if (!hasTabIndex) {
        el.setAttribute('tabindex', '-1'); // make programmaticly focussable only
        el.classList.add('outline-none'); // remove outlines
    }
}
function setA11yFocusable(Vue, router) {
    let autoFocus = true;
    if (router) {
        router.beforeEach((to, from, next) => {
            composer.appointedFocusable = null;
            autoFocus = !from.name || (to.meta && to.meta.noRefocus);
            next();
        });
    }
    Vue.directive('a11y-focusable', {
        inserted(el, binding) {
            setElementAttributes(el, binding);
            if (!autoFocus && el) {
                // timeout to give the Announcer component some time to speak first
                composer.focusOnElement(el, { wait: 300 });
            }
        },
        update(el, binding) {
            setElementAttributes(el, binding);
        },
    });
}
var a11yRouting = {
    install(Vue, router) {
        // Globally subscribe a11y components
        Vue.component('A11ySkiplink', __vue_component__);
        Vue.component('A11yAnnouncer', __vue_component__$1);
        setA11yFocusable(Vue, router);
        Vue.directive('a11y-fallback', {
            inserted(el) {
                composer.options.fallbackElement = el;
            },
        });
        Vue.prototype.$a11yRouting = {
            options: composer.options,
            focusOnElement: composer.focusOnElement,
            findFocusableAndFocus: composer.findFocusableAndFocus,
        };
    },
};

const getPickerStart = (startDate, endDate) => {
    let type = '';
    let date = '';
    if (!endDate || isAfter(endDate, today())) {
        type = 'DATE';
        date = toDayjsOrInvalid(today()).format('YYYY-MM');
    }
    else if (toDayjsOrInvalid(startDate).year() === toDayjsOrInvalid(endDate).year()) {
        type = 'MONTH';
        date = toDayjsOrInvalid(startDate).format('YYYY-MM');
    }
    else {
        type = 'YEAR';
        date = toDayjsOrInvalid(startDate).format('YYYY-MM');
    }
    return { type, date };
};

const API_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
function dateFromApi(json) {
    if (json) {
        return json.length === 10 ? toDate(json, null) : new Date(json);
    }
    return null;
}
function dateToApi(date) {
    return date ? dayjs_min(date).format(API_FORMAT) : null;
}

const phoenix = {
    install(Vue, options) {
        options = options || {};
        Vue.use(Vuetify);
        Vue.use(vueSmoothScroll);
        Vue.use(VueI18n$1);
        Vue.use(index);
        Vue.use(a11yRouting, options.router);
        Vue.component('FormRow', __vue_component__$1k);
        Vue.component('PageLayoutStandard', __vue_component__$1c);
        Vue.component('PageLayoutFull', __vue_component__$4);
        Vue.component('PageNotFound', __vue_component__$3);
        Object.keys(components).forEach(componentName => {
            // @ts-ignore
            Vue.component(componentName, components[componentName]);
        });
    },
    getVuetify() {
        // @ts-ignore
        return new Vuetify(vuetifyOptions);
    },
    getVueI18n(settings = {}, fillGlobalI18n) {
        return getI18n(VueI18n$1, settings, fillGlobalI18n);
    },
};

export { DelayedFormInputValidator, LogLevel, __vue_component__$1b as PAlert, __vue_component__$v as PApp, __vue_component__$1f as PButton, __vue_component__$12 as PButtonContainer, __vue_component__$1a as PCard, __vue_component__$l as PCheckbox, __vue_component__$K as PCol, __vue_component__$E as PContactList, __vue_component__$C as PContactListItem, __vue_component__$11 as PContainer, __vue_component__$U as PDataTable, __vue_component__$T as PDataTableButton, __vue_component__$m as PDatePicker, __vue_component__$17 as PDialog, __vue_component__$1j as PDivider, __vue_component__$h as PFieldset, __vue_component__$g as PFieldsetError, __vue_component__$5 as PFieldsetSpacer, __vue_component__$6 as PFieldsetValidationExclude, __vue_component__$b as PFileUpload, __vue_component__$X as PFilters, __vue_component__$R as PFooter, __vue_component__$S as PForm, __vue_component__$k as PGroupValidation, __vue_component__$j as PGroupValidationError, __vue_component__$8 as PGroupValidationExclude, __vue_component__$7 as PGroupValidationSpacer, __vue_component__$H as PHeader, __vue_component__$G as PHeaderButton, __vue_component__$1i as PHeading, __vue_component__$1d as PHelp, __vue_component__$19 as PHelpMobileTrigger, __vue_component__$F as PIcon, __vue_component__$16 as PInfo, __vue_component__$P as PList, __vue_component__$O as PListItem, __vue_component__$N as PListItemContent, __vue_component__$D as PListItemIcon, __vue_component__$M as PListItemTitle, __vue_component__$t as PLoadingIndicator, __vue_component__$u as PMain, __vue_component__$B as PMenu, __vue_component__$s as PNotifyRequiredField, __vue_component__$f as PRadioGroup, __vue_component__$a as PRouterLink, __vue_component__$L as PRow, __vue_component__$Y as PSearch, __vue_component__$9 as PSection, __vue_component__$Z as PSelect, __vue_component__$14 as PStep, __vue_component__$13 as PStepper, __vue_component__$r as PTextField, __vue_component__$q as PTextarea, __vue_component__$18 as PValueGrid, __vue_component__$15 as PValueRow, VueI18n$1 as VueI18n, add, childDateFormat, createHeader, dateFormat, dateFromApi, dateString, dateStringOrEmpty, dateToApi, diff, endOf, errorNotInProd, extractErrorMessage, getPickerStart, getSelectedFilters, invalidDate, invalidDateString, invalidDayjs, isAfter, isBefore, isBetween, isNothingSelected, logDebug, logError, logInfo, logLevel, logTrace, logWarning, monthsBetween, overrideVueI18nD, percentageFormat, phoenix, registerDelayedFormInputValidator, registerStepComponent, registerStepComponentKey, setLogLevel, setupRouteLinkResolver, startOf, subtract, toDate, toDateOrNull, toDayjs, toDayjsOrInvalid, toLocaleString, toStringSave, today, useBreakpoints, useCustomFocus, useHasSlot, useI18n, useIdGenerator, usePAriaLive, usePageDirtyState, useRouteResolver, useRouter, useState, useStepRouter, useWindowPrint };
